import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MongoID: { input: any; output: any; }
  RegExpAsString: { input: any; output: any; }
};

export type AccommodationOperatorMetadata = {
  __typename?: 'AccommodationOperatorMetadata';
  guestRoomQty?: Maybe<Scalars['Float']['output']>;
  shortTermAccommodationLicense?: Maybe<Scalars['String']['output']>;
};

export type AccommodationProductMetadata = {
  __typename?: 'AccommodationProductMetadata';
  amenities: Array<Amenity>;
  calendarLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  closures: Array<Maybe<Closure>>;
  guestMetadata: GuestMetadata;
  maximumNights: Scalars['Int']['output'];
  minimumNights: Scalars['Int']['output'];
  rooms: Array<Maybe<Room>>;
};

export type AccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closures: Array<InputMaybe<ClosureInput>>;
  guestMetadata: GuestMetadataInput;
  maximumNights: Scalars['Int']['input'];
  minimumNights: Scalars['Int']['input'];
  rooms: Array<InputMaybe<RoomInput>>;
};

export type AddPeopleToOperatorResponse = {
  __typename?: 'AddPeopleToOperatorResponse';
  _id?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  location?: Maybe<AddressLocation>;
  postalCode: Scalars['String']['output'];
  subdivision: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  postalCode: Scalars['String']['input'];
  subdivision: Scalars['String']['input'];
};

export type AddressLocation = {
  __typename?: 'AddressLocation';
  coordinates: Array<Maybe<Scalars['Float']['output']>>;
  type: EnumAddressLocationType;
};

export type AddressLocationInput = {
  coordinates: Array<InputMaybe<Scalars['Float']['input']>>;
  type: EnumAddressLocationType;
};

export type Amenity = {
  __typename?: 'Amenity';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  name: NewMultilingual;
  type: EnumAmenityType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type App = {
  __typename?: 'App';
  bundle?: Maybe<Scalars['String']['output']>;
  machineName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type AppMetadataInput = {
  onboarding?: InputMaybe<OnboardingInput>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Booker = {
  __typename?: 'Booker';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  operator?: Maybe<NewOperator>;
  productBundles: Array<Maybe<BookerProductBundles>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type BookerOptions = {
  __typename?: 'BookerOptions';
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<BookerPayment>;
  termsConditions?: Maybe<Scalars['String']['output']>;
};

export type BookerPayment = {
  __typename?: 'BookerPayment';
  applicationPercentage: Scalars['Float']['output'];
  connectedAccountId?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Float']['output']>;
};

export type BookerProductBundles = {
  __typename?: 'BookerProductBundles';
  _id?: Maybe<Scalars['MongoID']['output']>;
  addOns?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  product?: Maybe<Product>;
};

export type BookerProductBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addOns?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  product: Scalars['MongoID']['input'];
};

export type Button = {
  __typename?: 'Button';
  label?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type CalendarLinksByProductId = {
  links: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
};

export type Caption = {
  __typename?: 'Caption';
  en?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type CaptionInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type CartPrices = {
  __typename?: 'CartPrices';
  grandTotal: Scalars['Int']['output'];
  productPrices: Array<PricePerProduct>;
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
};

export type Checklist = {
  __typename?: 'Checklist';
  isYourBusinessDescriptionAccurateAndCompelling?: Maybe<Scalars['Boolean']['output']>;
  tagYourBusiness?: Maybe<Scalars['Boolean']['output']>;
  uploadNewHighResPhotos?: Maybe<Scalars['Boolean']['output']>;
  verifyAllLinks?: Maybe<Scalars['Boolean']['output']>;
  verifyLocation?: Maybe<Scalars['Boolean']['output']>;
  verifyOpeningHours?: Maybe<Scalars['Boolean']['output']>;
};

export type ChecklistInput = {
  isYourBusinessDescriptionAccurateAndCompelling?: InputMaybe<Scalars['Boolean']['input']>;
  tagYourBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  uploadNewHighResPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  verifyAllLinks?: InputMaybe<Scalars['Boolean']['input']>;
  verifyLocation?: InputMaybe<Scalars['Boolean']['input']>;
  verifyOpeningHours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Closure = {
  __typename?: 'Closure';
  _id?: Maybe<Scalars['MongoID']['output']>;
  dateRangeISO: DateRangeIso;
  name: Scalars['String']['output'];
};

export type ClosureData = {
  __typename?: 'ClosureData';
  closure: Closure;
  productIDs: Array<Scalars['String']['output']>;
};

export type ClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO: DateRangeIsoInput;
  name: Scalars['String']['input'];
};

export type Contact = {
  __typename?: 'Contact';
  address: Address;
  email: Scalars['String']['output'];
  links: Links;
  phone: Scalars['String']['output'];
};

export type ContactUsEmailDetails = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type Course = {
  __typename?: 'Course';
  _id: Scalars['MongoID']['output'];
  courseName?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<CourseCoverImage>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  packageType: EnumCoursePackageType;
  packageUrl?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tenantsOf: Array<Maybe<Scalars['String']['output']>>;
  typeformId?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type CourseCoverImage = {
  __typename?: 'CourseCoverImage';
  _id?: Maybe<Scalars['MongoID']['output']>;
  full_url?: Maybe<Scalars['String']['output']>;
};

export type CourseCoverImageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  full_url?: InputMaybe<Scalars['String']['input']>;
};

export type CoursesByFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CoursesByInput = {
  filterBy?: InputMaybe<CoursesByFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEvent = {
  __typename?: 'CreateEvent';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operatorId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateEventInput = {
  name: Scalars['String']['input'];
  operatorId: Scalars['ID']['input'];
  tenantOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOneAmenityInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name: NewMultilingualInput;
  type: EnumAmenityType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneAmenityPayload = {
  __typename?: 'CreateOneAmenityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Amenity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBookerInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  operator: Scalars['MongoID']['input'];
  productBundles?: InputMaybe<Array<InputMaybe<BookerProductBundlesInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneBookerPayload = {
  __typename?: 'CreateOneBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCourseInput = {
  courseName?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<CourseCoverImageInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  packageType: EnumCoursePackageType;
  packageUrl?: InputMaybe<Scalars['String']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeformId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneCoursePayload = {
  __typename?: 'CreateOneCoursePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Course>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInventoryItemInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  metadata: InventoryItemMetadataInput;
  productID: Scalars['MongoID']['input'];
  type: EnumInventoryItemType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneInventoryItemPayload = {
  __typename?: 'CreateOneInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLearnerActivityLogInput = {
  courseId?: InputMaybe<Scalars['MongoID']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  eventType: EnumLearnerActivityLogEventType;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorName?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['MongoID']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneLearnerActivityLogPayload = {
  __typename?: 'CreateOneLearnerActivityLogPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<LearnerActivityLog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneLegacyOperatorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  connections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<NewMultilingualInput>;
  email: Scalars['String']['input'];
  facebook_link?: InputMaybe<Scalars['String']['input']>;
  hours_of_operation_week?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  instagram_link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LegacyOperatorLocationInput>;
  more_information?: InputMaybe<Scalars['String']['input']>;
  open_hours_option?: InputMaybe<Scalars['String']['input']>;
  operator_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest_link?: InputMaybe<Scalars['String']['input']>;
  short_description?: InputMaybe<NewMultilingualInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<LegacyOperatorTagsInput>;
  tiktok_link?: InputMaybe<Scalars['String']['input']>;
  tripadvisor_link?: InputMaybe<Scalars['String']['input']>;
  twitter_link?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  updated_at: Scalars['Float']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  youtube_link?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneLegacyOperatorPayload = {
  __typename?: 'CreateOneLegacyOperatorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<LegacyOperator>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneListInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  listBundle?: InputMaybe<Scalars['String']['input']>;
  operatorData?: InputMaybe<Scalars['MongoID']['input']>;
  operatorId: Scalars['MongoID']['input'];
  organization: Scalars['MongoID']['input'];
  publicationStatus: EnumListPublicationStatus;
  team?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneListPayload = {
  __typename?: 'CreateOneListPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<List>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneMemberInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customStatus?: InputMaybe<Scalars['String']['input']>;
  customTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization: Scalars['MongoID']['input'];
  owner?: InputMaybe<Scalars['JSON']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status: EnumMemberStatus;
  teams: Array<InputMaybe<Scalars['String']['input']>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneMemberPayload = {
  __typename?: 'CreateOneMemberPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Member>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNewImagePayload = {
  __typename?: 'CreateOneNewImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NewImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNewNoteInput = {
  author: Scalars['MongoID']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  member: Scalars['MongoID']['input'];
  mentions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  message: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneNewNotePayload = {
  __typename?: 'CreateOneNewNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NewNote>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNewOccurrenceInput = {
  cancelled: Scalars['Boolean']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  endDateISO: Scalars['String']['input'];
  productID: Scalars['MongoID']['input'];
  startDateISO: Scalars['String']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneNewOccurrencePayload = {
  __typename?: 'CreateOneNewOccurrencePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NewOccurrence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNewOrgInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customTags?: InputMaybe<NewOrgCustomTagsInput>;
  membershipSettings?: InputMaybe<NewOrgMembershipSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneNewOrgPayload = {
  __typename?: 'CreateOneNewOrgPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NewOrg>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNewTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name: NewMultilingualInput;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneNewTagPayload = {
  __typename?: 'CreateOneNewTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NewTag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneOrderPayload = {
  __typename?: 'CreateOneOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type CreateOnePersonInput = {
  accountStatus: EnumPersonAccountStatus;
  address?: InputMaybe<AddressInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  enrolledThrough?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<PersonLearnerInput>;
  tenantsOf?: InputMaybe<Array<InputMaybe<PersonTenantsOfInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePersonPayload = {
  __typename?: 'CreateOnePersonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProductInput = {
  accommodationMetadata?: InputMaybe<AccommodationProductMetadataInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<NewMultilingualInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsellOnly: Scalars['Boolean']['input'];
  name: NewMultilingualInput;
  operator: Scalars['MongoID']['input'];
  pricing: PricingInput;
  publishingStatus: EnumProductPublishingStatus;
  shortDescription?: InputMaybe<NewMultilingualInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  taxRate?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumProductType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProductPayload = {
  __typename?: 'CreateOneProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRefundPayload = {
  __typename?: 'CreateOneRefundPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Refund>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type CreateOneSiteInput = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  lists?: InputMaybe<Array<InputMaybe<SiteListsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  whereaboutsSite?: InputMaybe<SiteWhereaboutsSiteInput>;
};

export type CreateOneSitePayload = {
  __typename?: 'CreateOneSitePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Site>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTsnnRequestInput = {
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<TsnnRequestNoteInput>;
  operatorID: Scalars['MongoID']['input'];
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status: EnumTsnnRequestStatus;
  taskList?: InputMaybe<TsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type: EnumTsnnRequestType;
};

export type CreateOneTsnnRequestPayload = {
  __typename?: 'CreateOneTSNNRequestPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TsnnRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTaxRateInput = {
  country: Scalars['String']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  percentage: Scalars['Float']['input'];
  subdivision: Scalars['String']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTaxRatePayload = {
  __typename?: 'CreateOneTaxRatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TaxRate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOperatorInput = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  line1?: InputMaybe<Scalars['String']['input']>;
  localPhone: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  orgTenantId?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  tollFreePhone: Scalars['String']['input'];
  type: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type CreateOperatorResponse = {
  __typename?: 'CreateOperatorResponse';
  _id: Scalars['ID']['output'];
};

export type CreateUserInput = {
  app_metadata?: InputMaybe<AppMetadataInput>;
  blocked?: InputMaybe<Scalars['String']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  email_verified?: InputMaybe<Scalars['String']['input']>;
  family_name?: InputMaybe<Scalars['String']['input']>;
  given_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_verified?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  verify_email?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomLearnerActivityLogFilter = {
  createdEndDate?: InputMaybe<Scalars['String']['input']>;
  createdStartDate?: InputMaybe<Scalars['String']['input']>;
  hideAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CustomOrderFilter = {
  /** Filter by an array of _ids to match specific orders */
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdEndDate?: InputMaybe<Scalars['String']['input']>;
  createdStartDate?: InputMaybe<Scalars['String']['input']>;
  /** Filter by search term to filter by _id, customerContact.name, or customerContact.email */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerContact = {
  __typename?: 'CustomerContact';
  email: Scalars['String']['output'];
  guests: Array<Maybe<CustomerContactGuests>>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type CustomerContactGuests = {
  __typename?: 'CustomerContactGuests';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
};

export type CustomerContactGuestsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
};

export type CustomerContactInput = {
  email: Scalars['String']['input'];
  guests?: InputMaybe<Array<InputMaybe<CustomerContactGuestsInput>>>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type DateRangeIso = {
  __typename?: 'DateRangeISO';
  _id: Scalars['MongoID']['output'];
  end: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  start: Scalars['String']['output'];
};

export type DateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type DeleteFormResponseInput = {
  _id: Scalars['ID']['input'];
};

export type DeleteFormResponseResponse = {
  __typename?: 'DeleteFormResponseResponse';
  _id: Scalars['ID']['output'];
};

export type EmailResponse = {
  __typename?: 'EmailResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum Entity {
  Event = 'EVENT',
  Operator = 'OPERATOR',
  Product = 'PRODUCT'
}

export enum EnumAddressLocationType {
  Point = 'Point'
}

export enum EnumAmenityType {
  Accommodation = 'ACCOMMODATION',
  RoomSpecific = 'ROOM_SPECIFIC'
}

export enum EnumCoursePackageType {
  Pdf = 'PDF',
  Scorm = 'SCORM',
  Typeform = 'TYPEFORM',
  Xapi = 'XAPI'
}

export enum EnumInventoryItemType {
  Accommodation = 'ACCOMMODATION',
  Event = 'EVENT'
}

export enum EnumLearnerActivityLogEventType {
  Completed = 'COMPLETED',
  Continued = 'CONTINUED',
  Started = 'STARTED',
  Viewed = 'VIEWED'
}

export enum EnumListPublicationStatus {
  ForReview = 'FOR_REVIEW',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum EnumMemberStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum EnumNewOperatorPricing {
  Expensive = 'EXPENSIVE',
  Inexpensive = 'INEXPENSIVE',
  ModeratelyExpensive = 'MODERATELY_EXPENSIVE',
  VeryExpensive = 'VERY_EXPENSIVE'
}

export enum EnumNewOperatorType {
  OpAccommodation = 'OP_ACCOMMODATION',
  OpExperience = 'OP_EXPERIENCE',
  OpRestaurant = 'OP_RESTAURANT',
  OpService = 'OP_SERVICE',
  OpTours = 'OP_TOURS'
}

export enum EnumOpeningSeasonality {
  Closed = 'CLOSED',
  High = 'HIGH',
  Low = 'LOW',
  Null = 'NULL'
}

export enum EnumOpeningSource {
  BookNow = 'BOOK_NOW',
  GoogleMyBusiness = 'GOOGLE_MY_BUSINESS',
  Instagram = 'INSTAGRAM',
  Internal = 'INTERNAL',
  Pinterest = 'PINTEREST',
  Tiktok = 'TIKTOK',
  TripAdvisor = 'TRIP_ADVISOR',
  Twitter = 'TWITTER',
  Website = 'WEBSITE',
  Youtube = 'YOUTUBE'
}

export enum EnumPersonAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  Suspended = 'SUSPENDED'
}

export enum EnumPersonLearnerCoursesStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum EnumPersonTenantsOfRole {
  Invited = 'INVITED',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum EnumPriceTierType {
  Adult = 'ADULT',
  Child = 'CHILD',
  General = 'GENERAL',
  Infant = 'INFANT',
  Pet = 'PET',
  Senior = 'SENIOR'
}

export enum EnumProductPublishingStatus {
  Draft = 'DRAFT',
  NeedsReview = 'NEEDS_REVIEW',
  Published = 'PUBLISHED'
}

export enum EnumProductType {
  Accommodation = 'ACCOMMODATION',
  Event = 'EVENT',
  Fee = 'FEE'
}

export enum EnumRefundStatus {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded'
}

export enum EnumRoomType {
  Bath = 'BATH',
  Bed = 'BED'
}

export enum EnumSiteWhereaboutsSiteSiteTemplate {
  Booker = 'BOOKER'
}

export enum EnumSiteWhereaboutsSiteSiteType {
  NextJs = 'NEXT_JS'
}

export enum EnumStripeOnboardingStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export enum EnumTsnnRequestStatus {
  Archived = 'Archived',
  Completed = 'Completed',
  Declined = 'Declined',
  New = 'New',
  Processing = 'Processing',
  ReadyForProcessing = 'Ready_for_Processing'
}

export enum EnumTsnnRequestType {
  Employer = 'Employer',
  Participant = 'Participant'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Int']['output'];
  customVtcTags?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Multilingual>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<NewImage>>;
  more_info_link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextOccurrence?: Maybe<Occurrence>;
  note?: Maybe<NoteEvent>;
  occurrences?: Maybe<Array<Maybe<Occurrence>>>;
  operator?: Maybe<OperatorEvent>;
  operatorId: Scalars['ID']['output'];
  pricing?: Maybe<Scalars['String']['output']>;
  publishingOption?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Schedule>;
  short_description?: Maybe<Multilingual>;
  status: Scalars['String']['output'];
  submitStatus?: Maybe<EventSubmitStatus>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantOf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['Int']['output'];
};

export type EventDetailsOptions = {
  __typename?: 'EventDetailsOptions';
  customVtcTags?: Maybe<Array<VtcTag>>;
};

export enum EventGroupByPeriodStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Past = 'PAST',
  Review = 'REVIEW',
  SearchAll = 'SEARCH_ALL',
  Unpublished = 'UNPUBLISHED',
  Upcoming = 'UPCOMING'
}

export type EventImageMetadata = {
  colors?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  faces?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>>>;
  hasFaces?: InputMaybe<Scalars['Boolean']['input']>;
  hasText?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  quality_analysis?: InputMaybe<QualityAnalysis>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum EventSubmitStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Review = 'REVIEW',
  SearchAll = 'SEARCH_ALL',
  Unpublished = 'UNPUBLISHED'
}

export type EventsPeriod = {
  __typename?: 'EventsPeriod';
  events: Array<Event>;
  month?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ExperienceOperatorMetadata = {
  __typename?: 'ExperienceOperatorMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type FilterCountMemberInput = {
  AND?: InputMaybe<Array<FilterCountMemberInput>>;
  OR?: InputMaybe<Array<FilterCountMemberInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountMemberOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customStatus?: InputMaybe<Scalars['String']['input']>;
  customTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  owner?: InputMaybe<Scalars['JSON']['input']>;
  /** Search by members with search string */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Count members with staff */
  staff?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EnumMemberStatus>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountMemberOperatorsInput = {
  _id?: InputMaybe<FilterCountMember_IdOperatorsInput>;
};

export type FilterCountMember_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountTsnnRequestInput = {
  AND?: InputMaybe<Array<FilterCountTsnnRequestInput>>;
  OR?: InputMaybe<Array<FilterCountTsnnRequestInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountTsnnRequestOperatorsInput>;
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<FilterCountTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<FilterCountTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type FilterCountTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountTsnnRequestOperatorsInput = {
  _id?: InputMaybe<FilterCountTsnnRequest_IdOperatorsInput>;
};

export type FilterCountTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountTsnnRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closures?: InputMaybe<Array<InputMaybe<FilterFindManyClosureInput>>>;
  guestMetadata?: InputMaybe<FilterFindManyGuestMetadataInput>;
  maximumNights?: InputMaybe<Scalars['Int']['input']>;
  minimumNights?: InputMaybe<Scalars['Int']['input']>;
  rooms?: InputMaybe<Array<InputMaybe<FilterFindManyRoomInput>>>;
};

export type FilterFindManyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterFindManyAddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type FilterFindManyAmenityInput = {
  AND?: InputMaybe<Array<FilterFindManyAmenityInput>>;
  OR?: InputMaybe<Array<FilterFindManyAmenityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAmenityOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<FilterFindManyNewMultilingualInput>;
  type?: InputMaybe<EnumAmenityType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAmenityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAmenity_IdOperatorsInput>;
};

export type FilterFindManyAmenity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBookerInput = {
  AND?: InputMaybe<Array<FilterFindManyBookerInput>>;
  OR?: InputMaybe<Array<FilterFindManyBookerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBookerOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  productBundles?: InputMaybe<Array<InputMaybe<FilterFindManyBookerProductBundlesInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBookerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBooker_IdOperatorsInput>;
};

export type FilterFindManyBookerOptionsInput = {
  cancellationPolicy?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<FilterFindManyBookerPaymentInput>;
  termsConditions?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyBookerPaymentInput = {
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBookerProductBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addOns?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBooker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContactInput = {
  address?: InputMaybe<FilterFindManyAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<FilterFindManyLinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCourseCoverImageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  full_url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCourseInput = {
  AND?: InputMaybe<Array<FilterFindManyCourseInput>>;
  OR?: InputMaybe<Array<FilterFindManyCourseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCourseOperatorsInput>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<FilterFindManyCourseCoverImageInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<EnumCoursePackageType>;
  packageUrl?: InputMaybe<Scalars['String']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeformId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCourseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCourse_IdOperatorsInput>;
};

export type FilterFindManyCourse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCustomerContactGuestsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCustomerContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  guests?: InputMaybe<Array<InputMaybe<FilterFindManyCustomerContactGuestsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyGuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  nameEntryRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyInventoryItemInput = {
  AND?: InputMaybe<Array<FilterFindManyInventoryItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyInventoryItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInventoryItemOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<FilterFindManyInventoryItemMetadataInput>;
  productID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumInventoryItemType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyInventoryItemMetadataInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<FilterFindManyDateRangeIsoInput>>>;
  occurrence?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInventoryItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInventoryItem_IdOperatorsInput>;
};

export type FilterFindManyInventoryItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLearnerActivityLogInput = {
  AND?: InputMaybe<Array<FilterFindManyLearnerActivityLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyLearnerActivityLogInput>>;
  _custom?: InputMaybe<CustomLearnerActivityLogFilter>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLearnerActivityLogOperatorsInput>;
  courseId?: InputMaybe<Scalars['MongoID']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  eventType?: InputMaybe<EnumLearnerActivityLogEventType>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorName?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['MongoID']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLearnerActivityLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLearnerActivityLog_IdOperatorsInput>;
};

export type FilterFindManyLearnerActivityLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLegacyOperatorHours_Of_Operation_WeekInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fri?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput>;
  mon?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput>;
  sat?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput>;
  sun?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput>;
  thu?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput>;
  tue?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput>;
  wed?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput>;
};

export type FilterFindManyLegacyOperatorHours_Of_Operation_WeekSunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLegacyOperatorInput = {
  AND?: InputMaybe<Array<FilterFindManyLegacyOperatorInput>>;
  OR?: InputMaybe<Array<FilterFindManyLegacyOperatorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLegacyOperatorOperatorsInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  connections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyNewMultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook_link?: InputMaybe<Scalars['String']['input']>;
  hours_of_operation_week?: InputMaybe<FilterFindManyLegacyOperatorHours_Of_Operation_WeekInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  instagram_link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<FilterFindManyLegacyOperatorLocationInput>;
  more_information?: InputMaybe<Scalars['String']['input']>;
  open_hours_option?: InputMaybe<Scalars['String']['input']>;
  operator_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest_link?: InputMaybe<Scalars['String']['input']>;
  short_description?: InputMaybe<FilterFindManyNewMultilingualInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<FilterFindManyLegacyOperatorTagsInput>;
  tiktok_link?: InputMaybe<Scalars['String']['input']>;
  tripadvisor_link?: InputMaybe<Scalars['String']['input']>;
  twitter_link?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  updated_at?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube_link?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLegacyOperatorLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLegacyOperatorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLegacyOperator_IdOperatorsInput>;
};

export type FilterFindManyLegacyOperatorTagsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accreditations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  capacity?: InputMaybe<Scalars['Float']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_of_operator?: InputMaybe<Scalars['String']['input']>;
  vtc_custom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyLegacyOperator_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLinksInput = {
  bookNow?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  tripAdvisor?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyListInput = {
  AND?: InputMaybe<Array<FilterFindManyListInput>>;
  OR?: InputMaybe<Array<FilterFindManyListInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyListOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  listBundle?: InputMaybe<Scalars['String']['input']>;
  operatorData?: InputMaybe<Scalars['MongoID']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  publicationStatus?: InputMaybe<EnumListPublicationStatus>;
  /** Search lists with search string */
  search?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyListOperatorsInput = {
  _id?: InputMaybe<FilterFindManyList_IdOperatorsInput>;
};

export type FilterFindManyList_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMemberInput = {
  AND?: InputMaybe<Array<FilterFindManyMemberInput>>;
  OR?: InputMaybe<Array<FilterFindManyMemberInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyMemberOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customStatus?: InputMaybe<Scalars['String']['input']>;
  customTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  /** Search by members with staff */
  existingStaff?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  owner?: InputMaybe<Scalars['JSON']['input']>;
  /** Search by members with search string */
  search?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<EnumMemberStatus>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyMemberOperatorsInput = {
  _id?: InputMaybe<FilterFindManyMember_IdOperatorsInput>;
};

export type FilterFindManyMember_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNewMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNewNoteInput = {
  AND?: InputMaybe<Array<FilterFindManyNewNoteInput>>;
  OR?: InputMaybe<Array<FilterFindManyNewNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNewNoteOperatorsInput>;
  author?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  member?: InputMaybe<Scalars['MongoID']['input']>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNewNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNewNote_IdOperatorsInput>;
};

export type FilterFindManyNewNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNewOccurrenceInput = {
  AND?: InputMaybe<Array<FilterFindManyNewOccurrenceInput>>;
  OR?: InputMaybe<Array<FilterFindManyNewOccurrenceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNewOccurrenceOperatorsInput>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  endDateISO?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['MongoID']['input']>;
  startDateISO?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNewOccurrenceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNewOccurrence_IdOperatorsInput>;
};

export type FilterFindManyNewOccurrence_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNewOperatorInput = {
  AND?: InputMaybe<Array<FilterFindManyNewOperatorInput>>;
  OR?: InputMaybe<Array<FilterFindManyNewOperatorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNewOperatorOperatorsInput>;
  accommodationMetadata?: InputMaybe<FilterFindManyAccommodationOperatorMetadataInput>;
  bookerOptions?: InputMaybe<FilterFindManyBookerOptionsInput>;
  contact?: InputMaybe<FilterFindManyContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyNewMultilingualInput>;
  experienceMetadata?: InputMaybe<FilterFindManyExperienceOperatorMetadataInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening?: InputMaybe<FilterFindManyOpeningInput>;
  pricing?: InputMaybe<EnumNewOperatorPricing>;
  restaurantMetadata?: InputMaybe<FilterFindManyRestaurantOperatorMetadataInput>;
  serviceMetadata?: InputMaybe<FilterFindManyServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<FilterFindManyNewMultilingualInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toursMetadata?: InputMaybe<FilterFindManyToursOperatorMetadataInput>;
  type?: InputMaybe<EnumNewOperatorType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNewOperatorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNewOperator_IdOperatorsInput>;
};

export type FilterFindManyNewOperator_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNewOrgCustomTagsInput = {
  memberTags?: InputMaybe<Array<InputMaybe<FilterFindManyNewOrgCustomTagsNoteTagsInput>>>;
  noteTags?: InputMaybe<Array<InputMaybe<FilterFindManyNewOrgCustomTagsNoteTagsInput>>>;
};

export type FilterFindManyNewOrgCustomTagsNoteTagsInput = {
  _id: Scalars['MongoID']['input'];
  name: NewMultilingualInput;
};

export type FilterFindManyNewOrgInput = {
  AND?: InputMaybe<Array<FilterFindManyNewOrgInput>>;
  OR?: InputMaybe<Array<FilterFindManyNewOrgInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNewOrgOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customTags?: InputMaybe<FilterFindManyNewOrgCustomTagsInput>;
  membershipSettings?: InputMaybe<FilterFindManyNewOrgMembershipSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyNewOrgMembershipSettingsCustomViewsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchField?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyNewOrgMembershipSettingsDuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<InputMaybe<FilterFindManyNewOrgMembershipSettingsDuesTiersInput>>>;
};

export type FilterFindManyNewOrgMembershipSettingsDuesTiersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNewOrgMembershipSettingsInput = {
  customViews?: InputMaybe<Array<InputMaybe<FilterFindManyNewOrgMembershipSettingsCustomViewsInput>>>;
  dues?: InputMaybe<FilterFindManyNewOrgMembershipSettingsDuesInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNewOrgOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNewOrg_IdOperatorsInput>;
};

export type FilterFindManyNewOrg_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNewTagInput = {
  AND?: InputMaybe<Array<FilterFindManyNewTagInput>>;
  OR?: InputMaybe<Array<FilterFindManyNewTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNewTagOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<FilterFindManyNewMultilingualInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNewTagOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNewTag_IdOperatorsInput>;
};

export type FilterFindManyNewTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOpeningInput = {
  hoursOfOperation?: InputMaybe<Array<InputMaybe<FilterFindManyDateRangeIsoInput>>>;
  seasonality?: InputMaybe<Array<InputMaybe<EnumOpeningSeasonality>>>;
  source?: InputMaybe<EnumOpeningSource>;
};

export type FilterFindManyOrderInput = {
  AND?: InputMaybe<Array<FilterFindManyOrderInput>>;
  OR?: InputMaybe<Array<FilterFindManyOrderInput>>;
  _custom?: InputMaybe<CustomOrderFilter>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrderOperatorsInput>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customerContact?: InputMaybe<FilterFindManyCustomerContactInput>;
  purchasedProducts?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductInput>>>;
  source?: InputMaybe<FilterFindManyOrderSourceInput>;
  stripeMetadata?: InputMaybe<FilterFindManyStripeMetadataInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrderOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrder_IdOperatorsInput>;
};

export type FilterFindManyOrderSourceInput = {
  bookerID?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrder_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPersonInput = {
  AND?: InputMaybe<Array<FilterFindManyPersonInput>>;
  OR?: InputMaybe<Array<FilterFindManyPersonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPersonOperatorsInput>;
  accountStatus?: InputMaybe<EnumPersonAccountStatus>;
  address?: InputMaybe<FilterFindManyAddressInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolledThrough?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<FilterFindManyPersonLearnerInput>;
  tenantsOf?: InputMaybe<Array<InputMaybe<FilterFindManyPersonTenantsOfInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPersonLearnerCoursesInput = {
  completedDate?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  lastAccessDate?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumPersonLearnerCoursesStatus>;
  suspendData?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyPersonLearnerInput = {
  courses?: InputMaybe<Array<InputMaybe<FilterFindManyPersonLearnerCoursesInput>>>;
  stats?: InputMaybe<FilterFindManyPersonLearnerStatsInput>;
};

export type FilterFindManyPersonLearnerStatsInput = {
  startDate?: InputMaybe<Scalars['String']['input']>;
  totalCoursesCompleted?: InputMaybe<Scalars['Float']['input']>;
  totalCoursesStarted?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPersonOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPerson_IdOperatorsInput>;
};

export type FilterFindManyPersonTenantsOfInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorRef?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<EnumPersonTenantsOfRole>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyPerson_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<FilterFindManyNewMultilingualInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumPriceTierType>;
};

export type FilterFindManyPricingInput = {
  description?: InputMaybe<FilterFindManyNewMultilingualInput>;
  tiers?: InputMaybe<Array<InputMaybe<FilterFindManyPriceTierInput>>>;
};

export type FilterFindManyProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<FilterFindManyAccommodationProductMetadataInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyNewMultilingualInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsellOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyNewMultilingualInput>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  pricing?: InputMaybe<FilterFindManyPricingInput>;
  publishingStatus?: InputMaybe<EnumProductPublishingStatus>;
  shortDescription?: InputMaybe<FilterFindManyNewMultilingualInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  taxRate?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumProductType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPurchasedProductGuestsPerTierInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  tierId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPurchasedProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  guestsPerTier?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductGuestsPerTierInput>>>;
  inventoryClaims?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductInventoryClaimsInput>>>;
  product?: InputMaybe<FilterFindManyProductInput>;
};

export type FilterFindManyPurchasedProductInventoryClaimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  claimedDateRangeISO?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  inventoryID?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyRefundInput = {
  AND?: InputMaybe<Array<FilterFindManyRefundInput>>;
  OR?: InputMaybe<Array<FilterFindManyRefundInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRefundOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  orderID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRefundStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRefundOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRefund_IdOperatorsInput>;
};

export type FilterFindManyRefund_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumRoomType>;
};

export type FilterFindManyServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManySiteInput = {
  AND?: InputMaybe<Array<FilterFindManySiteInput>>;
  OR?: InputMaybe<Array<FilterFindManySiteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySiteOperatorsInput>;
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  lists?: InputMaybe<Array<InputMaybe<FilterFindManySiteListsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  whereaboutsSite?: InputMaybe<FilterFindManySiteWhereaboutsSiteInput>;
};

export type FilterFindManySiteListsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySiteOperatorsInput = {
  _id?: InputMaybe<FilterFindManySite_IdOperatorsInput>;
};

export type FilterFindManySiteWhereaboutsSiteInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  siteTemplate?: InputMaybe<EnumSiteWhereaboutsSiteSiteTemplate>;
  siteType?: InputMaybe<EnumSiteWhereaboutsSiteSiteType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySite_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStripeMetadataInput = {
  chargeID?: InputMaybe<Scalars['String']['input']>;
  customerID?: InputMaybe<Scalars['String']['input']>;
  invoiceID?: InputMaybe<Scalars['String']['input']>;
  paymentMethodID?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyTsnnRequestInput = {
  AND?: InputMaybe<Array<FilterFindManyTsnnRequestInput>>;
  OR?: InputMaybe<Array<FilterFindManyTsnnRequestInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTsnnRequestOperatorsInput>;
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<FilterFindManyTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  /** Search by name */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<FilterFindManyTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type FilterFindManyTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTsnnRequestOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTsnnRequest_IdOperatorsInput>;
};

export type FilterFindManyTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyTsnnRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTaxRateInput = {
  AND?: InputMaybe<Array<FilterFindManyTaxRateInput>>;
  OR?: InputMaybe<Array<FilterFindManyTaxRateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTaxRateOperatorsInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTaxRateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTaxRate_IdOperatorsInput>;
};

export type FilterFindManyTaxRate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneNewOrgCustomTagsInput = {
  memberTags?: InputMaybe<Array<InputMaybe<FilterFindOneNewOrgCustomTagsNoteTagsInput>>>;
  noteTags?: InputMaybe<Array<InputMaybe<FilterFindOneNewOrgCustomTagsNoteTagsInput>>>;
};

export type FilterFindOneNewOrgCustomTagsNoteTagsInput = {
  _id: Scalars['MongoID']['input'];
  name: NewMultilingualInput;
};

export type FilterFindOneNewOrgInput = {
  AND?: InputMaybe<Array<FilterFindOneNewOrgInput>>;
  OR?: InputMaybe<Array<FilterFindOneNewOrgInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNewOrgOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customTags?: InputMaybe<FilterFindOneNewOrgCustomTagsInput>;
  membershipSettings?: InputMaybe<FilterFindOneNewOrgMembershipSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOneNewOrgMembershipSettingsCustomViewsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchField?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneNewOrgMembershipSettingsDuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<InputMaybe<FilterFindOneNewOrgMembershipSettingsDuesTiersInput>>>;
};

export type FilterFindOneNewOrgMembershipSettingsDuesTiersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneNewOrgMembershipSettingsInput = {
  customViews?: InputMaybe<Array<InputMaybe<FilterFindOneNewOrgMembershipSettingsCustomViewsInput>>>;
  dues?: InputMaybe<FilterFindOneNewOrgMembershipSettingsDuesInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNewOrgOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNewOrg_IdOperatorsInput>;
};

export type FilterFindOneNewOrg_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTsnnRequestInput = {
  AND?: InputMaybe<Array<FilterFindOneTsnnRequestInput>>;
  OR?: InputMaybe<Array<FilterFindOneTsnnRequestInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTsnnRequestOperatorsInput>;
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<FilterFindOneTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<FilterFindOneTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type FilterFindOneTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTsnnRequestOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTsnnRequest_IdOperatorsInput>;
};

export type FilterFindOneTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneTsnnRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterMembersGroupByOwnerInput = {
  customStatus?: InputMaybe<Scalars['String']['input']>;
  customTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EnumMemberStatus>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterRemoveOneNewImageColorsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  predominance?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterRemoveOneNewImageInput = {
  AND?: InputMaybe<Array<FilterRemoveOneNewImageInput>>;
  OR?: InputMaybe<Array<FilterRemoveOneNewImageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveOneNewImageOperatorsInput>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<FilterRemoveOneNewMultilingualInput>;
  colors?: InputMaybe<Array<InputMaybe<FilterRemoveOneNewImageColorsInput>>>;
  /**
   * Currently, our schema only supports facial and text detection, using the built-in Cloudinary AI Content Analysis face detection, and the `cld-text` model. Therefore, the fields returned in `detectedObjects` will be limited to *optional* `humanFace` and `text` fields which are of `IDetectedObject[]` type.
   *
   * &nbsp;
   *
   * `IDetectedObject` contains a `boundingBox` array of `numbers`, a `categories` array of `string`s, and a `number` `confidence` value.
   *
   * &nbsp;
   *
   * ```json
   * interface IDetectedObject extends Document {
   *   boundingBox: number[];
   *   categories: string[];
   *   confidence: number;
   * }
   * ```
   */
  detectedObjects?: InputMaybe<Scalars['JSON']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveOneNewImageOperatorsInput = {
  _id?: InputMaybe<FilterRemoveOneNewImage_IdOperatorsInput>;
};

export type FilterRemoveOneNewImage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveOneNewMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type FilterRemoveOneTsnnRequestInput = {
  AND?: InputMaybe<Array<FilterRemoveOneTsnnRequestInput>>;
  OR?: InputMaybe<Array<FilterRemoveOneTsnnRequestInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveOneTsnnRequestOperatorsInput>;
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<FilterRemoveOneTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<FilterRemoveOneTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type FilterRemoveOneTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveOneTsnnRequestOperatorsInput = {
  _id?: InputMaybe<FilterRemoveOneTsnnRequest_IdOperatorsInput>;
};

export type FilterRemoveOneTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterRemoveOneTsnnRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyTsnnRequestInput = {
  AND?: InputMaybe<Array<FilterUpdateManyTsnnRequestInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyTsnnRequestInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyTsnnRequestOperatorsInput>;
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<FilterUpdateManyTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<FilterUpdateManyTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type FilterUpdateManyTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyTsnnRequestOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyTsnnRequest_IdOperatorsInput>;
};

export type FilterUpdateManyTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyTsnnRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneTsnnRequestInput = {
  AND?: InputMaybe<Array<FilterUpdateOneTsnnRequestInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneTsnnRequestInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneTsnnRequestOperatorsInput>;
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<FilterUpdateOneTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<FilterUpdateOneTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type FilterUpdateOneTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneTsnnRequestOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneTsnnRequest_IdOperatorsInput>;
};

export type FilterUpdateOneTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneTsnnRequest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FormResponse = {
  __typename?: 'FormResponse';
  _id?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  linkedID?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requestBody?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GetEventQuery = {
  __typename?: 'GetEventQuery';
  getEvent?: Maybe<Event>;
};

export type GetEventVariables = {
  __typename?: 'GetEventVariables';
  _id: Scalars['ID']['output'];
};

export type GetEventsFilterByInput = {
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<GetEventsFilterByScheduleInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  submitStatus?: InputMaybe<EventSubmitStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetEventsFilterByScheduleInput = {
  endDateTime: Scalars['String']['input'];
  scheduleType?: InputMaybe<ScheduleType>;
  startDateTime: Scalars['String']['input'];
};

export type GetEventsGroupByPeriodFilterByInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status: EventGroupByPeriodStatus;
  tenantOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetEventsGroupByPeriodInput = {
  filterBy?: InputMaybe<GetEventsGroupByPeriodFilterByInput>;
  groupBy?: InputMaybe<TimePeriod>;
};

export type GetEventsGroupByPeriodResponse = {
  __typename?: 'GetEventsGroupByPeriodResponse';
  count: Scalars['Int']['output'];
  periods: Array<EventsPeriod>;
};

export type GetEventsInput = {
  filterBy?: InputMaybe<GetEventsFilterByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type GetFromResponseResponse = {
  __typename?: 'GetFromResponseResponse';
  data: Array<FormResponse>;
  total: Scalars['Int']['output'];
};

export type GetOperatorsByIdInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type GetOperatorsByProximityInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
};

export type GetOperatorsResponse = {
  __typename?: 'GetOperatorsResponse';
  data: Array<Operator>;
  total: Scalars['Int']['output'];
};

export type GetUserStatusResponse = {
  __typename?: 'GetUserStatusResponse';
  account?: Maybe<Scalars['Boolean']['output']>;
  claimed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
};

export type GuestMetadata = {
  __typename?: 'GuestMetadata';
  maximumNumber?: Maybe<Scalars['Float']['output']>;
  minimumNumber?: Maybe<Scalars['Float']['output']>;
  nameEntryAllowed: Scalars['Boolean']['output'];
  nameEntryRequired: Scalars['Boolean']['output'];
};

export type GuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed: Scalars['Boolean']['input'];
  nameEntryRequired: Scalars['Boolean']['input'];
};

export type Hours = {
  __typename?: 'Hours';
  from?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type HoursInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type HoursOfOperation = {
  __typename?: 'HoursOfOperation';
  fri?: Maybe<Hours>;
  mon?: Maybe<Hours>;
  sat?: Maybe<Hours>;
  sun?: Maybe<Hours>;
  thu?: Maybe<Hours>;
  tue?: Maybe<Hours>;
  wed?: Maybe<Hours>;
};

export type HoursOfOperationInput = {
  fri?: InputMaybe<HoursInput>;
  mon?: InputMaybe<HoursInput>;
  sat?: InputMaybe<HoursInput>;
  sun?: InputMaybe<HoursInput>;
  thu?: InputMaybe<HoursInput>;
  tue?: InputMaybe<HoursInput>;
  wed?: InputMaybe<HoursInput>;
};

export type Image = {
  __typename?: 'Image';
  _id?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Caption>;
  full_url?: Maybe<Scalars['String']['output']>;
  teaser_url?: Maybe<Scalars['String']['output']>;
  teaser_url_x2?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  thumbnail_url_x2?: Maybe<Scalars['String']['output']>;
};

export type ImageInput = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<CaptionInput>;
  full_url: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  teaser_url?: InputMaybe<Scalars['String']['input']>;
  teaser_url_x2?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_x2?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrateCalendarLinksByProductIds = {
  __typename?: 'IntegrateCalendarLinksByProductIds';
  products: Array<Product>;
  releasedInventoryClaimItems: Array<InventoryItem>;
  updatedInventoryClaimItems: Array<InventoryItem>;
};

export type InventoryBookedDatesSummary = {
  __typename?: 'InventoryBookedDatesSummary';
  bookedDatesISO: Array<Scalars['String']['output']>;
  checkOutOnlyDatesISO: Array<Scalars['String']['output']>;
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  metadata: InventoryItemMetadata;
  productID: Scalars['MongoID']['output'];
  type: EnumInventoryItemType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type InventoryItemMetadata = {
  __typename?: 'InventoryItemMetadata';
  available?: Maybe<Scalars['Boolean']['output']>;
  claimedDateRangesISO?: Maybe<Array<Maybe<DateRangeIso>>>;
  occurrence?: Maybe<Scalars['MongoID']['output']>;
};

export type InventoryItemMetadataInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<DateRangeIsoInput>>>;
  occurrence?: InputMaybe<Scalars['MongoID']['input']>;
};

export type LearnerActivityLog = {
  __typename?: 'LearnerActivityLog';
  _id: Scalars['MongoID']['output'];
  courseId?: Maybe<Scalars['MongoID']['output']>;
  courseName?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  eventType: EnumLearnerActivityLogEventType;
  operatorId?: Maybe<Scalars['MongoID']['output']>;
  operatorName?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['MongoID']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  tenantsOf: Array<Maybe<Scalars['String']['output']>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type LearnerActivityLogFindMany = {
  __typename?: 'LearnerActivityLogFindMany';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<LearnerActivityLog>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type LegacyOperator = {
  __typename?: 'LegacyOperator';
  _id: Scalars['MongoID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  connections: Array<Maybe<Scalars['String']['output']>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<NewMultilingual>;
  email: Scalars['String']['output'];
  facebook_link?: Maybe<Scalars['String']['output']>;
  hours_of_operation_week?: Maybe<LegacyOperatorHours_Of_Operation_Week>;
  images: Array<NewImage>;
  instagram_link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LegacyOperatorLocation>;
  more_information?: Maybe<Scalars['String']['output']>;
  open_hours_option?: Maybe<Scalars['String']['output']>;
  operator_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pinterest_link?: Maybe<Scalars['String']['output']>;
  short_description?: Maybe<NewMultilingual>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<LegacyOperatorTags>;
  tiktok_link?: Maybe<Scalars['String']['output']>;
  tripadvisor_link?: Maybe<Scalars['String']['output']>;
  twitter_link?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  updated_at: Scalars['Float']['output'];
  website?: Maybe<Scalars['String']['output']>;
  youtube_link?: Maybe<Scalars['String']['output']>;
};

export type LegacyOperatorHours_Of_Operation_Week = {
  __typename?: 'LegacyOperatorHours_of_operation_week';
  _id?: Maybe<Scalars['MongoID']['output']>;
  fri?: Maybe<LegacyOperatorHours_Of_Operation_WeekSun>;
  mon?: Maybe<LegacyOperatorHours_Of_Operation_WeekSun>;
  sat?: Maybe<LegacyOperatorHours_Of_Operation_WeekSun>;
  sun?: Maybe<LegacyOperatorHours_Of_Operation_WeekSun>;
  thu?: Maybe<LegacyOperatorHours_Of_Operation_WeekSun>;
  tue?: Maybe<LegacyOperatorHours_Of_Operation_WeekSun>;
  wed?: Maybe<LegacyOperatorHours_Of_Operation_WeekSun>;
};

export type LegacyOperatorHours_Of_Operation_WeekInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fri?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekSunInput>;
  mon?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekSunInput>;
  sat?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekSunInput>;
  sun?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekSunInput>;
  thu?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekSunInput>;
  tue?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekSunInput>;
  wed?: InputMaybe<LegacyOperatorHours_Of_Operation_WeekSunInput>;
};

export type LegacyOperatorHours_Of_Operation_WeekSun = {
  __typename?: 'LegacyOperatorHours_of_operation_weekSun';
  _id?: Maybe<Scalars['MongoID']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type LegacyOperatorHours_Of_Operation_WeekSunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyOperatorLocation = {
  __typename?: 'LegacyOperatorLocation';
  _id?: Maybe<Scalars['MongoID']['output']>;
  coordinates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LegacyOperatorLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyOperatorTags = {
  __typename?: 'LegacyOperatorTags';
  _id?: Maybe<Scalars['MongoID']['output']>;
  accreditations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  capacity?: Maybe<Scalars['Float']['output']>;
  pricing?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type_of_operator?: Maybe<Scalars['String']['output']>;
  vtc_custom?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LegacyOperatorTagsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accreditations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  capacity?: InputMaybe<Scalars['Float']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_of_operator?: InputMaybe<Scalars['String']['input']>;
  vtc_custom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Links = {
  __typename?: 'Links';
  bookNow?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  googleMyBusiness?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  tripAdvisor?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type List = {
  __typename?: 'List';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  listBundle?: Maybe<Scalars['String']['output']>;
  operatorData?: Maybe<LegacyOperator>;
  operatorId: Scalars['MongoID']['output'];
  organization?: Maybe<NewOrg>;
  publicationStatus: EnumListPublicationStatus;
  team: Array<Maybe<Scalars['String']['output']>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type MaintenanceData = {
  __typename?: 'MaintenanceData';
  isLive?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceMode = {
  __typename?: 'MaintenanceMode';
  banner?: Maybe<MaintenanceData>;
  doorstop?: Maybe<MaintenanceData>;
};

export type Member = {
  __typename?: 'Member';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customStatus?: Maybe<Scalars['String']['output']>;
  customTags: Array<NewTag>;
  notes: Array<Maybe<Scalars['MongoID']['output']>>;
  operator?: Maybe<LegacyOperator>;
  organization?: Maybe<NewOrg>;
  owner?: Maybe<Person>;
  staff: Array<Person>;
  status: EnumMemberStatus;
  teams: Array<Maybe<Scalars['String']['output']>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type MembersGroupByOwner = {
  __typename?: 'MembersGroupByOwner';
  count: Scalars['Int']['output'];
  groups?: Maybe<Array<Maybe<MembersGroupByOwnerGroup>>>;
};

export type MembersGroupByOwnerGroup = {
  __typename?: 'MembersGroupByOwnerGroup';
  members: Array<Member>;
  uuid: Scalars['String']['output'];
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Multilingual = {
  __typename?: 'Multilingual';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type MultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPeopleToOperator: AddPeopleToOperatorResponse;
  addProfileIdToUser?: Maybe<User>;
  addUserToTenant?: Maybe<Tenant>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  amenityCreate?: Maybe<CreateOneAmenityPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  amenityRemove?: Maybe<RemoveByIdAmenityPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  amenityUpdate?: Maybe<UpdateByIdAmenityPayload>;
  analyzeLearnerReport: SummaryResponse;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  bookerCreate?: Maybe<CreateOneBookerPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  bookerRemove?: Maybe<RemoveByIdBookerPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  bookerUpdate?: Maybe<UpdateByIdBookerPayload>;
  cancelAllEventOccurrences: CancelAllEventOccurrencesResponse;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  courseCreate?: Maybe<CreateOneCoursePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  courseRemove?: Maybe<RemoveByIdCoursePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  courseUpdate?: Maybe<UpdateByIdCoursePayload>;
  createClosuresPerProduct: Array<Scalars['ID']['output']>;
  createEvent: CreateEvent;
  createEventImage: CreateEventImageResponse;
  createNotification?: Maybe<Notification>;
  createOperator: CreateOperatorResponse;
  createOperatorImage: CreateOperatorImageResponse;
  createReport?: Maybe<Report>;
  createTenant?: Maybe<Tenant>;
  createUser: CreateUserResponse;
  deleteEvent: DeleteEventResponse;
  deleteEventImage: DeleteEventImageResponse;
  deleteEventOccurrence: Event;
  deleteFormResponse: DeleteFormResponseResponse;
  deleteImage?: Maybe<Image>;
  deleteOperator: DeleteOperatorResponse;
  generateOperatorOTP: GenerateOperatorOtpResponse;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  imageCreate?: Maybe<CreateOneNewImagePayload>;
  /** Remove one document: 1) Remove with hooks via findOneAndRemove. 2) Return removed document. */
  imageRemove?: Maybe<RemoveOneNewImagePayload>;
  imageSortOrder: Array<Maybe<Scalars['MongoID']['output']>>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  imageUpdate?: Maybe<UpdateByIdNewImagePayload>;
  integrateProductCalendarLinksByProductIds: IntegrateCalendarLinksByProductIds;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  inventoryCreate?: Maybe<CreateOneInventoryItemPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  inventoryRemove?: Maybe<RemoveByIdInventoryItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  inventoryUpdate?: Maybe<UpdateByIdInventoryItemPayload>;
  inventoryUpdateClaimedDatesByOrder?: Maybe<Order>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  learnerActivityLogCreate?: Maybe<CreateOneLearnerActivityLogPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  learnerActivityLogRemove?: Maybe<RemoveByIdLearnerActivityLogPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  learnerActivityLogUpdate?: Maybe<UpdateByIdLearnerActivityLogPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  legacyOperatorCreate?: Maybe<CreateOneLegacyOperatorPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  legacyOperatorRemove?: Maybe<RemoveByIdLegacyOperatorPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  legacyOperatorUpdate?: Maybe<UpdateByIdLegacyOperatorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  listCreate?: Maybe<CreateOneListPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  listRemove?: Maybe<RemoveByIdListPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  listUpdate?: Maybe<UpdateByIdListPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  memberCreate?: Maybe<CreateOneMemberPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  memberRemove?: Maybe<RemoveByIdMemberPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  memberUpdate?: Maybe<UpdateByIdMemberPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  noteCreate?: Maybe<CreateOneNewNotePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  noteDelete?: Maybe<RemoveByIdNewNotePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdate?: Maybe<UpdateByIdNewNotePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  occurrenceCreate?: Maybe<CreateOneNewOccurrencePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  occurrenceRemove?: Maybe<RemoveByIdNewOccurrencePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  occurrenceUpdate?: Maybe<UpdateByIdNewOccurrencePayload>;
  operatorConnectStripeAccount?: Maybe<OperatorConnectStripeReturn>;
  operatorDisconnectStripeAccount?: Maybe<NewOperator>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  operatorUpdate?: Maybe<UpdateByIdNewOperatorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  orderCreate?: Maybe<CreateOneOrderPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  orderRemove?: Maybe<RemoveByIdOrderPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  orderUpdate?: Maybe<UpdateByIdOrderPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  orgCreate?: Maybe<CreateOneNewOrgPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  orgRemove?: Maybe<RemoveByIdNewOrgPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  orgUpdate?: Maybe<UpdateByIdNewOrgPayload>;
  personCoursesUpdate?: Maybe<PersonCoursesUpdateResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  personCreate?: Maybe<CreateOnePersonPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  personRemove?: Maybe<RemoveByIdPersonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  personUpdate?: Maybe<UpdateByIdPersonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  productCreate?: Maybe<CreateOneProductPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  productRemove?: Maybe<RemoveByIdProductPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  productUpdate?: Maybe<UpdateByIdProductPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  refundCreate?: Maybe<CreateOneRefundPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  refundUpdate?: Maybe<UpdateByIdRefundPayload>;
  removeManyFromTenant: RemoveManyFromTenantResponse;
  saveOnboardingStep?: Maybe<User>;
  sendEmail: SendEmailResponse;
  sendEmailVerification?: Maybe<User>;
  setOnboardingStatus?: Maybe<User>;
  setOperatorAsPermanentlyClosed: SetOperatorAsPermanentlyClosedResponse;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  siteCreate?: Maybe<CreateOneSitePayload>;
  siteDeploy?: Maybe<SiteDeployResponse>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  siteRemove?: Maybe<RemoveByIdSitePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  siteUpdate?: Maybe<UpdateByIdSitePayload>;
  submitEventForApproval: SubmitEventForApprovalResponse;
  summarize: SummaryResponse;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tagCreate?: Maybe<CreateOneNewTagPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  tagRemove?: Maybe<RemoveByIdNewTagPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tagUpdate?: Maybe<UpdateByIdNewTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  taxRateCreate?: Maybe<CreateOneTaxRatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  taxRateRemove?: Maybe<RemoveByIdTaxRatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  taxRateUpdate?: Maybe<UpdateByIdTaxRatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tsnnRequestCreate?: Maybe<CreateOneTsnnRequestPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  tsnnRequestRemoveById?: Maybe<RemoveByIdTsnnRequestPayload>;
  /** Remove one document: 1) Remove with hooks via findOneAndRemove. 2) Return removed document. */
  tsnnRequestRemoveOne?: Maybe<RemoveOneTsnnRequestPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tsnnRequestUpdateById?: Maybe<UpdateByIdTsnnRequestPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  tsnnRequestUpdateMany?: Maybe<UpdateManyTsnnRequestPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tsnnRequestUpdateOne?: Maybe<UpdateOneTsnnRequestPayload>;
  updateClosuresPerProduct: Array<Scalars['ID']['output']>;
  updateEvent?: Maybe<Event>;
  updateEventAdminZone: UpdateEventAdminZoneResponse;
  updateEventDetails: UpdateEventDetailsResponse;
  updateEventImage: UpdateEventImageResponse;
  updateEventImages: UpdateEventImagesResponse;
  updateEventOccurrence?: Maybe<Event>;
  updateImage?: Maybe<Image>;
  updateImageData?: Maybe<Image>;
  updateManyOperators: UpdateManyOperatorsResponse;
  updateOperator?: Maybe<Operator>;
  updateUserMetadata?: Maybe<User>;
  validateOperatorOTP: ValidateOperatorOtpResponse;
};


export type MutationAddPeopleToOperatorArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddProfileIdToUserArgs = {
  auth0Id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationAddUserToTenantArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userObject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAmenityCreateArgs = {
  record: CreateOneAmenityInput;
};


export type MutationAmenityRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationAmenityUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAmenityInput;
};


export type MutationAnalyzeLearnerReportArgs = {
  input: SummaryInput;
};


export type MutationBookerCreateArgs = {
  record: CreateOneBookerInput;
};


export type MutationBookerRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationBookerUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBookerInput;
};


export type MutationCancelAllEventOccurrencesArgs = {
  _id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCourseCreateArgs = {
  record: CreateOneCourseInput;
};


export type MutationCourseRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationCourseUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCourseInput;
};


export type MutationCreateClosuresPerProductArgs = {
  endISO: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIDs: Array<Scalars['ID']['input']>;
  startISO: Scalars['String']['input'];
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateEventImageArgs = {
  input: CreateEventImageInput;
};


export type MutationCreateNotificationArgs = {
  notification?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOperatorArgs = {
  input: CreateOperatorInput;
};


export type MutationCreateOperatorImageArgs = {
  input: CreateOperatorImageInput;
};


export type MutationCreateReportArgs = {
  report?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTenantArgs = {
  dmo?: InputMaybe<Scalars['String']['input']>;
  operators?: InputMaybe<Scalars['String']['input']>;
  registeredApps?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteEventArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteEventImageArgs = {
  input: DeleteEventImageInput;
};


export type MutationDeleteEventOccurrenceArgs = {
  input: DeleteEventOccurrenceInput;
};


export type MutationDeleteFormResponseArgs = {
  input: DeleteFormResponseInput;
};


export type MutationDeleteImageArgs = {
  _id: Scalars['ID']['input'];
  image?: InputMaybe<ImageInput>;
};


export type MutationDeleteOperatorArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationGenerateOperatorOtpArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationImageCreateArgs = {
  data: Scalars['JSON']['input'];
  entityId: Scalars['MongoID']['input'];
  entityType: Entity;
};


export type MutationImageRemoveArgs = {
  entityId: Scalars['MongoID']['input'];
  entityType: Entity;
  filter?: InputMaybe<FilterRemoveOneNewImageInput>;
  sort?: InputMaybe<SortRemoveOneNewImageInput>;
};


export type MutationImageSortOrderArgs = {
  entityId: Scalars['MongoID']['input'];
  entityType: Entity;
  images: Array<InputMaybe<Scalars['MongoID']['input']>>;
};


export type MutationImageUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNewImageInput;
};


export type MutationIntegrateProductCalendarLinksByProductIdsArgs = {
  calendarLinksByProductIDs: Array<CalendarLinksByProductId>;
};


export type MutationInventoryCreateArgs = {
  record: CreateOneInventoryItemInput;
};


export type MutationInventoryRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationInventoryUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInventoryItemInput;
};


export type MutationInventoryUpdateClaimedDatesByOrderArgs = {
  endISO: Scalars['String']['input'];
  orderID: Scalars['ID']['input'];
  startISO: Scalars['String']['input'];
};


export type MutationLearnerActivityLogCreateArgs = {
  record: CreateOneLearnerActivityLogInput;
};


export type MutationLearnerActivityLogRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationLearnerActivityLogUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLearnerActivityLogInput;
};


export type MutationLegacyOperatorCreateArgs = {
  record: CreateOneLegacyOperatorInput;
};


export type MutationLegacyOperatorRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationLegacyOperatorUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLegacyOperatorInput;
};


export type MutationListCreateArgs = {
  record: CreateOneListInput;
};


export type MutationListRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationListUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdListInput;
};


export type MutationMemberCreateArgs = {
  record: CreateOneMemberInput;
};


export type MutationMemberRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationMemberUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdMemberInput;
};


export type MutationNoteCreateArgs = {
  record: CreateOneNewNoteInput;
};


export type MutationNoteDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationNoteUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNewNoteInput;
};


export type MutationOccurrenceCreateArgs = {
  record: CreateOneNewOccurrenceInput;
};


export type MutationOccurrenceRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationOccurrenceUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNewOccurrenceInput;
};


export type MutationOperatorConnectStripeAccountArgs = {
  id: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationOperatorDisconnectStripeAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOperatorUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNewOperatorInput;
};


export type MutationOrderCreateArgs = {
  customerContact: CustomerContactInput;
  paymentMethodID: Scalars['String']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>>;
  source: OrderSourceInput;
};


export type MutationOrderRemoveArgs = {
  _id: Scalars['String']['input'];
};


export type MutationOrderUpdateArgs = {
  _id: Scalars['String']['input'];
  cancelled: Scalars['Boolean']['input'];
};


export type MutationOrgCreateArgs = {
  record: CreateOneNewOrgInput;
};


export type MutationOrgRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationOrgUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNewOrgInput;
};


export type MutationPersonCoursesUpdateArgs = {
  input?: InputMaybe<PersonCoursesUpdateInput>;
};


export type MutationPersonCreateArgs = {
  record: CreateOnePersonInput;
};


export type MutationPersonRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationPersonUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPersonInput;
};


export type MutationProductCreateArgs = {
  inventoryCount: Scalars['Int']['input'];
  record: CreateOneProductInput;
};


export type MutationProductRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationProductUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProductInput;
};


export type MutationRefundCreateArgs = {
  amount: Scalars['Int']['input'];
  orderID: Scalars['String']['input'];
};


export type MutationRefundUpdateArgs = {
  _id: Scalars['String']['input'];
  record: UpdateByIdRefundInput;
};


export type MutationRemoveManyFromTenantArgs = {
  ids: Array<Scalars['ID']['input']>;
  tenants?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveOnboardingStepArgs = {
  page?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendEmailArgs = {
  input: SendEmailInput;
};


export type MutationSendEmailVerificationArgs = {
  user_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetOnboardingStatusArgs = {
  status?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetOperatorAsPermanentlyClosedArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationSiteCreateArgs = {
  record: CreateOneSiteInput;
};


export type MutationSiteDeployArgs = {
  input?: InputMaybe<SiteDeployInput>;
};


export type MutationSiteRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationSiteUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSiteInput;
};


export type MutationSubmitEventForApprovalArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationSummarizeArgs = {
  input: SummaryInput;
};


export type MutationTagCreateArgs = {
  record: CreateOneNewTagInput;
};


export type MutationTagRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationTagUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNewTagInput;
};


export type MutationTaxRateCreateArgs = {
  record: CreateOneTaxRateInput;
};


export type MutationTaxRateRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationTaxRateUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTaxRateInput;
};


export type MutationTsnnRequestCreateArgs = {
  record: CreateOneTsnnRequestInput;
};


export type MutationTsnnRequestRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationTsnnRequestRemoveOneArgs = {
  filter?: InputMaybe<FilterRemoveOneTsnnRequestInput>;
  sort?: InputMaybe<SortRemoveOneTsnnRequestInput>;
};


export type MutationTsnnRequestUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTsnnRequestInput;
};


export type MutationTsnnRequestUpdateManyArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  filter?: InputMaybe<FilterUpdateManyTsnnRequestInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyTsnnRequestInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyTsnnRequestInput>;
};


export type MutationTsnnRequestUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneTsnnRequestInput>;
  record: UpdateOneTsnnRequestInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneTsnnRequestInput>;
};


export type MutationUpdateClosuresPerProductArgs = {
  closureID: Scalars['ID']['input'];
  deleteClosure: Scalars['Boolean']['input'];
  endISO?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  startISO?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEventArgs = {
  _id: Scalars['ID']['input'];
  event: UpdateEventInput;
};


export type MutationUpdateEventAdminZoneArgs = {
  input: UpdateEventAdminZoneInput;
};


export type MutationUpdateEventDetailsArgs = {
  input: UpdateEventDetailsInput;
};


export type MutationUpdateEventImageArgs = {
  input: UpdateEventImageInput;
};


export type MutationUpdateEventImagesArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  record: UpdateEventImagesInput;
};


export type MutationUpdateEventOccurrenceArgs = {
  eventId: Scalars['ID']['input'];
  occurrenceId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateOccurrence>;
};


export type MutationUpdateImageArgs = {
  _id: Scalars['ID']['input'];
  image: Scalars['String']['input'];
};


export type MutationUpdateImageDataArgs = {
  _id: Scalars['ID']['input'];
  image?: InputMaybe<ImageInput>;
};


export type MutationUpdateManyOperatorsArgs = {
  input: UpdateManyOperatorsInput;
};


export type MutationUpdateOperatorArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  record?: InputMaybe<UpdateOperatorInput>;
};


export type MutationUpdateUserMetadataArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationValidateOperatorOtpArgs = {
  input: ValidateOperatorOtpInput;
};

export type NewImage = {
  __typename?: 'NewImage';
  _id: Scalars['MongoID']['output'];
  blurhash: Scalars['String']['output'];
  caption?: Maybe<NewMultilingual>;
  colors: Array<Maybe<NewImageColors>>;
  /**
   * Currently, our schema only supports facial and text detection, using the built-in Cloudinary AI Content Analysis face detection, and the `cld-text` model. Therefore, the fields returned in `detectedObjects` will be limited to *optional* `humanFace` and `text` fields which are of `IDetectedObject[]` type.
   *
   * &nbsp;
   *
   * `IDetectedObject` contains a `boundingBox` array of `numbers`, a `categories` array of `string`s, and a `number` `confidence` value.
   *
   * &nbsp;
   *
   * ```json
   * interface IDetectedObject extends Document {
   *   boundingBox: number[];
   *   categories: string[];
   *   confidence: number;
   * }
   * ```
   */
  detectedObjects?: Maybe<Scalars['JSON']['output']>;
  full_url?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  teaser_url?: Maybe<Scalars['String']['output']>;
  teaser_url_x2?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  thumbnail_url_x2?: Maybe<Scalars['String']['output']>;
};

export type NewImageColors = {
  __typename?: 'NewImageColors';
  _id?: Maybe<Scalars['MongoID']['output']>;
  predominance: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type NewMultilingual = {
  __typename?: 'NewMultilingual';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type NewMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type NewNote = {
  __typename?: 'NewNote';
  _id: Scalars['MongoID']['output'];
  author?: Maybe<Person>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  /** @deprecated  */
  member?: Maybe<Member>;
  mentions: Array<Person>;
  message: Scalars['String']['output'];
  pin: Scalars['Boolean']['output'];
  resolved: Scalars['Boolean']['output'];
  tags: Array<NewTag>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};


export type NewNoteMemberArgs = {
  _id: Scalars['MongoID']['input'];
};

export type NewOccurrence = {
  __typename?: 'NewOccurrence';
  _id: Scalars['MongoID']['output'];
  cancelled: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  endDateISO: Scalars['String']['output'];
  productID: Scalars['MongoID']['output'];
  startDateISO: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type NewOperator = {
  __typename?: 'NewOperator';
  _id: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  bookerOptions?: Maybe<BookerOptions>;
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<NewMultilingual>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  images: Array<NewImage>;
  name: Scalars['String']['output'];
  opening: Opening;
  pricing?: Maybe<EnumNewOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<NewMultilingual>;
  tags: Array<Maybe<Scalars['MongoID']['output']>>;
  tenantsOf: Array<Maybe<Scalars['String']['output']>>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumNewOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type NewOrg = {
  __typename?: 'NewOrg';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customTags?: Maybe<NewOrgCustomTags>;
  membershipSettings?: Maybe<NewOrgMembershipSettings>;
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  staff: Array<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type NewOrgCustomTags = {
  __typename?: 'NewOrgCustomTags';
  memberTags?: Maybe<Array<Maybe<NewOrgCustomTagsNoteTags>>>;
  noteTags?: Maybe<Array<Maybe<NewOrgCustomTagsNoteTags>>>;
};

export type NewOrgCustomTagsInput = {
  memberTags?: InputMaybe<Array<InputMaybe<NewOrgCustomTagsNoteTagsInput>>>;
  noteTags?: InputMaybe<Array<InputMaybe<NewOrgCustomTagsNoteTagsInput>>>;
};

export type NewOrgCustomTagsNoteTags = {
  __typename?: 'NewOrgCustomTagsNoteTags';
  _id: Scalars['MongoID']['output'];
  name: NewMultilingual;
};

export type NewOrgCustomTagsNoteTagsInput = {
  _id: Scalars['MongoID']['input'];
  name: NewMultilingualInput;
};

export type NewOrgMembershipSettings = {
  __typename?: 'NewOrgMembershipSettings';
  customViews: Array<Maybe<NewOrgMembershipSettingsCustomViews>>;
  dues: NewOrgMembershipSettingsDues;
};

export type NewOrgMembershipSettingsCustomViews = {
  __typename?: 'NewOrgMembershipSettingsCustomViews';
  _id?: Maybe<Scalars['MongoID']['output']>;
  label: Scalars['String']['output'];
  query: Scalars['String']['output'];
  searchField: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type NewOrgMembershipSettingsCustomViewsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label: Scalars['String']['input'];
  query: Scalars['String']['input'];
  searchField: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type NewOrgMembershipSettingsDues = {
  __typename?: 'NewOrgMembershipSettingsDues';
  active: Scalars['Boolean']['output'];
  tiers: Array<Maybe<NewOrgMembershipSettingsDuesTiers>>;
};

export type NewOrgMembershipSettingsDuesInput = {
  active: Scalars['Boolean']['input'];
  tiers: Array<InputMaybe<NewOrgMembershipSettingsDuesTiersInput>>;
};

export type NewOrgMembershipSettingsDuesTiers = {
  __typename?: 'NewOrgMembershipSettingsDuesTiers';
  _id?: Maybe<Scalars['MongoID']['output']>;
  label: Scalars['String']['output'];
};

export type NewOrgMembershipSettingsDuesTiersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label: Scalars['String']['input'];
};

export type NewOrgMembershipSettingsInput = {
  customViews: Array<InputMaybe<NewOrgMembershipSettingsCustomViewsInput>>;
  dues: NewOrgMembershipSettingsDuesInput;
};

export type NewTag = {
  __typename?: 'NewTag';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  name: NewMultilingual;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Note = {
  __typename?: 'Note';
  by?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Int']['output']>;
  is_public?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NoteEvent = {
  __typename?: 'NoteEvent';
  by?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NoteEventInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type NoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Int']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  _id?: Maybe<Scalars['ID']['output']>;
  button?: Maybe<Button>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Occurrence = {
  __typename?: 'Occurrence';
  _id: Scalars['ID']['output'];
  endDateTime?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  startDateTime: Scalars['String']['output'];
  type?: Maybe<ScheduleType>;
};

export type OnboardingInput = {
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  signUp?: InputMaybe<SignupInput>;
};

export type Opening = {
  __typename?: 'Opening';
  hoursOfOperation: Array<Maybe<DateRangeIso>>;
  seasonality: Array<Maybe<EnumOpeningSeasonality>>;
  source?: Maybe<EnumOpeningSource>;
};

export type Operator = {
  __typename?: 'Operator';
  Categories?: Maybe<Scalars['String']['output']>;
  Date?: Maybe<Scalars['Int']['output']>;
  Slug?: Maybe<Scalars['Int']['output']>;
  Tags?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  book_now_url?: Maybe<Scalars['String']['output']>;
  checklist?: Maybe<Checklist>;
  city?: Maybe<Scalars['String']['output']>;
  connections?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Multilingual>;
  destinations?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook_link?: Maybe<Scalars['String']['output']>;
  google_mybusiness_link?: Maybe<Scalars['String']['output']>;
  hours_of_operation?: Maybe<Scalars['String']['output']>;
  hours_of_operation_week?: Maybe<HoursOfOperation>;
  images?: Maybe<Array<Maybe<NewImage>>>;
  inline_featured_image?: Maybe<Scalars['String']['output']>;
  instagram_link?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  line_1?: Maybe<Scalars['String']['output']>;
  line_2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  markAsNeedsAttention?: Maybe<Scalars['Boolean']['output']>;
  more_info_link?: Maybe<Scalars['String']['output']>;
  more_information?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  open_hours_option?: Maybe<Scalars['String']['output']>;
  operator_name?: Maybe<Scalars['String']['output']>;
  people?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phone?: Maybe<Scalars['String']['output']>;
  pinterest_link?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  publishingOptions?: Maybe<Scalars['String']['output']>;
  seasonality?: Maybe<Seasonality>;
  short_description?: Maybe<Multilingual>;
  sta_license_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Tags>;
  tenants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  termsConditions?: Maybe<Scalars['String']['output']>;
  tiktok_link?: Maybe<Scalars['String']['output']>;
  tripadvisor_link?: Maybe<Scalars['String']['output']>;
  twitter_link?: Maybe<Scalars['String']['output']>;
  up_to_date_source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube_link?: Maybe<Scalars['String']['output']>;
};

export type OperatorConnectStripeReturn = {
  __typename?: 'OperatorConnectStripeReturn';
  link: Scalars['String']['output'];
  record?: Maybe<NewOperator>;
};

export type OperatorEvent = {
  __typename?: 'OperatorEvent';
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook_link?: Maybe<Scalars['String']['output']>;
  instagram_link?: Maybe<Scalars['String']['output']>;
  operator_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pinterest_link?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube_link?: Maybe<Scalars['String']['output']>;
};

export type OperatorStripeAccountStatus = {
  __typename?: 'OperatorStripeAccountStatus';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: EnumStripeOnboardingStatus;
};

export type Order = {
  __typename?: 'Order';
  _id: Scalars['String']['output'];
  cancelled: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customerContact: CustomerContact;
  purchasedProducts: Array<Maybe<PurchasedProduct>>;
  source: OrderSource;
  stripeMetadata: StripeMetadata;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OrderCartPrice = {
  __typename?: 'OrderCartPrice';
  orderID: Scalars['ID']['output'];
  prices?: Maybe<CartPrices>;
};

/** List of items with pagination. */
export type OrderFindMany = {
  __typename?: 'OrderFindMany';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Order>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OrderSource = {
  __typename?: 'OrderSource';
  bookerID: Scalars['String']['output'];
  operator: Scalars['MongoID']['output'];
};

export type OrderSourceInput = {
  bookerID: Scalars['String']['input'];
  operator: Scalars['MongoID']['input'];
};

export type Org = {
  __typename?: 'Org';
  _id?: Maybe<Scalars['ID']['output']>;
  customPortals?: Maybe<Scalars['JSON']['output']>;
  logo?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tripperSettings?: Maybe<Tripper>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type Person = {
  __typename?: 'Person';
  _id: Scalars['MongoID']['output'];
  accountStatus: EnumPersonAccountStatus;
  address?: Maybe<Address>;
  auth0Id?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  enrolledThrough?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  learner?: Maybe<PersonLearner>;
  operator?: Maybe<LegacyOperator>;
  tenantsOf: Array<Maybe<PersonTenantsOf>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type PersonCoursesUpdateInput = {
  courseId: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  status?: InputMaybe<PersonCoursesUpdateStatusEnum>;
  suspendData?: InputMaybe<Scalars['JSON']['input']>;
};

export type PersonCoursesUpdateResult = {
  __typename?: 'PersonCoursesUpdateResult';
  _id: Scalars['String']['output'];
};

export enum PersonCoursesUpdateStatusEnum {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type PersonLearner = {
  __typename?: 'PersonLearner';
  courses?: Maybe<Array<Maybe<PersonLearnerCourses>>>;
  stats?: Maybe<PersonLearnerStats>;
};

export type PersonLearnerCourses = {
  __typename?: 'PersonLearnerCourses';
  completedDate?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  courseName?: Maybe<Scalars['String']['output']>;
  lastAccessDate?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumPersonLearnerCoursesStatus>;
  suspendData?: Maybe<Scalars['JSON']['output']>;
};

export type PersonLearnerCoursesInput = {
  completedDate?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  lastAccessDate?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumPersonLearnerCoursesStatus>;
  suspendData?: InputMaybe<Scalars['JSON']['input']>;
};

export type PersonLearnerInput = {
  courses?: InputMaybe<Array<InputMaybe<PersonLearnerCoursesInput>>>;
  stats?: InputMaybe<PersonLearnerStatsInput>;
};

export type PersonLearnerStats = {
  __typename?: 'PersonLearnerStats';
  startDate?: Maybe<Scalars['String']['output']>;
  totalCoursesCompleted?: Maybe<Scalars['Float']['output']>;
  totalCoursesStarted?: Maybe<Scalars['Float']['output']>;
};

export type PersonLearnerStatsInput = {
  startDate?: InputMaybe<Scalars['String']['input']>;
  totalCoursesCompleted?: InputMaybe<Scalars['Float']['input']>;
  totalCoursesStarted?: InputMaybe<Scalars['Float']['input']>;
};

export type PersonTenantsOf = {
  __typename?: 'PersonTenantsOf';
  _id?: Maybe<Scalars['MongoID']['output']>;
  operatorRef?: Maybe<Scalars['MongoID']['output']>;
  role: EnumPersonTenantsOfRole;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type PersonTenantsOfInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorRef?: InputMaybe<Scalars['MongoID']['input']>;
  role: EnumPersonTenantsOfRole;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type PointLocation = {
  __typename?: 'PointLocation';
  coordinates: Array<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type PricePerProduct = {
  __typename?: 'PricePerProduct';
  price: Scalars['Int']['output'];
  productID: Scalars['ID']['output'];
};

export type PriceTier = {
  __typename?: 'PriceTier';
  _id: Scalars['MongoID']['output'];
  label?: Maybe<NewMultilingual>;
  price: Scalars['Float']['output'];
  type: EnumPriceTierType;
};

export type PriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<NewMultilingualInput>;
  price: Scalars['Float']['input'];
  type: EnumPriceTierType;
};

export type Pricing = {
  __typename?: 'Pricing';
  description?: Maybe<NewMultilingual>;
  tiers: Array<Maybe<PriceTier>>;
};

export type PricingInput = {
  description?: InputMaybe<NewMultilingualInput>;
  tiers: Array<InputMaybe<PriceTierInput>>;
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationProductMetadata>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<NewMultilingual>;
  externalBookingUrl?: Maybe<Scalars['String']['output']>;
  images: Array<NewImage>;
  isActive: Scalars['Boolean']['output'];
  isUpsellOnly: Scalars['Boolean']['output'];
  name: NewMultilingual;
  operator: Scalars['MongoID']['output'];
  pricing: Pricing;
  publishingStatus: EnumProductPublishingStatus;
  shortDescription?: Maybe<NewMultilingual>;
  tags: Array<NewTag>;
  taxRate?: Maybe<TaxRate>;
  type: EnumProductType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ProductPurchaseRequest = {
  endDateISO: Scalars['String']['input'];
  guestTiers: Array<InputMaybe<PurchasedProductGuestsPerTierInput>>;
  productId: Scalars['MongoID']['input'];
  startDateISO: Scalars['String']['input'];
};

export type PurchasedProduct = {
  __typename?: 'PurchasedProduct';
  _id: Scalars['MongoID']['output'];
  guestsPerTier: Array<Maybe<PurchasedProductGuestsPerTier>>;
  inventoryClaims: Array<Maybe<PurchasedProductInventoryClaims>>;
  product: Product;
};

export type PurchasedProductGuestsPerTier = {
  __typename?: 'PurchasedProductGuestsPerTier';
  count: Scalars['Float']['output'];
  tierId: Scalars['MongoID']['output'];
};

export type PurchasedProductGuestsPerTierInput = {
  count: Scalars['Float']['input'];
  tierId: Scalars['MongoID']['input'];
};

export type PurchasedProductInventoryClaims = {
  __typename?: 'PurchasedProductInventoryClaims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  claimedDateRangeISO?: Maybe<DateRangeIso>;
  inventory?: Maybe<InventoryItem>;
  inventoryID: Scalars['MongoID']['output'];
};

export type QualityAnalysis = {
  focus?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename?: 'Query';
  amenityById?: Maybe<Amenity>;
  amenityByIds: Array<Amenity>;
  amenityMany: Array<Amenity>;
  apps?: Maybe<Array<Maybe<App>>>;
  bookerById?: Maybe<Booker>;
  bookerByMainProductId?: Maybe<Booker>;
  bookerCartPrice?: Maybe<CartPrices>;
  bookerMany: Array<Booker>;
  bookerSendContactUsEmail?: Maybe<EmailResponse>;
  courseById?: Maybe<Course>;
  courseMany: Array<Course>;
  coursesBy?: Maybe<Array<Maybe<Course>>>;
  getEvent?: Maybe<Event>;
  getEventDetailsOptions?: Maybe<EventDetailsOptions>;
  getEvents: Array<Event>;
  getEventsGroupByPeriod: GetEventsGroupByPeriodResponse;
  getFormResponses: GetFromResponseResponse;
  getOperator?: Maybe<Operator>;
  getOperators: GetOperatorsResponse;
  getOperatorsByID?: Maybe<Array<Maybe<Operator>>>;
  getOrgs?: Maybe<Array<Maybe<Org>>>;
  getReports?: Maybe<Array<Maybe<Report>>>;
  getSiteSettings?: Maybe<SiteSettings>;
  getTeamInfo?: Maybe<Tenant>;
  getUserStatus: GetUserStatusResponse;
  getVisitsForURL?: Maybe<Scalars['String']['output']>;
  imageById?: Maybe<NewImage>;
  imageByIds: Array<NewImage>;
  inventoryById?: Maybe<InventoryItem>;
  inventoryByIds: Array<InventoryItem>;
  /** This resolver will return all the fully booked dates & the check-out only dates per product. */
  inventoryDatesByProduct?: Maybe<InventoryBookedDatesSummary>;
  inventoryMany: Array<InventoryItem>;
  learnerActivityLogById?: Maybe<LearnerActivityLog>;
  learnerActivityLogMany?: Maybe<LearnerActivityLogFindMany>;
  legacyOperatorById?: Maybe<LegacyOperator>;
  legacyOperatorByIds: Array<LegacyOperator>;
  legacyOperatorMany: Array<LegacyOperator>;
  listById?: Maybe<List>;
  listFindMany: Array<List>;
  memberById?: Maybe<Member>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  memberMany: Array<Member>;
  membersGroupByOwner?: Maybe<MembersGroupByOwner>;
  noteById?: Maybe<NewNote>;
  noteMany: Array<NewNote>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  occurrenceById?: Maybe<NewOccurrence>;
  occurrenceMany: Array<NewOccurrence>;
  operatorById?: Maybe<NewOperator>;
  operatorMany: Array<NewOperator>;
  operatorStripeAccountStatus?: Maybe<OperatorStripeAccountStatus>;
  operatorTotalSales: Scalars['Float']['output'];
  orderById?: Maybe<Order>;
  orderByIds: Array<Order>;
  orderMany?: Maybe<OrderFindMany>;
  orderPricesById?: Maybe<CartPrices>;
  orderPricesByIds: Array<OrderCartPrice>;
  org?: Maybe<Org>;
  orgById?: Maybe<NewOrg>;
  orgByIds: Array<NewOrg>;
  orgFindOne?: Maybe<NewOrg>;
  orgMany: Array<NewOrg>;
  personById?: Maybe<Person>;
  personByIds: Array<Person>;
  personMany: Array<Person>;
  productById?: Maybe<Product>;
  productCalendarLinkById: Scalars['String']['output'];
  productClosureById?: Maybe<ClosureData>;
  productMany: Array<Product>;
  productTotalSales: Scalars['Float']['output'];
  productsByIds: Array<Product>;
  refundById?: Maybe<Refund>;
  refundMany: Array<Refund>;
  refundsByOrderIds?: Maybe<Array<Refund>>;
  searchOperators?: Maybe<Array<Maybe<Operator>>>;
  searchTags?: Maybe<Array<Maybe<Tag>>>;
  siteById?: Maybe<Site>;
  siteByOperatorId?: Maybe<SiteByOperatorIdResponse>;
  siteMany: Array<Site>;
  tagById?: Maybe<NewTag>;
  tagByIds: Array<NewTag>;
  tagMany: Array<NewTag>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  taxRateById?: Maybe<TaxRate>;
  taxRateMany: Array<TaxRate>;
  tripper?: Maybe<Array<Maybe<Tripper>>>;
  tsnnRequestById?: Maybe<TsnnRequest>;
  tsnnRequestCount?: Maybe<Scalars['Int']['output']>;
  tsnnRequestMany?: Maybe<TsnnRequestFindMany>;
  tsnnRequestOne?: Maybe<TsnnRequest>;
};


export type QueryAmenityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAmenityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAmenityInput>;
};


export type QueryAmenityManyArgs = {
  filter?: InputMaybe<FilterFindManyAmenityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAmenityInput>;
};


export type QueryAppsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookerByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBookerByMainProductIdArgs = {
  operatorID?: InputMaybe<Scalars['ID']['input']>;
  productID: Scalars['ID']['input'];
};


export type QueryBookerCartPriceArgs = {
  bookerID: Scalars['ID']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>>;
};


export type QueryBookerManyArgs = {
  filter?: InputMaybe<FilterFindManyBookerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBookerInput>;
};


export type QueryBookerSendContactUsEmailArgs = {
  details: ContactUsEmailDetails;
  operatorID: Scalars['ID']['input'];
  productID: Scalars['ID']['input'];
};


export type QueryCourseByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCourseManyArgs = {
  filter?: InputMaybe<FilterFindManyCourseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCourseInput>;
};


export type QueryCoursesByArgs = {
  input?: InputMaybe<CoursesByInput>;
};


export type QueryGetEventArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetEventsArgs = {
  input?: InputMaybe<GetEventsInput>;
};


export type QueryGetEventsGroupByPeriodArgs = {
  input?: InputMaybe<GetEventsGroupByPeriodInput>;
};


export type QueryGetFormResponsesArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  linkedID?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOperatorArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetOperatorsArgs = {
  adminTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  filterMode?: InputMaybe<Scalars['String']['input']>;
  getOperatorsByProximityInput?: InputMaybe<GetOperatorsByProximityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator_name?: InputMaybe<Scalars['String']['input']>;
  operator_type?: InputMaybe<Array<Scalars['String']['input']>>;
  publishingOptions?: InputMaybe<Scalars['String']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenants?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOperatorsByIdArgs = {
  input?: InputMaybe<GetOperatorsByIdInput>;
};


export type QueryGetTeamInfoArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserStatusArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImageByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryImageByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNewImageInput>;
};


export type QueryInventoryByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInventoryByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInventoryItemInput>;
};


export type QueryInventoryDatesByProductArgs = {
  productID: Scalars['ID']['input'];
};


export type QueryInventoryManyArgs = {
  filter?: InputMaybe<FilterFindManyInventoryItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInventoryItemInput>;
};


export type QueryLearnerActivityLogByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLearnerActivityLogManyArgs = {
  filter?: InputMaybe<FilterFindManyLearnerActivityLogInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLearnerActivityLogInput>;
};


export type QueryLegacyOperatorByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLegacyOperatorByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsLegacyOperatorInput>;
};


export type QueryLegacyOperatorManyArgs = {
  filter?: InputMaybe<FilterFindManyLegacyOperatorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLegacyOperatorInput>;
};


export type QueryListByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryListFindManyArgs = {
  filter?: InputMaybe<FilterFindManyListInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyListInput>;
};


export type QueryMemberByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryMemberCountArgs = {
  filter?: InputMaybe<FilterCountMemberInput>;
};


export type QueryMemberManyArgs = {
  filter?: InputMaybe<FilterFindManyMemberInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyMemberInput>;
};


export type QueryMembersGroupByOwnerArgs = {
  filter?: InputMaybe<FilterMembersGroupByOwnerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNoteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNoteManyArgs = {
  filter?: InputMaybe<FilterFindManyNewNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNewNoteInput>;
  sortCreatedDateISODesc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNotificationsArgs = {
  tenants?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOccurrenceByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryOccurrenceManyArgs = {
  filter?: InputMaybe<FilterFindManyNewOccurrenceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNewOccurrenceInput>;
};


export type QueryOperatorByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryOperatorManyArgs = {
  filter?: InputMaybe<FilterFindManyNewOperatorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNewOperatorInput>;
};


export type QueryOperatorStripeAccountStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOperatorTotalSalesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryOrderByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrderInput>;
};


export type QueryOrderManyArgs = {
  filter?: InputMaybe<FilterFindManyOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrderInput>;
};


export type QueryOrderPricesByIdArgs = {
  orderID: Scalars['ID']['input'];
};


export type QueryOrderPricesByIdsArgs = {
  orderIDs: Array<Scalars['ID']['input']>;
};


export type QueryOrgArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryOrgByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNewOrgInput>;
};


export type QueryOrgFindOneArgs = {
  filter?: InputMaybe<FilterFindOneNewOrgInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNewOrgInput>;
};


export type QueryOrgManyArgs = {
  filter?: InputMaybe<FilterFindManyNewOrgInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNewOrgInput>;
};


export type QueryPersonByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPersonByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPersonInput>;
};


export type QueryPersonManyArgs = {
  filter?: InputMaybe<FilterFindManyPersonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPersonInput>;
};


export type QueryProductByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProductCalendarLinkByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductClosureByIdArgs = {
  closureID: Scalars['ID']['input'];
};


export type QueryProductManyArgs = {
  filter?: InputMaybe<FilterFindManyProductInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};


export type QueryProductTotalSalesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProductInput>;
};


export type QueryRefundByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryRefundManyArgs = {
  filter?: InputMaybe<FilterFindManyRefundInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRefundInput>;
};


export type QueryRefundsByOrderIdsArgs = {
  orderIDs: Array<Scalars['ID']['input']>;
};


export type QuerySearchOperatorsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchTagsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySiteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySiteByOperatorIdArgs = {
  input?: InputMaybe<SiteByOperatorIdInput>;
};


export type QuerySiteManyArgs = {
  filter?: InputMaybe<FilterFindManySiteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySiteInput>;
};


export type QueryTagByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNewTagInput>;
};


export type QueryTagManyArgs = {
  filter?: InputMaybe<FilterFindManyNewTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNewTagInput>;
};


export type QueryTagsArgs = {
  bundle?: InputMaybe<Scalars['String']['input']>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  dbName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaxRateByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTaxRateManyArgs = {
  filter?: InputMaybe<FilterFindManyTaxRateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTaxRateInput>;
};


export type QueryTripperArgs = {
  nid?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTsnnRequestByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTsnnRequestCountArgs = {
  filter?: InputMaybe<FilterCountTsnnRequestInput>;
};


export type QueryTsnnRequestManyArgs = {
  filter?: InputMaybe<FilterFindManyTsnnRequestInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTsnnRequestInput>;
};


export type QueryTsnnRequestOneArgs = {
  filter?: InputMaybe<FilterFindOneTsnnRequestInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneTsnnRequestInput>;
};

export type Refund = {
  __typename?: 'Refund';
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  orderID: Scalars['String']['output'];
  status: EnumRefundStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type RemoveByIdAmenityPayload = {
  __typename?: 'RemoveByIdAmenityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Amenity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBookerPayload = {
  __typename?: 'RemoveByIdBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCoursePayload = {
  __typename?: 'RemoveByIdCoursePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Course>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdInventoryItemPayload = {
  __typename?: 'RemoveByIdInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLearnerActivityLogPayload = {
  __typename?: 'RemoveByIdLearnerActivityLogPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<LearnerActivityLog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdLegacyOperatorPayload = {
  __typename?: 'RemoveByIdLegacyOperatorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<LegacyOperator>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdListPayload = {
  __typename?: 'RemoveByIdListPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<List>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdMemberPayload = {
  __typename?: 'RemoveByIdMemberPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Member>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdNewNotePayload = {
  __typename?: 'RemoveByIdNewNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<NewNote>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdNewOccurrencePayload = {
  __typename?: 'RemoveByIdNewOccurrencePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<NewOccurrence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdNewOrgPayload = {
  __typename?: 'RemoveByIdNewOrgPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<NewOrg>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdNewTagPayload = {
  __typename?: 'RemoveByIdNewTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<NewTag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdOrderPayload = {
  __typename?: 'RemoveByIdOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdPersonPayload = {
  __typename?: 'RemoveByIdPersonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdProductPayload = {
  __typename?: 'RemoveByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdSitePayload = {
  __typename?: 'RemoveByIdSitePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Site>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTsnnRequestPayload = {
  __typename?: 'RemoveByIdTSNNRequestPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TsnnRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTaxRatePayload = {
  __typename?: 'RemoveByIdTaxRatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TaxRate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveOneNewImagePayload = {
  __typename?: 'RemoveOneNewImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<NewImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveOneTsnnRequestPayload = {
  __typename?: 'RemoveOneTSNNRequestPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TsnnRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export enum RepeatType {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type Report = {
  __typename?: 'Report';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type RestaurantOperatorMetadata = {
  __typename?: 'RestaurantOperatorMetadata';
  seatingCapacity?: Maybe<Scalars['Float']['output']>;
};

export type Room = {
  __typename?: 'Room';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amenities?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  type: EnumRoomType;
};

export type RoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumRoomType;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Schedule = {
  __typename?: 'Schedule';
  day?: Maybe<Scalars['Int']['output']>;
  endDateTime?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  occurrenceEndDate?: Maybe<Scalars['String']['output']>;
  occurrences?: Maybe<Scalars['Int']['output']>;
  repeat?: Maybe<RepeatType>;
  startDateTime?: Maybe<Scalars['String']['output']>;
  timeSlots?: Maybe<Array<Maybe<TimeSlot>>>;
  type: ScheduleType;
  weekdays?: Maybe<Array<Maybe<Weekday>>>;
};

export type ScheduleInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  repeat?: InputMaybe<RepeatType>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  type: ScheduleType;
  weekdays?: InputMaybe<Array<InputMaybe<Weekday>>>;
};

export enum ScheduleType {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export type Season = {
  __typename?: 'Season';
  apr?: Maybe<Scalars['Boolean']['output']>;
  aug?: Maybe<Scalars['Boolean']['output']>;
  dec?: Maybe<Scalars['Boolean']['output']>;
  feb?: Maybe<Scalars['Boolean']['output']>;
  jan?: Maybe<Scalars['Boolean']['output']>;
  jul?: Maybe<Scalars['Boolean']['output']>;
  jun?: Maybe<Scalars['Boolean']['output']>;
  mar?: Maybe<Scalars['Boolean']['output']>;
  may?: Maybe<Scalars['Boolean']['output']>;
  nov?: Maybe<Scalars['Boolean']['output']>;
  oct?: Maybe<Scalars['Boolean']['output']>;
  sep?: Maybe<Scalars['Boolean']['output']>;
};

export type SeasonInput = {
  apr?: InputMaybe<Scalars['Boolean']['input']>;
  aug?: InputMaybe<Scalars['Boolean']['input']>;
  dec?: InputMaybe<Scalars['Boolean']['input']>;
  feb?: InputMaybe<Scalars['Boolean']['input']>;
  jan?: InputMaybe<Scalars['Boolean']['input']>;
  jul?: InputMaybe<Scalars['Boolean']['input']>;
  jun?: InputMaybe<Scalars['Boolean']['input']>;
  mar?: InputMaybe<Scalars['Boolean']['input']>;
  may?: InputMaybe<Scalars['Boolean']['input']>;
  nov?: InputMaybe<Scalars['Boolean']['input']>;
  oct?: InputMaybe<Scalars['Boolean']['input']>;
  sep?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Seasonality = {
  __typename?: 'Seasonality';
  closed?: Maybe<Season>;
  high?: Maybe<Season>;
  low?: Maybe<Season>;
};

export type SeasonalityInput = {
  closed?: InputMaybe<SeasonInput>;
  high?: InputMaybe<SeasonInput>;
  low?: InputMaybe<SeasonInput>;
};

export type ServiceOperatorMetadata = {
  __typename?: 'ServiceOperatorMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type SetOperatorAsPermanentlyClosedResponse = {
  __typename?: 'SetOperatorAsPermanentlyClosedResponse';
  _id: Scalars['ID']['output'];
};

export type SignupInput = {
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  pages?: InputMaybe<Scalars['String']['input']>;
  startedDate?: InputMaybe<Scalars['Date']['input']>;
  tenants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Site = {
  __typename?: 'Site';
  _id: Scalars['MongoID']['output'];
  analyticsId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  lists: Array<Maybe<SiteLists>>;
  name?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  teams: Array<Maybe<Scalars['String']['output']>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  whereaboutsSite?: Maybe<SiteWhereaboutsSite>;
};

export type SiteByOperatorIdInput = {
  operatorId: Scalars['ID']['input'];
};

export type SiteByOperatorIdResponse = {
  __typename?: 'SiteByOperatorIdResponse';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SiteDeployInput = {
  customDomain?: InputMaybe<Scalars['String']['input']>;
  operatorId: Scalars['ID']['input'];
  siteName: Scalars['String']['input'];
};

export type SiteDeployResponse = {
  __typename?: 'SiteDeployResponse';
  _id: Scalars['ID']['output'];
  branch: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SiteLists = {
  __typename?: 'SiteLists';
  _id?: Maybe<Scalars['MongoID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type SiteListsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSettings = {
  __typename?: 'SiteSettings';
  _id?: Maybe<Scalars['ID']['output']>;
  maintenanceMode?: Maybe<MaintenanceMode>;
};

export type SiteWhereaboutsSite = {
  __typename?: 'SiteWhereaboutsSite';
  _id?: Maybe<Scalars['MongoID']['output']>;
  branch: Scalars['String']['output'];
  operatorId: Scalars['MongoID']['output'];
  siteId: Scalars['String']['output'];
  siteTemplate?: Maybe<EnumSiteWhereaboutsSiteSiteTemplate>;
  siteType?: Maybe<EnumSiteWhereaboutsSiteSiteType>;
  url: Scalars['String']['output'];
};

export type SiteWhereaboutsSiteInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  branch: Scalars['String']['input'];
  operatorId: Scalars['MongoID']['input'];
  siteId: Scalars['String']['input'];
  siteTemplate?: InputMaybe<EnumSiteWhereaboutsSiteSiteTemplate>;
  siteType?: InputMaybe<EnumSiteWhereaboutsSiteSiteType>;
  url: Scalars['String']['input'];
};

export enum SortFindByIdsAmenityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInventoryItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsLegacyOperatorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNewImageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNewOrgInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNewTagInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsOrderInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPersonInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProductInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAmenityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBookerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCourseInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInventoryItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyLearnerActivityLogInput {
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyLegacyOperatorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyListInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyMemberInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNewNoteInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNewOccurrenceInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNewOperatorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNewOrgInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNewTagInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyOrderInput {
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPersonInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProductInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRefundInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManySiteInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTsnnRequestInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTaxRateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNewOrgInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneTsnnRequestInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortRemoveOneNewImageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortRemoveOneTsnnRequestInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyTsnnRequestInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneTsnnRequestInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type StripeMetadata = {
  __typename?: 'StripeMetadata';
  chargeID: Scalars['String']['output'];
  customerID: Scalars['String']['output'];
  invoiceID?: Maybe<Scalars['String']['output']>;
  paymentMethodID: Scalars['String']['output'];
};

export type SubmitEventForApprovalResponse = {
  __typename?: 'SubmitEventForApprovalResponse';
  _id: Scalars['ID']['output'];
};

export type SummaryInput = {
  text: Scalars['String']['input'];
};

export type SummaryResponse = {
  __typename?: 'SummaryResponse';
  response: Scalars['String']['output'];
};

export type TsnnRequest = {
  __typename?: 'TSNNRequest';
  _id: Scalars['MongoID']['output'];
  matchedToOperator?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<TsnnRequestNote>;
  operatorID: Scalars['MongoID']['output'];
  requestBody?: Maybe<Scalars['JSON']['output']>;
  status: EnumTsnnRequestStatus;
  taskList: TsnnRequestTaskList;
  trainingCompletionDate?: Maybe<Scalars['String']['output']>;
  type: EnumTsnnRequestType;
};

/** List of items with pagination. */
export type TsnnRequestFindMany = {
  __typename?: 'TSNNRequestFindMany';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<TsnnRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TsnnRequestNote = {
  __typename?: 'TSNNRequestNote';
  by?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TsnnRequestTaskList = {
  __typename?: 'TSNNRequestTaskList';
  applicationReviewed: Scalars['Boolean']['output'];
  matchedWithEmployer: Scalars['Boolean']['output'];
  notoHasBegunWork: Scalars['Boolean']['output'];
  notoHasCompletedWork: Scalars['Boolean']['output'];
  notoJobBoardLinkShared: Scalars['Boolean']['output'];
  otecWelcomeEmailSent: Scalars['Boolean']['output'];
  sdfFormComplete: Scalars['Boolean']['output'];
  sfpParticipantRegFormComplete: Scalars['Boolean']['output'];
  trainingComplete: Scalars['Boolean']['output'];
  wageSubsidyPaid: Scalars['Boolean']['output'];
  welcomeEmailSent: Scalars['Boolean']['output'];
};

export type TsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  _id?: Maybe<Scalars['ID']['output']>;
  bundle?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Multilingual>;
  subtags?: Maybe<Array<Maybe<Tag>>>;
};

export type Tags = {
  __typename?: 'Tags';
  accreditations?: Maybe<Array<Scalars['String']['output']>>;
  amenities?: Maybe<Array<Scalars['String']['output']>>;
  capacity?: Maybe<Scalars['Int']['output']>;
  pricing?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Array<Scalars['String']['output']>>;
  type_of_operator?: Maybe<Scalars['String']['output']>;
  vtc_custom?: Maybe<Array<Scalars['String']['output']>>;
};

export type TagsInput = {
  accreditations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_of_operator?: InputMaybe<Scalars['String']['input']>;
  vtc_custom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TaxRate = {
  __typename?: 'TaxRate';
  _id: Scalars['MongoID']['output'];
  country: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  percentage: Scalars['Float']['output'];
  subdivision: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  _id?: Maybe<Scalars['ID']['output']>;
  dmo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Scalars['String']['output']>;
  registeredApps?: Maybe<Array<Maybe<App>>>;
  users?: Maybe<Array<Maybe<User>>>;
};

export enum TimePeriod {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type TimeSlot = {
  __typename?: 'TimeSlot';
  endISO: Scalars['String']['output'];
  startISO: Scalars['String']['output'];
};

export type TimeSlotInput = {
  endISO: Scalars['String']['input'];
  startISO: Scalars['String']['input'];
};

export type ToursOperatorMetadata = {
  __typename?: 'ToursOperatorMetadata';
  maxGroupSize?: Maybe<Scalars['Float']['output']>;
};

export type Tripper = {
  __typename?: 'Tripper';
  description?: Maybe<Multilingual>;
  image?: Maybe<TripperImage>;
  nid?: Maybe<Scalars['ID']['output']>;
  teamId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Multilingual>;
  type?: Maybe<TripperType>;
};

export enum TripperType {
  Atlas = 'Atlas',
  Itinerary = 'Itinerary'
}

export type UpdateByIdAccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closures?: InputMaybe<Array<InputMaybe<UpdateByIdClosureInput>>>;
  guestMetadata?: InputMaybe<UpdateByIdGuestMetadataInput>;
  maximumNights?: InputMaybe<Scalars['Int']['input']>;
  minimumNights?: InputMaybe<Scalars['Int']['input']>;
  rooms?: InputMaybe<Array<InputMaybe<UpdateByIdRoomInput>>>;
};

export type UpdateByIdAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateByIdAddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type UpdateByIdAmenityInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<UpdateByIdNewMultilingualInput>;
  type?: InputMaybe<EnumAmenityType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdAmenityPayload = {
  __typename?: 'UpdateByIdAmenityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Amenity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBookerInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  productBundles?: InputMaybe<Array<InputMaybe<UpdateByIdBookerProductBundlesInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdBookerOptionsInput = {
  cancellationPolicy?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<UpdateByIdBookerPaymentInput>;
  termsConditions?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdBookerPayload = {
  __typename?: 'UpdateByIdBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBookerPaymentInput = {
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBookerProductBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  addOns?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdContactInput = {
  address?: InputMaybe<UpdateByIdAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<UpdateByIdLinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCourseCoverImageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  full_url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCourseInput = {
  courseName?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UpdateByIdCourseCoverImageInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<EnumCoursePackageType>;
  packageUrl?: InputMaybe<Scalars['String']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeformId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdCoursePayload = {
  __typename?: 'UpdateByIdCoursePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Course>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdGuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  nameEntryRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdInventoryItemInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<UpdateByIdInventoryItemMetadataInput>;
  productID?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumInventoryItemType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdInventoryItemMetadataInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<UpdateByIdDateRangeIsoInput>>>;
  occurrence?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInventoryItemPayload = {
  __typename?: 'UpdateByIdInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLearnerActivityLogInput = {
  courseId?: InputMaybe<Scalars['MongoID']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  eventType?: InputMaybe<EnumLearnerActivityLogEventType>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorName?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['MongoID']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdLearnerActivityLogPayload = {
  __typename?: 'UpdateByIdLearnerActivityLogPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LearnerActivityLog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLegacyOperatorHours_Of_Operation_WeekInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fri?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput>;
  mon?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput>;
  sat?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput>;
  sun?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput>;
  thu?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput>;
  tue?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput>;
  wed?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput>;
};

export type UpdateByIdLegacyOperatorHours_Of_Operation_WeekSunInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLegacyOperatorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  connections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdNewMultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook_link?: InputMaybe<Scalars['String']['input']>;
  hours_of_operation_week?: InputMaybe<UpdateByIdLegacyOperatorHours_Of_Operation_WeekInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  instagram_link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateByIdLegacyOperatorLocationInput>;
  more_information?: InputMaybe<Scalars['String']['input']>;
  open_hours_option?: InputMaybe<Scalars['String']['input']>;
  operator_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest_link?: InputMaybe<Scalars['String']['input']>;
  short_description?: InputMaybe<UpdateByIdNewMultilingualInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<UpdateByIdLegacyOperatorTagsInput>;
  tiktok_link?: InputMaybe<Scalars['String']['input']>;
  tripadvisor_link?: InputMaybe<Scalars['String']['input']>;
  twitter_link?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  updated_at?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube_link?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLegacyOperatorLocationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLegacyOperatorPayload = {
  __typename?: 'UpdateByIdLegacyOperatorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<LegacyOperator>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdLegacyOperatorTagsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accreditations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  capacity?: InputMaybe<Scalars['Float']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_of_operator?: InputMaybe<Scalars['String']['input']>;
  vtc_custom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdLinksInput = {
  bookNow?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  tripAdvisor?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdListInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  listBundle?: InputMaybe<Scalars['String']['input']>;
  operatorData?: InputMaybe<Scalars['MongoID']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  publicationStatus?: InputMaybe<EnumListPublicationStatus>;
  team?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdListPayload = {
  __typename?: 'UpdateByIdListPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<List>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdMemberInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customStatus?: InputMaybe<Scalars['String']['input']>;
  customTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  owner?: InputMaybe<Scalars['JSON']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<EnumMemberStatus>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdMemberPayload = {
  __typename?: 'UpdateByIdMemberPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Member>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNewImageColorsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  predominance?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNewImageInput = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<UpdateByIdNewMultilingualInput>;
  colors?: InputMaybe<Array<InputMaybe<UpdateByIdNewImageColorsInput>>>;
  /**
   * Currently, our schema only supports facial and text detection, using the built-in Cloudinary AI Content Analysis face detection, and the `cld-text` model. Therefore, the fields returned in `detectedObjects` will be limited to *optional* `humanFace` and `text` fields which are of `IDetectedObject[]` type.
   *
   * &nbsp;
   *
   * `IDetectedObject` contains a `boundingBox` array of `numbers`, a `categories` array of `string`s, and a `number` `confidence` value.
   *
   * &nbsp;
   *
   * ```json
   * interface IDetectedObject extends Document {
   *   boundingBox: number[];
   *   categories: string[];
   *   confidence: number;
   * }
   * ```
   */
  detectedObjects?: InputMaybe<Scalars['JSON']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNewImagePayload = {
  __typename?: 'UpdateByIdNewImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NewImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNewMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNewNoteInput = {
  author?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  member?: InputMaybe<Scalars['MongoID']['input']>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNewNotePayload = {
  __typename?: 'UpdateByIdNewNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NewNote>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNewOccurrenceInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  endDateISO?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['MongoID']['input']>;
  startDateISO?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNewOccurrencePayload = {
  __typename?: 'UpdateByIdNewOccurrencePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NewOccurrence>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNewOperatorInput = {
  accommodationMetadata?: InputMaybe<UpdateByIdAccommodationOperatorMetadataInput>;
  bookerOptions?: InputMaybe<UpdateByIdBookerOptionsInput>;
  contact?: InputMaybe<UpdateByIdContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdNewMultilingualInput>;
  experienceMetadata?: InputMaybe<UpdateByIdExperienceOperatorMetadataInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening?: InputMaybe<UpdateByIdOpeningInput>;
  pricing?: InputMaybe<EnumNewOperatorPricing>;
  restaurantMetadata?: InputMaybe<UpdateByIdRestaurantOperatorMetadataInput>;
  serviceMetadata?: InputMaybe<UpdateByIdServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<UpdateByIdNewMultilingualInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tenantsOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toursMetadata?: InputMaybe<UpdateByIdToursOperatorMetadataInput>;
  type?: InputMaybe<EnumNewOperatorType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNewOperatorPayload = {
  __typename?: 'UpdateByIdNewOperatorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NewOperator>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNewOrgCustomTagsInput = {
  memberTags?: InputMaybe<Array<InputMaybe<UpdateByIdNewOrgCustomTagsNoteTagsInput>>>;
  noteTags?: InputMaybe<Array<InputMaybe<UpdateByIdNewOrgCustomTagsNoteTagsInput>>>;
};

export type UpdateByIdNewOrgCustomTagsNoteTagsInput = {
  _id: Scalars['MongoID']['input'];
  name: NewMultilingualInput;
};

export type UpdateByIdNewOrgInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customTags?: InputMaybe<UpdateByIdNewOrgCustomTagsInput>;
  membershipSettings?: InputMaybe<UpdateByIdNewOrgMembershipSettingsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNewOrgMembershipSettingsCustomViewsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchField?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdNewOrgMembershipSettingsDuesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<InputMaybe<UpdateByIdNewOrgMembershipSettingsDuesTiersInput>>>;
};

export type UpdateByIdNewOrgMembershipSettingsDuesTiersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNewOrgMembershipSettingsInput = {
  customViews?: InputMaybe<Array<InputMaybe<UpdateByIdNewOrgMembershipSettingsCustomViewsInput>>>;
  dues?: InputMaybe<UpdateByIdNewOrgMembershipSettingsDuesInput>;
};

export type UpdateByIdNewOrgPayload = {
  __typename?: 'UpdateByIdNewOrgPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NewOrg>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNewTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<UpdateByIdNewMultilingualInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNewTagPayload = {
  __typename?: 'UpdateByIdNewTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NewTag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdOpeningInput = {
  hoursOfOperation?: InputMaybe<Array<InputMaybe<UpdateByIdDateRangeIsoInput>>>;
  seasonality?: InputMaybe<Array<InputMaybe<EnumOpeningSeasonality>>>;
  source?: InputMaybe<EnumOpeningSource>;
};

export type UpdateByIdOrderPayload = {
  __typename?: 'UpdateByIdOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdPersonInput = {
  accountStatus?: InputMaybe<EnumPersonAccountStatus>;
  address?: InputMaybe<UpdateByIdAddressInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolledThrough?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<UpdateByIdPersonLearnerInput>;
  tenantsOf?: InputMaybe<Array<InputMaybe<UpdateByIdPersonTenantsOfInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPersonLearnerCoursesInput = {
  completedDate?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  lastAccessDate?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumPersonLearnerCoursesStatus>;
  suspendData?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdPersonLearnerInput = {
  courses?: InputMaybe<Array<InputMaybe<UpdateByIdPersonLearnerCoursesInput>>>;
  stats?: InputMaybe<UpdateByIdPersonLearnerStatsInput>;
};

export type UpdateByIdPersonLearnerStatsInput = {
  startDate?: InputMaybe<Scalars['String']['input']>;
  totalCoursesCompleted?: InputMaybe<Scalars['Float']['input']>;
  totalCoursesStarted?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPersonPayload = {
  __typename?: 'UpdateByIdPersonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Person>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPersonTenantsOfInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorRef?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<EnumPersonTenantsOfRole>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdPriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<UpdateByIdNewMultilingualInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumPriceTierType>;
};

export type UpdateByIdPricingInput = {
  description?: InputMaybe<UpdateByIdNewMultilingualInput>;
  tiers?: InputMaybe<Array<InputMaybe<UpdateByIdPriceTierInput>>>;
};

export type UpdateByIdProductInput = {
  accommodationMetadata?: InputMaybe<UpdateByIdAccommodationProductMetadataInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdNewMultilingualInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsellOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdNewMultilingualInput>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  pricing?: InputMaybe<UpdateByIdPricingInput>;
  publishingStatus?: InputMaybe<EnumProductPublishingStatus>;
  shortDescription?: InputMaybe<UpdateByIdNewMultilingualInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  taxRate?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumProductType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProductPayload = {
  __typename?: 'UpdateByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdRefundInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  orderID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRefundStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdRefundPayload = {
  __typename?: 'UpdateByIdRefundPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Refund>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdRestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumRoomType>;
};

export type UpdateByIdServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdSiteInput = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  lists?: InputMaybe<Array<InputMaybe<UpdateByIdSiteListsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  whereaboutsSite?: InputMaybe<UpdateByIdSiteWhereaboutsSiteInput>;
};

export type UpdateByIdSiteListsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdSitePayload = {
  __typename?: 'UpdateByIdSitePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Site>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSiteWhereaboutsSiteInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  siteTemplate?: InputMaybe<EnumSiteWhereaboutsSiteSiteTemplate>;
  siteType?: InputMaybe<EnumSiteWhereaboutsSiteSiteType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTsnnRequestInput = {
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<UpdateByIdTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<UpdateByIdTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type UpdateByIdTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTsnnRequestPayload = {
  __typename?: 'UpdateByIdTSNNRequestPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TsnnRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdTaxRateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTaxRatePayload = {
  __typename?: 'UpdateByIdTaxRatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TaxRate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEventAdminZoneInput = {
  _id: Scalars['ID']['input'];
  note?: InputMaybe<NoteEventInput>;
  submitStatus?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventAdminZoneResponse = {
  __typename?: 'UpdateEventAdminZoneResponse';
  _id: Scalars['ID']['output'];
};

export type UpdateEventInput = {
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
};

export type UpdateEventOccurrenceVariables = {
  eventId: Scalars['ID']['input'];
  occurrenceId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateOccurrence>;
};

export type UpdateEventVariables = {
  _id: Scalars['ID']['input'];
  event: UpdateEventInput;
};

export type UpdateManyTsnnRequestInput = {
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<UpdateManyTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<UpdateManyTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type UpdateManyTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyTsnnRequestPayload = {
  __typename?: 'UpdateManyTSNNRequestPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOccurrence = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ScheduleType>;
};

export type UpdateOneTsnnRequestInput = {
  matchedToOperator?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<UpdateOneTsnnRequestNoteInput>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  requestBody?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumTsnnRequestStatus>;
  taskList?: InputMaybe<UpdateOneTsnnRequestTaskListInput>;
  trainingCompletionDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTsnnRequestType>;
};

export type UpdateOneTsnnRequestNoteInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneTsnnRequestPayload = {
  __typename?: 'UpdateOneTSNNRequestPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TsnnRequest>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneTsnnRequestTaskListInput = {
  applicationReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  matchedWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasBegunWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoHasCompletedWork?: InputMaybe<Scalars['Boolean']['input']>;
  notoJobBoardLinkShared?: InputMaybe<Scalars['Boolean']['input']>;
  otecWelcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  sdfFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  sfpParticipantRegFormComplete?: InputMaybe<Scalars['Boolean']['input']>;
  trainingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  wageSubsidyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOperatorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  checklist?: InputMaybe<ChecklistInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  connections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<MultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook_link?: InputMaybe<Scalars['String']['input']>;
  google_mybusiness_link?: InputMaybe<Scalars['String']['input']>;
  hours_of_operation_week?: InputMaybe<HoursOfOperationInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  instagram_link?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line_1?: InputMaybe<Scalars['String']['input']>;
  line_2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  markAsNeedsAttention?: InputMaybe<Scalars['Boolean']['input']>;
  more_info_link?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<NoteInput>;
  open_hours_option?: InputMaybe<Scalars['String']['input']>;
  operator_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest_link?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  publishingOptions?: InputMaybe<Scalars['String']['input']>;
  seasonality?: InputMaybe<SeasonalityInput>;
  short_description?: InputMaybe<MultilingualInput>;
  sta_license_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagsInput>;
  tiktok_link?: InputMaybe<Scalars['String']['input']>;
  tripadvisor_link?: InputMaybe<Scalars['String']['input']>;
  up_to_date_source?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube_link?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type VtcTag = {
  __typename?: 'VtcTag';
  _id: Scalars['ID']['output'];
  bundle?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Multilingual>;
};

export enum Weekday {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export type CancelAllEventOccurrencesResponse = {
  __typename?: 'cancelAllEventOccurrencesResponse';
  _id: Scalars['ID']['output'];
};

export type CreateEventImageInput = {
  _id: Scalars['ID']['input'];
  caption?: InputMaybe<CaptionInput>;
  metadata?: InputMaybe<EventImageMetadata>;
  url: Scalars['String']['input'];
};

export type CreateEventImageResponse = {
  __typename?: 'createEventImageResponse';
  _id: Scalars['ID']['output'];
};

export type CreateOperatorImageInput = {
  _id: Scalars['ID']['input'];
  caption?: InputMaybe<CaptionInput>;
  url: Scalars['String']['input'];
};

export type CreateOperatorImageResponse = {
  __typename?: 'createOperatorImageResponse';
  _id: Scalars['ID']['output'];
};

export type DeleteEventImageInput = {
  _id: Scalars['ID']['input'];
  image: ImageInput;
};

export type DeleteEventImageResponse = {
  __typename?: 'deleteEventImageResponse';
  _id: Scalars['ID']['output'];
};

export type DeleteEventOccurrenceInput = {
  eventId: Scalars['ID']['input'];
  occurrenceId: Scalars['ID']['input'];
};

export type DeleteEventResponse = {
  __typename?: 'deleteEventResponse';
  _id: Scalars['ID']['output'];
};

export type DeleteOperatorResponse = {
  __typename?: 'deleteOperatorResponse';
  _id: Scalars['ID']['output'];
};

export type GenerateOperatorOtpResponse = {
  __typename?: 'generateOperatorOTPResponse';
  _id: Scalars['ID']['output'];
};

export type RemoveManyFromTenantResponse = {
  __typename?: 'removeManyFromTenantResponse';
  _ids: Array<Scalars['ID']['output']>;
};

export type SendEmailInput = {
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  linkURL?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type SendEmailResponse = {
  __typename?: 'sendEmailResponse';
  messageBody?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type TripperImage = {
  __typename?: 'tripperImage';
  image?: Maybe<Scalars['String']['output']>;
  image2x?: Maybe<Scalars['String']['output']>;
};

export type TripperMultilingual = {
  __typename?: 'tripperMultilingual';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UpdateEventDetailsInput = {
  _id: Scalars['ID']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  customVtcTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<MultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  facebook_link?: InputMaybe<Scalars['String']['input']>;
  instagram_link?: InputMaybe<Scalars['String']['input']>;
  more_info_link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operator_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pinterest_link?: InputMaybe<Scalars['String']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  short_description?: InputMaybe<MultilingualInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube_link?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventDetailsResponse = {
  __typename?: 'updateEventDetailsResponse';
  _id: Scalars['ID']['output'];
};

export type UpdateEventImageInput = {
  _id: Scalars['ID']['input'];
  image: ImageInput;
};

export type UpdateEventImageResponse = {
  __typename?: 'updateEventImageResponse';
  _id: Scalars['ID']['output'];
};

export type UpdateEventImagesInput = {
  images: Array<Scalars['MongoID']['input']>;
};

export type UpdateEventImagesResponse = {
  __typename?: 'updateEventImagesResponse';
  _id: Scalars['ID']['output'];
};

export type UpdateManyOperatorsInput = {
  ids: Array<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateManyOperatorsResponse = {
  __typename?: 'updateManyOperatorsResponse';
  _ids: Array<Scalars['ID']['output']>;
};

export type ValidateOperatorOtpInput = {
  code: Scalars['String']['input'];
  operatorId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};

export type ValidateOperatorOtpResponse = {
  __typename?: 'validateOperatorOTPResponse';
  _id: Scalars['ID']['output'];
};

export type GetTsnnRequestByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetTsnnRequestByIdQuery = { __typename?: 'Query', tsnnRequestById?: { __typename?: 'TSNNRequest', _id: any, name?: string | null, type: EnumTsnnRequestType, status: EnumTsnnRequestStatus, requestBody?: any | null, operatorID: any, matchedToOperator?: any | null, trainingCompletionDate?: string | null, taskList: { __typename?: 'TSNNRequestTaskList', applicationReviewed: boolean, matchedWithEmployer: boolean, notoHasBegunWork: boolean, notoHasCompletedWork: boolean, notoJobBoardLinkShared: boolean, otecWelcomeEmailSent: boolean, sdfFormComplete: boolean, trainingComplete: boolean, wageSubsidyPaid: boolean, welcomeEmailSent: boolean }, note?: { __typename?: 'TSNNRequestNote', text?: string | null, by?: string | null, createdAt?: string | null } | null } | null };

export type GetTsnnRequestsQueryVariables = Exact<{
  type?: InputMaybe<EnumTsnnRequestType>;
  operatorID?: InputMaybe<Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTsnnRequestsQuery = { __typename?: 'Query', tsnnRequestMany?: { __typename?: 'TSNNRequestFindMany', count?: number | null, items?: Array<{ __typename?: 'TSNNRequest', _id: any, name?: string | null, type: EnumTsnnRequestType, status: EnumTsnnRequestStatus, requestBody?: any | null, operatorID: any, matchedToOperator?: any | null, trainingCompletionDate?: string | null, taskList: { __typename?: 'TSNNRequestTaskList', applicationReviewed: boolean, matchedWithEmployer: boolean, notoHasBegunWork: boolean, notoHasCompletedWork: boolean, notoJobBoardLinkShared: boolean, otecWelcomeEmailSent: boolean, sdfFormComplete: boolean, trainingComplete: boolean, wageSubsidyPaid: boolean, welcomeEmailSent: boolean }, note?: { __typename?: 'TSNNRequestNote', text?: string | null, by?: string | null, createdAt?: string | null } | null }> | null } | null };

export type CreateTsnnRequestMutationVariables = Exact<{
  record: CreateOneTsnnRequestInput;
}>;


export type CreateTsnnRequestMutation = { __typename?: 'Mutation', tsnnRequestCreate?: { __typename?: 'CreateOneTSNNRequestPayload', recordId?: any | null, record?: { __typename?: 'TSNNRequest', _id: any, name?: string | null, type: EnumTsnnRequestType, status: EnumTsnnRequestStatus, requestBody?: any | null, operatorID: any, matchedToOperator?: any | null, trainingCompletionDate?: string | null, taskList: { __typename?: 'TSNNRequestTaskList', applicationReviewed: boolean, matchedWithEmployer: boolean, notoHasBegunWork: boolean, notoHasCompletedWork: boolean, notoJobBoardLinkShared: boolean, otecWelcomeEmailSent: boolean, sdfFormComplete: boolean, sfpParticipantRegFormComplete: boolean, trainingComplete: boolean, wageSubsidyPaid: boolean, welcomeEmailSent: boolean }, note?: { __typename?: 'TSNNRequestNote', text?: string | null, by?: string | null, createdAt?: string | null } | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type UpdateTsnnRequestStatusMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  record: UpdateManyTsnnRequestInput;
  tsnnRequestUpdateManyFilter2?: InputMaybe<FilterUpdateManyTsnnRequestInput>;
}>;


export type UpdateTsnnRequestStatusMutation = { __typename?: 'Mutation', tsnnRequestUpdateMany?: { __typename?: 'UpdateManyTSNNRequestPayload', numAffected?: number | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type UpdateTsnnRequestByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTsnnRequestInput;
}>;


export type UpdateTsnnRequestByIdMutation = { __typename?: 'Mutation', tsnnRequestUpdateById?: { __typename?: 'UpdateByIdTSNNRequestPayload', recordId?: any | null, record?: { __typename?: 'TSNNRequest', _id: any, name?: string | null, type: EnumTsnnRequestType, status: EnumTsnnRequestStatus, requestBody?: any | null, operatorID: any, matchedToOperator?: any | null, trainingCompletionDate?: string | null, taskList: { __typename?: 'TSNNRequestTaskList', applicationReviewed: boolean, matchedWithEmployer: boolean, notoHasBegunWork: boolean, notoHasCompletedWork: boolean, notoJobBoardLinkShared: boolean, otecWelcomeEmailSent: boolean, sdfFormComplete: boolean, trainingComplete: boolean, wageSubsidyPaid: boolean, welcomeEmailSent: boolean }, note?: { __typename?: 'TSNNRequestNote', text?: string | null, by?: string | null, createdAt?: string | null } | null } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type AnalyzeLearnerReportMutationVariables = Exact<{
  input: SummaryInput;
}>;


export type AnalyzeLearnerReportMutation = { __typename?: 'Mutation', analyzeLearnerReport: { __typename?: 'SummaryResponse', response: string } };

export type BookerCreateMutationVariables = Exact<{
  record: CreateOneBookerInput;
}>;


export type BookerCreateMutation = { __typename?: 'Mutation', bookerCreate?: { __typename?: 'CreateOneBookerPayload', recordId?: any | null } | null };

export type BookerUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdBookerInput;
}>;


export type BookerUpdateMutation = { __typename?: 'Mutation', bookerUpdate?: { __typename?: 'UpdateByIdBookerPayload', recordId?: any | null } | null };

export type CancelAllEventOccurrencesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelAllEventOccurrencesMutation = { __typename?: 'Mutation', cancelAllEventOccurrences: { __typename?: 'cancelAllEventOccurrencesResponse', _id: string } };

export type CreateClosuresPerProductMutationVariables = Exact<{
  productIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  name: Scalars['String']['input'];
  startIso: Scalars['String']['input'];
  endIso: Scalars['String']['input'];
}>;


export type CreateClosuresPerProductMutation = { __typename?: 'Mutation', createClosuresPerProduct: Array<string> };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'CreateEvent', _id: string, name: string, status?: string | null, operatorId: string } };

export type CreateEventImageMutationVariables = Exact<{
  input: CreateEventImageInput;
}>;


export type CreateEventImageMutation = { __typename?: 'Mutation', createEventImage: { __typename?: 'createEventImageResponse', _id: string } };

export type CreateOperatorMutationVariables = Exact<{
  input: CreateOperatorInput;
}>;


export type CreateOperatorMutation = { __typename?: 'Mutation', createOperator: { __typename?: 'CreateOperatorResponse', _id: string } };

export type CreateOperatorImageMutationVariables = Exact<{
  input: CreateOperatorImageInput;
}>;


export type CreateOperatorImageMutation = { __typename?: 'Mutation', createOperatorImage: { __typename?: 'createOperatorImageResponse', _id: string } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserResponse', code?: number | null, message?: string | null, success?: boolean | null } };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: { __typename?: 'deleteEventResponse', _id: string } };

export type DeleteEventImageMutationVariables = Exact<{
  input: DeleteEventImageInput;
}>;


export type DeleteEventImageMutation = { __typename?: 'Mutation', deleteEventImage: { __typename?: 'deleteEventImageResponse', _id: string } };

export type DeleteEventOccurrenceMutationVariables = Exact<{
  input: DeleteEventOccurrenceInput;
}>;


export type DeleteEventOccurrenceMutation = { __typename?: 'Mutation', deleteEventOccurrence: { __typename?: 'Event', _id: string } };

export type DeleteFormResponseMutationVariables = Exact<{
  input: DeleteFormResponseInput;
}>;


export type DeleteFormResponseMutation = { __typename?: 'Mutation', deleteFormResponse: { __typename?: 'DeleteFormResponseResponse', _id: string } };

export type DeleteOperatorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOperatorMutation = { __typename?: 'Mutation', deleteOperator: { __typename?: 'deleteOperatorResponse', _id: string } };

export type GenerateOperatorOtpMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenerateOperatorOtpMutation = { __typename?: 'Mutation', generateOperatorOTP: { __typename?: 'generateOperatorOTPResponse', _id: string } };

export type GenerateSummaryMutationVariables = Exact<{
  input: SummaryInput;
}>;


export type GenerateSummaryMutation = { __typename?: 'Mutation', summarize: { __typename?: 'SummaryResponse', response: string } };

export type ImageCreateMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
  entityType: Entity;
  entityId: Scalars['MongoID']['input'];
}>;


export type ImageCreateMutation = { __typename?: 'Mutation', imageCreate?: { __typename?: 'CreateOneNewImagePayload', recordId?: any | null } | null };

export type ImageRemoveMutationVariables = Exact<{
  entityType: Entity;
  entityId: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterRemoveOneNewImageInput>;
}>;


export type ImageRemoveMutation = { __typename?: 'Mutation', imageRemove?: { __typename?: 'RemoveOneNewImagePayload', recordId?: any | null } | null };

export type ImageSortOrderMutationVariables = Exact<{
  images: Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>;
  entityType: Entity;
  entityId: Scalars['MongoID']['input'];
}>;


export type ImageSortOrderMutation = { __typename?: 'Mutation', imageSortOrder: Array<any | null> };

export type ImageUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdNewImageInput;
}>;


export type ImageUpdateMutation = { __typename?: 'Mutation', imageUpdate?: { __typename?: 'UpdateByIdNewImagePayload', recordId?: any | null } | null };

export type IntegrateProductCalendarLinksByProductIdsMutationVariables = Exact<{
  calendarLinksByProductIDs: Array<CalendarLinksByProductId> | CalendarLinksByProductId;
}>;


export type IntegrateProductCalendarLinksByProductIdsMutation = { __typename?: 'Mutation', integrateProductCalendarLinksByProductIds: { __typename?: 'IntegrateCalendarLinksByProductIds', updatedInventoryClaimItems: Array<{ __typename?: 'InventoryItem', _id: any, metadata: { __typename?: 'InventoryItemMetadata', claimedDateRangesISO?: Array<{ __typename?: 'DateRangeISO', metadata?: string | null, start: string, end: string } | null> | null } }>, releasedInventoryClaimItems: Array<{ __typename?: 'InventoryItem', _id: any, metadata: { __typename?: 'InventoryItemMetadata', claimedDateRangesISO?: Array<{ __typename?: 'DateRangeISO', metadata?: string | null, end: string, start: string } | null> | null } }>, products: Array<{ __typename?: 'Product', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null }, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', calendarLinks?: Array<string | null> | null, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', start: string, _id: any, end: string } } | null> } | null }> } };

export type InventoryUpdateClaimedDatesByOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  startIso: Scalars['String']['input'];
  endIso: Scalars['String']['input'];
}>;


export type InventoryUpdateClaimedDatesByOrderMutation = { __typename?: 'Mutation', inventoryUpdateClaimedDatesByOrder?: { __typename?: 'Order', _id: string } | null };

export type LearnerActivityLogCreateMutationVariables = Exact<{
  record: CreateOneLearnerActivityLogInput;
}>;


export type LearnerActivityLogCreateMutation = { __typename?: 'Mutation', learnerActivityLogCreate?: { __typename?: 'CreateOneLearnerActivityLogPayload', recordId?: any | null, record?: { __typename?: 'LearnerActivityLog', createdDateISO?: any | null } | null } | null };

export type MemberUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdMemberInput;
}>;


export type MemberUpdateMutation = { __typename?: 'Mutation', memberUpdate?: { __typename?: 'UpdateByIdMemberPayload', recordId?: any | null } | null };

export type OperatorConnectStripeAccountMutationVariables = Exact<{
  operatorId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
}>;


export type OperatorConnectStripeAccountMutation = { __typename?: 'Mutation', operatorConnectStripeAccount?: { __typename?: 'OperatorConnectStripeReturn', link: string, record?: { __typename?: 'NewOperator', _id: any } | null } | null };

export type OperatorDisconnectStripeAccountMutationVariables = Exact<{
  operatorId: Scalars['ID']['input'];
}>;


export type OperatorDisconnectStripeAccountMutation = { __typename?: 'Mutation', operatorDisconnectStripeAccount?: { __typename?: 'NewOperator', _id: any } | null };

export type OperatorUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdNewOperatorInput;
}>;


export type OperatorUpdateMutation = { __typename?: 'Mutation', operatorUpdate?: { __typename?: 'UpdateByIdNewOperatorPayload', record?: { __typename?: 'NewOperator', _id: any, bookerOptions?: { __typename?: 'BookerOptions', cancellationPolicy?: string | null, termsConditions?: string | null, payment?: { __typename?: 'BookerPayment', taxPercentage?: number | null, applicationPercentage: number } | null } | null } | null } | null };

export type OrderCreateMutationVariables = Exact<{
  source: OrderSourceInput;
  customerContact: CustomerContactInput;
  paymentMethodId: Scalars['String']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>> | InputMaybe<ProductPurchaseRequest>;
}>;


export type OrderCreateMutation = { __typename?: 'Mutation', orderCreate?: { __typename?: 'CreateOneOrderPayload', recordId?: string | null } | null };

export type OrderUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  cancelled: Scalars['Boolean']['input'];
}>;


export type OrderUpdateMutation = { __typename?: 'Mutation', orderUpdate?: { __typename?: 'UpdateByIdOrderPayload', recordId?: string | null } | null };

export type PersonCourseUpdateMutationVariables = Exact<{
  input?: InputMaybe<PersonCoursesUpdateInput>;
}>;


export type PersonCourseUpdateMutation = { __typename?: 'Mutation', personCoursesUpdate?: { __typename?: 'PersonCoursesUpdateResult', _id: string } | null };

export type ProductCreateMutationVariables = Exact<{
  record: CreateOneProductInput;
  inventoryCount: Scalars['Int']['input'];
}>;


export type ProductCreateMutation = { __typename?: 'Mutation', productCreate?: { __typename?: 'CreateOneProductPayload', recordId?: any | null, record?: { __typename?: 'Product', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type ProductUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProductInput;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', productUpdate?: { __typename?: 'UpdateByIdProductPayload', recordId?: any | null, record?: { __typename?: 'Product', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type RefundCreateMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
}>;


export type RefundCreateMutation = { __typename?: 'Mutation', refundCreate?: { __typename?: 'CreateOneRefundPayload', record?: { __typename?: 'Refund', _id: string, amount: number, createdDateISO?: any | null, orderID: string, status: EnumRefundStatus, updatedDateISO?: any | null } | null } | null };

export type RemoveManyFromTenantMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tenants?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveManyFromTenantMutation = { __typename?: 'Mutation', removeManyFromTenant: { __typename?: 'removeManyFromTenantResponse', _ids: Array<string> } };

export type SendEmailMutationVariables = Exact<{
  input: SendEmailInput;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', sendEmail: { __typename?: 'sendEmailResponse', to?: string | null } };

export type SetOperatorAsPermanentlyClosedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetOperatorAsPermanentlyClosedMutation = { __typename?: 'Mutation', setOperatorAsPermanentlyClosed: { __typename?: 'SetOperatorAsPermanentlyClosedResponse', _id: string } };

export type SiteByOperatorIdQueryVariables = Exact<{
  input?: InputMaybe<SiteByOperatorIdInput>;
}>;


export type SiteByOperatorIdQuery = { __typename?: 'Query', siteByOperatorId?: { __typename?: 'SiteByOperatorIdResponse', _id: string, siteId: string, url: string, status?: string | null, createdAt: string, updatedAt: string } | null };

export type SiteDeployMutationVariables = Exact<{
  input?: InputMaybe<SiteDeployInput>;
}>;


export type SiteDeployMutation = { __typename?: 'Mutation', siteDeploy?: { __typename?: 'SiteDeployResponse', _id: string, url: string, branch: string } | null };

export type SubmitEventForApprovalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubmitEventForApprovalMutation = { __typename?: 'Mutation', submitEventForApproval: { __typename?: 'SubmitEventForApprovalResponse', _id: string } };

export type UpdateClosuresPerProductMutationVariables = Exact<{
  closureId: Scalars['ID']['input'];
  deleteClosure: Scalars['Boolean']['input'];
  productIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startIso?: InputMaybe<Scalars['String']['input']>;
  endIso?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateClosuresPerProductMutation = { __typename?: 'Mutation', updateClosuresPerProduct: Array<string> };

export type UpdateEventAdminZoneMutationVariables = Exact<{
  input: UpdateEventAdminZoneInput;
}>;


export type UpdateEventAdminZoneMutation = { __typename?: 'Mutation', updateEventAdminZone: { __typename?: 'UpdateEventAdminZoneResponse', _id: string } };

export type UpdateEventDetailsMutationVariables = Exact<{
  input: UpdateEventDetailsInput;
}>;


export type UpdateEventDetailsMutation = { __typename?: 'Mutation', updateEventDetails: { __typename?: 'updateEventDetailsResponse', _id: string } };

export type UpdateEventImageMutationVariables = Exact<{
  input: UpdateEventImageInput;
}>;


export type UpdateEventImageMutation = { __typename?: 'Mutation', updateEventImage: { __typename?: 'updateEventImageResponse', _id: string } };

export type UpdateEventImagesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  record: UpdateEventImagesInput;
}>;


export type UpdateEventImagesMutation = { __typename?: 'Mutation', updateEventImages: { __typename?: 'updateEventImagesResponse', _id: string } };

export type UpdateManyOperatorsMutationVariables = Exact<{
  input: UpdateManyOperatorsInput;
}>;


export type UpdateManyOperatorsMutation = { __typename?: 'Mutation', updateManyOperators: { __typename?: 'updateManyOperatorsResponse', _ids: Array<string> } };

export type ValidateOperatorOtpMutationVariables = Exact<{
  input: ValidateOperatorOtpInput;
}>;


export type ValidateOperatorOtpMutation = { __typename?: 'Mutation', validateOperatorOTP: { __typename?: 'validateOperatorOTPResponse', _id: string } };

export type ProductManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyProductInput>;
}>;


export type ProductManyQuery = { __typename?: 'Query', productMany: Array<{ __typename?: 'Product', _id: any, type: EnumProductType, isActive: boolean, isUpsellOnly: boolean, publishingStatus: EnumProductPublishingStatus, operator: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null }>, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', calendarLinks?: Array<string | null> | null, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', start: string, _id: any, end: string } } | null> } | null, pricing: { __typename?: 'Pricing', tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number } | null>, description?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null, es?: string | null } | null }, description?: { __typename?: 'NewMultilingual', en?: string | null } | null }> };

export type AmenityByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type AmenityByIdsQuery = { __typename?: 'Query', amenityByIds: Array<{ __typename?: 'Amenity', type: EnumAmenityType, _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type AmenityManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyAmenityInput>;
}>;


export type AmenityManyQuery = { __typename?: 'Query', amenityMany: Array<{ __typename?: 'Amenity', _id: any, type: EnumAmenityType, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type BookerByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type BookerByIdQuery = { __typename?: 'Query', bookerById?: { __typename?: 'Booker', _id: any, operator?: { __typename?: 'NewOperator', _id: any } | null, productBundles: Array<{ __typename?: 'BookerProductBundles', addOns?: Array<any | null> | null, _id?: any | null, product?: { __typename?: 'Product', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null };

export type BookerByMainProductIdQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  operatorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BookerByMainProductIdQuery = { __typename?: 'Query', bookerByMainProductId?: { __typename?: 'Booker', _id: any, productBundles: Array<{ __typename?: 'BookerProductBundles', addOns?: Array<any | null> | null, _id?: any | null, product?: { __typename?: 'Product', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null } } | null } | null>, operator?: { __typename?: 'NewOperator', _id: any, name: string } | null } | null };

export type BookerCartPriceQueryVariables = Exact<{
  bookerId: Scalars['ID']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>> | InputMaybe<ProductPurchaseRequest>;
}>;


export type BookerCartPriceQuery = { __typename?: 'Query', bookerCartPrice?: { __typename?: 'CartPrices', grandTotal: number, subTotal: number, taxTotal: number, productPrices: Array<{ __typename?: 'PricePerProduct', price: number, productID: string }> } | null };

export type BookerSendContactUsEmailQueryVariables = Exact<{
  operatorId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  details: ContactUsEmailDetails;
}>;


export type BookerSendContactUsEmailQuery = { __typename?: 'Query', bookerSendContactUsEmail?: { __typename?: 'EmailResponse', message: string, success: boolean } | null };

export type AdminZoneEventFragment = { __typename?: 'Event', _id: string, status: string, submitStatus?: EventSubmitStatus | null, publishingOption?: string | null, note?: { __typename?: 'NoteEvent', text?: string | null, by?: string | null, isPublic?: boolean | null, createdAt?: number | null } | null };

export type GetAdminZoneEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAdminZoneEventQuery = { __typename?: 'Query', getAdminZoneEvent?: { __typename?: 'Event', _id: string, status: string, submitStatus?: EventSubmitStatus | null, publishingOption?: string | null, note?: { __typename?: 'NoteEvent', text?: string | null, by?: string | null, isPublic?: boolean | null, createdAt?: number | null } | null } | null };

export type GetCoursesByQueryVariables = Exact<{
  input?: InputMaybe<CoursesByInput>;
}>;


export type GetCoursesByQuery = { __typename?: 'Query', coursesBy?: Array<{ __typename?: 'Course', courseName?: string | null, slug?: string | null, packageType: EnumCoursePackageType, packageUrl?: string | null, typeformId?: string | null, pdfUrl?: string | null, description?: string | null, tenantsOf: Array<string | null>, _id: any, createdDateISO?: any | null, updatedDateISO?: any | null, coverImage?: { __typename?: 'CourseCoverImage', full_url?: string | null, _id?: any | null } | null } | null> | null };

export type GetEventDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventDetailsQuery = { __typename?: 'Query', getEvent?: { __typename?: 'Event', _id: string, name: string, externalUrl?: string | null, pricing?: string | null, more_info_link?: string | null, tags?: Array<string> | null, customVtcTags?: Array<string> | null, status: string, createdAt: number, updatedAt: number, operatorId: string, submitStatus?: EventSubmitStatus | null, description?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null } | null, short_description?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null } | null, images?: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, teaser_url?: string | null, teaser_url_x2?: string | null, thumbnail_url?: string | null, thumbnail_url_x2?: string | null, blurhash: string, caption?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } | null }> | null, operator?: { __typename?: 'OperatorEvent', operator_name?: string | null, address?: string | null, website?: string | null, email?: string | null, phone?: string | null, facebook_link?: string | null, instagram_link?: string | null, youtube_link?: string | null, pinterest_link?: string | null } | null, occurrences?: Array<{ __typename?: 'Occurrence', _id: string, startDateTime: string, endDateTime?: string | null, isActive: boolean, note?: string | null, type?: ScheduleType | null } | null> | null, schedule?: { __typename?: 'Schedule', day?: number | null, endDateTime?: string | null, interval?: number | null, month?: number | null, occurrences?: number | null, repeat?: RepeatType | null, startDateTime?: string | null, type: ScheduleType, weekdays?: Array<Weekday | null> | null, occurrenceEndDate?: string | null, timeSlots?: Array<{ __typename?: 'TimeSlot', endISO: string, startISO: string } | null> | null } | null } | null };

export type GetEventDetailsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventDetailsOptionsQuery = { __typename?: 'Query', getEventDetailsOptions?: { __typename?: 'EventDetailsOptions', customVtcTags?: Array<{ __typename?: 'VtcTag', _id: string, bundle?: string | null, label?: { __typename?: 'Multilingual', en?: string | null } | null }> | null } | null };

export type GetEventImagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventImagesQuery = { __typename?: 'Query', getEvent?: { __typename?: 'Event', _id: string, images?: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, teaser_url?: string | null, teaser_url_x2?: string | null, thumbnail_url?: string | null, thumbnail_url_x2?: string | null, blurhash: string, caption?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } | null }> | null } | null };

export type GetEventsQueryVariables = Exact<{
  input?: InputMaybe<GetEventsInput>;
}>;


export type GetEventsQuery = { __typename?: 'Query', getEvents: Array<{ __typename?: 'Event', _id: string, name: string, status: string, submitStatus?: EventSubmitStatus | null, operator?: { __typename?: 'OperatorEvent', operator_name?: string | null } | null, images?: Array<{ __typename?: 'NewImage', full_url?: string | null }> | null, schedule?: { __typename?: 'Schedule', startDateTime?: string | null, endDateTime?: string | null, occurrenceEndDate?: string | null } | null, occurrences?: Array<{ __typename?: 'Occurrence', _id: string, startDateTime: string, endDateTime?: string | null, isActive: boolean, note?: string | null, type?: ScheduleType | null } | null> | null, nextOccurrence?: { __typename?: 'Occurrence', _id: string, startDateTime: string, endDateTime?: string | null, isActive: boolean, note?: string | null, type?: ScheduleType | null } | null }> };

export type GetEventsByQueryVariables = Exact<{
  input?: InputMaybe<GetEventsGroupByPeriodInput>;
}>;


export type GetEventsByQuery = { __typename?: 'Query', getEventsGroupByPeriod: { __typename?: 'GetEventsGroupByPeriodResponse', count: number, periods: Array<{ __typename?: 'EventsPeriod', year?: number | null, month?: number | null, week?: number | null, events: Array<{ __typename?: 'Event', _id: string, name: string, status: string, submitStatus?: EventSubmitStatus | null, operator?: { __typename?: 'OperatorEvent', operator_name?: string | null } | null, images?: Array<{ __typename?: 'NewImage', full_url?: string | null }> | null, schedule?: { __typename?: 'Schedule', startDateTime?: string | null, endDateTime?: string | null, occurrenceEndDate?: string | null } | null, occurrences?: Array<{ __typename?: 'Occurrence', _id: string, startDateTime: string, endDateTime?: string | null, isActive: boolean, note?: string | null, type?: ScheduleType | null } | null> | null, nextOccurrence?: { __typename?: 'Occurrence', _id: string, startDateTime: string, endDateTime?: string | null, isActive: boolean, note?: string | null, type?: ScheduleType | null } | null }> }> } };

export type GetEventsFilteredByStatusQueryVariables = Exact<{
  tenantOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetEventsFilteredByStatusQuery = { __typename?: 'Query', draft: Array<{ __typename?: 'Event', _id: string, name: string, status: string, operatorId: string, createdAt: number, updatedAt: number, images?: Array<{ __typename?: 'NewImage', full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } | null }> | null, operator?: { __typename?: 'OperatorEvent', operator_name?: string | null } | null, schedule?: { __typename?: 'Schedule', startDateTime?: string | null, endDateTime?: string | null, timeSlots?: Array<{ __typename?: 'TimeSlot', startISO: string, endISO: string } | null> | null } | null }>, upcoming: Array<{ __typename?: 'Event', _id: string, name: string, status: string, operatorId: string, createdAt: number, updatedAt: number, images?: Array<{ __typename?: 'NewImage', full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } | null }> | null, operator?: { __typename?: 'OperatorEvent', operator_name?: string | null } | null, schedule?: { __typename?: 'Schedule', startDateTime?: string | null, endDateTime?: string | null, timeSlots?: Array<{ __typename?: 'TimeSlot', startISO: string, endISO: string } | null> | null } | null }>, past: Array<{ __typename?: 'Event', _id: string, name: string, status: string, operatorId: string, createdAt: number, updatedAt: number, images?: Array<{ __typename?: 'NewImage', full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } | null }> | null, operator?: { __typename?: 'OperatorEvent', operator_name?: string | null } | null, schedule?: { __typename?: 'Schedule', startDateTime?: string | null, endDateTime?: string | null, timeSlots?: Array<{ __typename?: 'TimeSlot', startISO: string, endISO: string } | null> | null } | null }>, cancelled: Array<{ __typename?: 'Event', _id: string, name: string, status: string, operatorId: string, createdAt: number, updatedAt: number, images?: Array<{ __typename?: 'NewImage', full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } | null }> | null, operator?: { __typename?: 'OperatorEvent', operator_name?: string | null } | null, schedule?: { __typename?: 'Schedule', startDateTime?: string | null, endDateTime?: string | null, timeSlots?: Array<{ __typename?: 'TimeSlot', startISO: string, endISO: string } | null> | null } | null }> };

export type GetFormResponsesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  linkedId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFormResponsesQuery = { __typename?: 'Query', getFormResponses: { __typename?: 'GetFromResponseResponse', data: Array<{ __typename?: 'FormResponse', _id?: string | null, name?: string | null, linkedID?: string | null, requestBody?: any | null, type?: string | null }> } };

export type GetLearnerActivityLogManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyLearnerActivityLogInput>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLearnerActivityLogInput>;
}>;


export type GetLearnerActivityLogManyQuery = { __typename?: 'Query', learnerActivityLogMany?: { __typename?: 'LearnerActivityLogFindMany', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'LearnerActivityLog', eventType: EnumLearnerActivityLogEventType, personName?: string | null, personId?: any | null, operatorName?: string | null, operatorId?: any | null, courseName?: string | null, courseId?: any | null, _id: any, createdDateISO?: any | null, updatedDateISO?: any | null }> | null } | null };

export type GetOperatorQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetOperatorQuery = { __typename?: 'Query', getOperator?: { __typename?: 'Operator', _id?: string | null, updated_at?: number | null, website?: string | null, line_1?: string | null, line_2?: string | null, latitude?: number | null, longitude?: number | null, address?: string | null, city?: string | null, email?: string | null, tenants?: Array<string | null> | null, people?: Array<string | null> | null, connections?: Array<string | null> | null, operator_name?: string | null, postal_code?: string | null, province?: string | null, more_info_link?: string | null, phone?: string | null, termsConditions?: string | null, facebook_link?: string | null, instagram_link?: string | null, youtube_link?: string | null, pinterest_link?: string | null, google_mybusiness_link?: string | null, tiktok_link?: string | null, tripadvisor_link?: string | null, up_to_date_source?: string | null, open_hours_option?: string | null, publishingOptions?: string | null, markAsNeedsAttention?: boolean | null, sta_license_status?: string | null, status?: string | null, images?: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, teaser_url?: string | null, teaser_url_x2?: string | null, thumbnail_url?: string | null, thumbnail_url_x2?: string | null, blurhash: string, caption?: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } | null } | null> | null, description?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null } | null, short_description?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null } | null, tags?: { __typename?: 'Tags', type_of_operator?: string | null, capacity?: number | null, region?: Array<string> | null, pricing?: string | null, amenities?: Array<string> | null, vtc_custom?: Array<string> | null, accreditations?: Array<string> | null } | null, hours_of_operation_week?: { __typename?: 'HoursOfOperation', sun?: { __typename?: 'Hours', from?: string | null, to?: string | null, isActive?: boolean | null } | null, mon?: { __typename?: 'Hours', from?: string | null, to?: string | null, isActive?: boolean | null } | null, tue?: { __typename?: 'Hours', from?: string | null, to?: string | null, isActive?: boolean | null } | null, wed?: { __typename?: 'Hours', from?: string | null, to?: string | null, isActive?: boolean | null } | null, thu?: { __typename?: 'Hours', from?: string | null, to?: string | null, isActive?: boolean | null } | null, fri?: { __typename?: 'Hours', from?: string | null, to?: string | null, isActive?: boolean | null } | null, sat?: { __typename?: 'Hours', from?: string | null, to?: string | null, isActive?: boolean | null } | null } | null, checklist?: { __typename?: 'Checklist', verifyAllLinks?: boolean | null, tagYourBusiness?: boolean | null, verifyLocation?: boolean | null, verifyOpeningHours?: boolean | null, uploadNewHighResPhotos?: boolean | null, isYourBusinessDescriptionAccurateAndCompelling?: boolean | null } | null, seasonality?: { __typename?: 'Seasonality', high?: { __typename?: 'Season', jan?: boolean | null, feb?: boolean | null, mar?: boolean | null, apr?: boolean | null, may?: boolean | null, jun?: boolean | null, jul?: boolean | null, aug?: boolean | null, sep?: boolean | null, oct?: boolean | null, nov?: boolean | null, dec?: boolean | null } | null, low?: { __typename?: 'Season', jan?: boolean | null, feb?: boolean | null, mar?: boolean | null, apr?: boolean | null, may?: boolean | null, jun?: boolean | null, jul?: boolean | null, aug?: boolean | null, sep?: boolean | null, oct?: boolean | null, nov?: boolean | null, dec?: boolean | null } | null, closed?: { __typename?: 'Season', jan?: boolean | null, feb?: boolean | null, mar?: boolean | null, apr?: boolean | null, may?: boolean | null, jun?: boolean | null, jul?: boolean | null, aug?: boolean | null, sep?: boolean | null, oct?: boolean | null, nov?: boolean | null, dec?: boolean | null } | null } | null, note?: { __typename?: 'Note', text?: string | null, by?: string | null, date?: number | null, is_public?: boolean | null } | null } | null };

export type GetOperatorsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  tenants?: InputMaybe<Scalars['String']['input']>;
  operator_name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetOperatorsQuery = { __typename?: 'Query', getOperators: { __typename?: 'GetOperatorsResponse', total: number, data: Array<{ __typename?: 'Operator', _id?: string | null, operator_name?: string | null, status?: string | null, website?: string | null, updated_at?: number | null }> } };

export type GetPersonByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type GetPersonByIdQuery = { __typename?: 'Query', personById?: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, accountStatus: EnumPersonAccountStatus, email: string, auth0Id?: string | null, enrolledThrough?: string | null, _id: any, createdDateISO?: any | null, updatedDateISO?: any | null, operator?: { __typename?: 'LegacyOperator', _id: any, operator_name?: string | null } | null, address?: { __typename?: 'Address', line1: string, line2?: string | null, city: string, subdivision: string, postalCode: string, country: string, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, learner?: { __typename?: 'PersonLearner', stats?: { __typename?: 'PersonLearnerStats', startDate?: string | null, totalCoursesCompleted?: number | null, totalCoursesStarted?: number | null } | null, courses?: Array<{ __typename?: 'PersonLearnerCourses', courseId?: string | null, courseName?: string | null, startDate?: string | null, lastAccessDate?: string | null, completedDate?: string | null, status?: EnumPersonLearnerCoursesStatus | null, suspendData?: any | null, location?: string | null } | null> | null } | null } | null };

export type GetUserStatusByEmailQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserStatusByEmailQuery = { __typename?: 'Query', getUserStatus: { __typename?: 'GetUserStatusResponse', account?: boolean | null, claimed?: boolean | null, email?: string | null } };

export type InventoryByProductBookedDatesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type InventoryByProductBookedDatesQuery = { __typename?: 'Query', inventoryDatesByProduct?: { __typename?: 'InventoryBookedDatesSummary', bookedDatesISO: Array<string>, checkOutOnlyDatesISO: Array<string> } | null };

export type MemberCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountMemberInput>;
}>;


export type MemberCountQuery = { __typename?: 'Query', memberCount?: number | null };

export type MemberManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyMemberInput>;
  sort?: InputMaybe<SortFindManyMemberInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MemberManyQuery = { __typename?: 'Query', memberMany: Array<{ __typename?: 'Member', _id: any, operator?: { __typename?: 'LegacyOperator', website?: string | null, email: string, status?: string | null, address?: string | null, operator_name?: string | null, _id: any, images: Array<{ __typename?: 'NewImage', full_url?: string | null }> } | null, organization?: { __typename?: 'NewOrg', tenantId?: string | null, name?: string | null, staff: Array<{ __typename?: 'Person', _id: any, firstName?: string | null, lastName?: string | null }>, customTags?: { __typename?: 'NewOrgCustomTags', noteTags?: Array<{ __typename?: 'NewOrgCustomTagsNoteTags', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } } | null> | null } | null } | null, owner?: { __typename?: 'Person', email: string, _id: any, firstName?: string | null, lastName?: string | null } | null, staff: Array<{ __typename?: 'Person', email: string, firstName?: string | null, lastName?: string | null, _id: any }> }> };

export type MembersGroupByOwnerQueryVariables = Exact<{
  filter?: InputMaybe<FilterMembersGroupByOwnerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MembersGroupByOwnerQuery = { __typename?: 'Query', membersGroupByOwner?: { __typename?: 'MembersGroupByOwner', count: number, groups?: Array<{ __typename?: 'MembersGroupByOwnerGroup', uuid: string, members: Array<{ __typename?: 'Member', _id: any, operator?: { __typename?: 'LegacyOperator', email: string, website?: string | null, status?: string | null, address?: string | null, operator_name?: string | null, _id: any, images: Array<{ __typename?: 'NewImage', full_url?: string | null }> } | null, organization?: { __typename?: 'NewOrg', tenantId?: string | null, name?: string | null, staff: Array<{ __typename?: 'Person', _id: any, firstName?: string | null, lastName?: string | null }>, customTags?: { __typename?: 'NewOrgCustomTags', noteTags?: Array<{ __typename?: 'NewOrgCustomTagsNoteTags', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, fr?: string | null } } | null> | null } | null } | null, owner?: { __typename?: 'Person', email: string, _id: any, firstName?: string | null, lastName?: string | null } | null, staff: Array<{ __typename?: 'Person', email: string, firstName?: string | null, lastName?: string | null, _id: any }> }> } | null> | null } | null };

export type OperatorByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OperatorByIdQuery = { __typename?: 'Query', operatorById?: { __typename?: 'NewOperator', _id: any, name: string, contact: { __typename?: 'Contact', email: string, phone: string, address: { __typename?: 'Address', city: string, country: string, line1: string, line2?: string | null, postalCode: string, subdivision: string, location?: { __typename?: 'AddressLocation', coordinates: Array<number | null>, type: EnumAddressLocationType } | null } }, description?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, bookerOptions?: { __typename?: 'BookerOptions', cancellationPolicy?: string | null, termsConditions?: string | null, payment?: { __typename?: 'BookerPayment', connectedAccountId?: string | null, taxPercentage?: number | null, applicationPercentage: number } | null } | null } | null };

export type OperatorManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyNewOperatorInput>;
}>;


export type OperatorManyQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'NewOperator', _id: any, name: string, images: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null }> }> };

export type OperatorStripeAccountStatusQueryVariables = Exact<{
  operatorId: Scalars['ID']['input'];
}>;


export type OperatorStripeAccountStatusQuery = { __typename?: 'Query', operatorStripeAccountStatus?: { __typename?: 'OperatorStripeAccountStatus', id: string, name: string, status: EnumStripeOnboardingStatus } | null };

export type OperatorTotalSalesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OperatorTotalSalesQuery = { __typename?: 'Query', operatorTotalSales: number };

export type OrderByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OrderByIdQuery = { __typename?: 'Query', orderById?: { __typename?: 'Order', _id: string, cancelled: boolean, createdDateISO?: any | null, customerContact: { __typename?: 'CustomerContact', phone: string, name: string, email: string, guests: Array<{ __typename?: 'CustomerContactGuests', _id?: any | null, name: string } | null> }, source: { __typename?: 'OrderSource', bookerID: string, operator: any }, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', _id: any, product: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, pricing: { __typename?: 'Pricing', tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumPriceTierType, label?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> }, images: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null }> }, guestsPerTier: Array<{ __typename?: 'PurchasedProductGuestsPerTier', count: number, tierId: any } | null>, inventoryClaims: Array<{ __typename?: 'PurchasedProductInventoryClaims', _id?: any | null, inventoryID: any, claimedDateRangeISO?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null } | null> } | null> } | null };

export type OrderManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOrderInput>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrderInput>;
}>;


export type OrderManyQuery = { __typename?: 'Query', orderMany?: { __typename?: 'OrderFindMany', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, itemCount?: number | null, pageCount?: number | null, perPage: number }, items?: Array<{ __typename?: 'Order', _id: string, cancelled: boolean, createdDateISO?: any | null, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', _id: any, guestsPerTier: Array<{ __typename?: 'PurchasedProductGuestsPerTier', count: number, tierId: any } | null>, inventoryClaims: Array<{ __typename?: 'PurchasedProductInventoryClaims', _id?: any | null, inventoryID: any, claimedDateRangeISO?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null } | null>, product: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null>, customerContact: { __typename?: 'CustomerContact', name: string, email: string }, stripeMetadata: { __typename?: 'StripeMetadata', invoiceID?: string | null } }> | null } | null };

export type OrderPricesByIdQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderPricesByIdQuery = { __typename?: 'Query', orderPricesById?: { __typename?: 'CartPrices', grandTotal: number, subTotal: number, taxTotal: number, productPrices: Array<{ __typename?: 'PricePerProduct', price: number, productID: string }> } | null };

export type OrderPricesByIdsQueryVariables = Exact<{
  orderIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderPricesByIdsQuery = { __typename?: 'Query', orderPricesByIds: Array<{ __typename?: 'OrderCartPrice', orderID: string, prices?: { __typename?: 'CartPrices', grandTotal: number, taxTotal: number, subTotal: number, productPrices: Array<{ __typename?: 'PricePerProduct', price: number, productID: string }> } | null }> };

export type OrgFindOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneNewOrgInput>;
}>;


export type OrgFindOneQuery = { __typename?: 'Query', orgFindOne?: { __typename?: 'NewOrg', _id: any, customTags?: { __typename?: 'NewOrgCustomTags', memberTags?: Array<{ __typename?: 'NewOrgCustomTagsNoteTags', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null } } | null> | null, noteTags?: Array<{ __typename?: 'NewOrgCustomTagsNoteTags', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null } } | null> | null } | null, membershipSettings?: { __typename?: 'NewOrgMembershipSettings', customViews: Array<{ __typename?: 'NewOrgMembershipSettingsCustomViews', _id?: any | null, label: string, query: string, searchField: string, value: any } | null>, dues: { __typename?: 'NewOrgMembershipSettingsDues', active: boolean, tiers: Array<{ __typename?: 'NewOrgMembershipSettingsDuesTiers', _id?: any | null, label: string } | null> } } | null } | null };

export type GetPersonManyQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FilterFindManyPersonInput>;
}>;


export type GetPersonManyQuery = { __typename?: 'Query', personMany: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, accountStatus: EnumPersonAccountStatus, email: string, auth0Id?: string | null, _id: any, createdDateISO?: any | null, updatedDateISO?: any | null, operator?: { __typename?: 'LegacyOperator', operator_name?: string | null, _id: any } | null, tenantsOf: Array<{ __typename?: 'PersonTenantsOf', tenantId?: string | null, role: EnumPersonTenantsOfRole, _id?: any | null } | null>, learner?: { __typename?: 'PersonLearner', courses?: Array<{ __typename?: 'PersonLearnerCourses', courseId?: string | null, courseName?: string | null, startDate?: string | null, lastAccessDate?: string | null, completedDate?: string | null, status?: EnumPersonLearnerCoursesStatus | null, suspendData?: any | null } | null> | null, stats?: { __typename?: 'PersonLearnerStats', startDate?: string | null, totalCoursesCompleted?: number | null, totalCoursesStarted?: number | null } | null } | null }> };

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ProductByIdQuery = { __typename?: 'Query', productById?: { __typename?: 'Product', _id: any, externalBookingUrl?: string | null, operator: any, type: EnumProductType, description?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, thumbnail_url?: string | null, blurhash: string, caption?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null }>, pricing: { __typename?: 'Pricing', description?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumPriceTierType, label?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> }, shortDescription?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tags: Array<{ __typename?: 'NewTag', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } }>, taxRate?: { __typename?: 'TaxRate', _id: any, country: string, percentage: number, subdivision: string } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', minimumNights: number, maximumNights: number, amenities: Array<{ __typename?: 'Amenity', _id: any, type: EnumAmenityType, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } }>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', start: string, _id: any, end: string } } | null>, guestMetadata: { __typename?: 'GuestMetadata', maximumNumber?: number | null, minimumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean }, rooms: Array<{ __typename?: 'Room', _id?: any | null, amenities?: Array<any | null> | null, type: EnumRoomType } | null> } | null } | null };

export type ProductCalendarLinkByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductCalendarLinkByIdQuery = { __typename?: 'Query', productCalendarLinkById: string };

export type ProductClosureByIdQueryVariables = Exact<{
  closureId: Scalars['ID']['input'];
}>;


export type ProductClosureByIdQuery = { __typename?: 'Query', productClosureById?: { __typename?: 'ClosureData', productIDs: Array<string>, closure: { __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, start: string } } } | null };

export type ProductTotalSalesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductTotalSalesQuery = { __typename?: 'Query', productTotalSales: number };

export type ProductsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type ProductsByIdsQuery = { __typename?: 'Query', productsByIds: Array<{ __typename?: 'Product', _id: any, externalBookingUrl?: string | null, type: EnumProductType, description?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'NewImage', _id: any, full_url?: string | null, thumbnail_url?: string | null, caption?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null }>, pricing: { __typename?: 'Pricing', description?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumPriceTierType, label?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> }, shortDescription?: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tags: Array<{ __typename?: 'NewTag', _id: any, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } }>, taxRate?: { __typename?: 'TaxRate', _id: any, country: string, percentage: number, subdivision: string } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', amenities: Array<{ __typename?: 'Amenity', _id: any, type: EnumAmenityType, name: { __typename?: 'NewMultilingual', en?: string | null, es?: string | null, fr?: string | null } }>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', start: string, _id: any, end: string } } | null>, guestMetadata: { __typename?: 'GuestMetadata', maximumNumber?: number | null, minimumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean }, rooms: Array<{ __typename?: 'Room', _id?: any | null, amenities?: Array<any | null> | null, type: EnumRoomType } | null> } | null }> };

export type RefundManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyRefundInput>;
}>;


export type RefundManyQuery = { __typename?: 'Query', refundMany: Array<{ __typename?: 'Refund', _id: string, amount: number, orderID: string, status: EnumRefundStatus, createdDateISO?: any | null, updatedDateISO?: any | null }> };

export type RefundsByOrderIdsQueryVariables = Exact<{
  orderIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RefundsByOrderIdsQuery = { __typename?: 'Query', refundsByOrderIds?: Array<{ __typename?: 'Refund', _id: string, amount: number, createdDateISO?: any | null, orderID: string, status: EnumRefundStatus, updatedDateISO?: any | null }> | null };

export const AdminZoneEventFragmentDoc = gql`
    fragment AdminZoneEvent on Event {
  _id
  status
  submitStatus
  publishingOption
  note {
    text
    by
    isPublic
    createdAt
  }
}
    `;
export const GetTsnnRequestByIdDocument = gql`
    query GetTSNNRequestById($id: MongoID!) {
  tsnnRequestById(_id: $id) {
    _id
    name
    type
    status
    requestBody
    operatorID
    matchedToOperator
    trainingCompletionDate
    taskList {
      applicationReviewed
      matchedWithEmployer
      notoHasBegunWork
      notoHasCompletedWork
      notoJobBoardLinkShared
      otecWelcomeEmailSent
      sdfFormComplete
      trainingComplete
      wageSubsidyPaid
      welcomeEmailSent
    }
    note {
      text
      by
      createdAt
    }
  }
}
    `;

/**
 * __useGetTsnnRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetTsnnRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTsnnRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTsnnRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTsnnRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTsnnRequestByIdQuery, GetTsnnRequestByIdQueryVariables> & ({ variables: GetTsnnRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTsnnRequestByIdQuery, GetTsnnRequestByIdQueryVariables>(GetTsnnRequestByIdDocument, options);
      }
export function useGetTsnnRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTsnnRequestByIdQuery, GetTsnnRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTsnnRequestByIdQuery, GetTsnnRequestByIdQueryVariables>(GetTsnnRequestByIdDocument, options);
        }
export function useGetTsnnRequestByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTsnnRequestByIdQuery, GetTsnnRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTsnnRequestByIdQuery, GetTsnnRequestByIdQueryVariables>(GetTsnnRequestByIdDocument, options);
        }
export type GetTsnnRequestByIdQueryHookResult = ReturnType<typeof useGetTsnnRequestByIdQuery>;
export type GetTsnnRequestByIdLazyQueryHookResult = ReturnType<typeof useGetTsnnRequestByIdLazyQuery>;
export type GetTsnnRequestByIdSuspenseQueryHookResult = ReturnType<typeof useGetTsnnRequestByIdSuspenseQuery>;
export type GetTsnnRequestByIdQueryResult = Apollo.QueryResult<GetTsnnRequestByIdQuery, GetTsnnRequestByIdQueryVariables>;
export const GetTsnnRequestsDocument = gql`
    query GetTSNNRequests($type: EnumTSNNRequestType, $operatorID: MongoID, $search: String) {
  tsnnRequestMany(filter: {type: $type, operatorID: $operatorID, search: $search}) {
    count
    items {
      _id
      name
      type
      status
      requestBody
      operatorID
      matchedToOperator
      trainingCompletionDate
      taskList {
        applicationReviewed
        matchedWithEmployer
        notoHasBegunWork
        notoHasCompletedWork
        notoJobBoardLinkShared
        otecWelcomeEmailSent
        sdfFormComplete
        trainingComplete
        wageSubsidyPaid
        welcomeEmailSent
      }
      note {
        text
        by
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetTsnnRequestsQuery__
 *
 * To run a query within a React component, call `useGetTsnnRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTsnnRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTsnnRequestsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      operatorID: // value for 'operatorID'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTsnnRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetTsnnRequestsQuery, GetTsnnRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTsnnRequestsQuery, GetTsnnRequestsQueryVariables>(GetTsnnRequestsDocument, options);
      }
export function useGetTsnnRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTsnnRequestsQuery, GetTsnnRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTsnnRequestsQuery, GetTsnnRequestsQueryVariables>(GetTsnnRequestsDocument, options);
        }
export function useGetTsnnRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTsnnRequestsQuery, GetTsnnRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTsnnRequestsQuery, GetTsnnRequestsQueryVariables>(GetTsnnRequestsDocument, options);
        }
export type GetTsnnRequestsQueryHookResult = ReturnType<typeof useGetTsnnRequestsQuery>;
export type GetTsnnRequestsLazyQueryHookResult = ReturnType<typeof useGetTsnnRequestsLazyQuery>;
export type GetTsnnRequestsSuspenseQueryHookResult = ReturnType<typeof useGetTsnnRequestsSuspenseQuery>;
export type GetTsnnRequestsQueryResult = Apollo.QueryResult<GetTsnnRequestsQuery, GetTsnnRequestsQueryVariables>;
export const CreateTsnnRequestDocument = gql`
    mutation CreateTSNNRequest($record: CreateOneTSNNRequestInput!) {
  tsnnRequestCreate(record: $record) {
    record {
      _id
      name
      type
      status
      requestBody
      operatorID
      matchedToOperator
      trainingCompletionDate
      taskList {
        applicationReviewed
        matchedWithEmployer
        notoHasBegunWork
        notoHasCompletedWork
        notoJobBoardLinkShared
        otecWelcomeEmailSent
        sdfFormComplete
        sfpParticipantRegFormComplete
        trainingComplete
        wageSubsidyPaid
        welcomeEmailSent
      }
      note {
        text
        by
        createdAt
      }
    }
    recordId
    error {
      message
    }
  }
}
    `;
export type CreateTsnnRequestMutationFn = Apollo.MutationFunction<CreateTsnnRequestMutation, CreateTsnnRequestMutationVariables>;

/**
 * __useCreateTsnnRequestMutation__
 *
 * To run a mutation, you first call `useCreateTsnnRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTsnnRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTsnnRequestMutation, { data, loading, error }] = useCreateTsnnRequestMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreateTsnnRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateTsnnRequestMutation, CreateTsnnRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTsnnRequestMutation, CreateTsnnRequestMutationVariables>(CreateTsnnRequestDocument, options);
      }
export type CreateTsnnRequestMutationHookResult = ReturnType<typeof useCreateTsnnRequestMutation>;
export type CreateTsnnRequestMutationResult = Apollo.MutationResult<CreateTsnnRequestMutation>;
export type CreateTsnnRequestMutationOptions = Apollo.BaseMutationOptions<CreateTsnnRequestMutation, CreateTsnnRequestMutationVariables>;
export const UpdateTsnnRequestStatusDocument = gql`
    mutation UpdateTSNNRequestStatus($ids: [MongoID!]!, $record: UpdateManyTSNNRequestInput!, $tsnnRequestUpdateManyFilter2: FilterUpdateManyTSNNRequestInput) {
  tsnnRequestUpdateMany(
    record: $record
    filter: $tsnnRequestUpdateManyFilter2
    _ids: $ids
  ) {
    numAffected
    error {
      message
    }
  }
}
    `;
export type UpdateTsnnRequestStatusMutationFn = Apollo.MutationFunction<UpdateTsnnRequestStatusMutation, UpdateTsnnRequestStatusMutationVariables>;

/**
 * __useUpdateTsnnRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTsnnRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTsnnRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTsnnRequestStatusMutation, { data, loading, error }] = useUpdateTsnnRequestStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      record: // value for 'record'
 *      tsnnRequestUpdateManyFilter2: // value for 'tsnnRequestUpdateManyFilter2'
 *   },
 * });
 */
export function useUpdateTsnnRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTsnnRequestStatusMutation, UpdateTsnnRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTsnnRequestStatusMutation, UpdateTsnnRequestStatusMutationVariables>(UpdateTsnnRequestStatusDocument, options);
      }
export type UpdateTsnnRequestStatusMutationHookResult = ReturnType<typeof useUpdateTsnnRequestStatusMutation>;
export type UpdateTsnnRequestStatusMutationResult = Apollo.MutationResult<UpdateTsnnRequestStatusMutation>;
export type UpdateTsnnRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTsnnRequestStatusMutation, UpdateTsnnRequestStatusMutationVariables>;
export const UpdateTsnnRequestByIdDocument = gql`
    mutation UpdateTSNNRequestById($id: MongoID!, $record: UpdateByIdTSNNRequestInput!) {
  tsnnRequestUpdateById(_id: $id, record: $record) {
    record {
      _id
      name
      type
      status
      requestBody
      operatorID
      matchedToOperator
      trainingCompletionDate
      taskList {
        applicationReviewed
        matchedWithEmployer
        notoHasBegunWork
        notoHasCompletedWork
        notoJobBoardLinkShared
        otecWelcomeEmailSent
        sdfFormComplete
        trainingComplete
        wageSubsidyPaid
        welcomeEmailSent
      }
      note {
        text
        by
        createdAt
      }
    }
    recordId
    error {
      message
    }
  }
}
    `;
export type UpdateTsnnRequestByIdMutationFn = Apollo.MutationFunction<UpdateTsnnRequestByIdMutation, UpdateTsnnRequestByIdMutationVariables>;

/**
 * __useUpdateTsnnRequestByIdMutation__
 *
 * To run a mutation, you first call `useUpdateTsnnRequestByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTsnnRequestByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTsnnRequestByIdMutation, { data, loading, error }] = useUpdateTsnnRequestByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUpdateTsnnRequestByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTsnnRequestByIdMutation, UpdateTsnnRequestByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTsnnRequestByIdMutation, UpdateTsnnRequestByIdMutationVariables>(UpdateTsnnRequestByIdDocument, options);
      }
export type UpdateTsnnRequestByIdMutationHookResult = ReturnType<typeof useUpdateTsnnRequestByIdMutation>;
export type UpdateTsnnRequestByIdMutationResult = Apollo.MutationResult<UpdateTsnnRequestByIdMutation>;
export type UpdateTsnnRequestByIdMutationOptions = Apollo.BaseMutationOptions<UpdateTsnnRequestByIdMutation, UpdateTsnnRequestByIdMutationVariables>;
export const AnalyzeLearnerReportDocument = gql`
    mutation AnalyzeLearnerReport($input: SummaryInput!) {
  analyzeLearnerReport(input: $input) {
    response
  }
}
    `;
export type AnalyzeLearnerReportMutationFn = Apollo.MutationFunction<AnalyzeLearnerReportMutation, AnalyzeLearnerReportMutationVariables>;

/**
 * __useAnalyzeLearnerReportMutation__
 *
 * To run a mutation, you first call `useAnalyzeLearnerReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeLearnerReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeLearnerReportMutation, { data, loading, error }] = useAnalyzeLearnerReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyzeLearnerReportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyzeLearnerReportMutation, AnalyzeLearnerReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyzeLearnerReportMutation, AnalyzeLearnerReportMutationVariables>(AnalyzeLearnerReportDocument, options);
      }
export type AnalyzeLearnerReportMutationHookResult = ReturnType<typeof useAnalyzeLearnerReportMutation>;
export type AnalyzeLearnerReportMutationResult = Apollo.MutationResult<AnalyzeLearnerReportMutation>;
export type AnalyzeLearnerReportMutationOptions = Apollo.BaseMutationOptions<AnalyzeLearnerReportMutation, AnalyzeLearnerReportMutationVariables>;
export const BookerCreateDocument = gql`
    mutation BookerCreate($record: CreateOneBookerInput!) {
  bookerCreate(record: $record) {
    recordId
  }
}
    `;
export type BookerCreateMutationFn = Apollo.MutationFunction<BookerCreateMutation, BookerCreateMutationVariables>;

/**
 * __useBookerCreateMutation__
 *
 * To run a mutation, you first call `useBookerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerCreateMutation, { data, loading, error }] = useBookerCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useBookerCreateMutation(baseOptions?: Apollo.MutationHookOptions<BookerCreateMutation, BookerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerCreateMutation, BookerCreateMutationVariables>(BookerCreateDocument, options);
      }
export type BookerCreateMutationHookResult = ReturnType<typeof useBookerCreateMutation>;
export type BookerCreateMutationResult = Apollo.MutationResult<BookerCreateMutation>;
export type BookerCreateMutationOptions = Apollo.BaseMutationOptions<BookerCreateMutation, BookerCreateMutationVariables>;
export const BookerUpdateDocument = gql`
    mutation BookerUpdate($id: MongoID!, $record: UpdateByIdBookerInput!) {
  bookerUpdate(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type BookerUpdateMutationFn = Apollo.MutationFunction<BookerUpdateMutation, BookerUpdateMutationVariables>;

/**
 * __useBookerUpdateMutation__
 *
 * To run a mutation, you first call `useBookerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerUpdateMutation, { data, loading, error }] = useBookerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useBookerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BookerUpdateMutation, BookerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerUpdateMutation, BookerUpdateMutationVariables>(BookerUpdateDocument, options);
      }
export type BookerUpdateMutationHookResult = ReturnType<typeof useBookerUpdateMutation>;
export type BookerUpdateMutationResult = Apollo.MutationResult<BookerUpdateMutation>;
export type BookerUpdateMutationOptions = Apollo.BaseMutationOptions<BookerUpdateMutation, BookerUpdateMutationVariables>;
export const CancelAllEventOccurrencesDocument = gql`
    mutation CancelAllEventOccurrences($id: ID!, $note: String) {
  cancelAllEventOccurrences(_id: $id, note: $note) {
    _id
  }
}
    `;
export type CancelAllEventOccurrencesMutationFn = Apollo.MutationFunction<CancelAllEventOccurrencesMutation, CancelAllEventOccurrencesMutationVariables>;

/**
 * __useCancelAllEventOccurrencesMutation__
 *
 * To run a mutation, you first call `useCancelAllEventOccurrencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAllEventOccurrencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAllEventOccurrencesMutation, { data, loading, error }] = useCancelAllEventOccurrencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCancelAllEventOccurrencesMutation(baseOptions?: Apollo.MutationHookOptions<CancelAllEventOccurrencesMutation, CancelAllEventOccurrencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAllEventOccurrencesMutation, CancelAllEventOccurrencesMutationVariables>(CancelAllEventOccurrencesDocument, options);
      }
export type CancelAllEventOccurrencesMutationHookResult = ReturnType<typeof useCancelAllEventOccurrencesMutation>;
export type CancelAllEventOccurrencesMutationResult = Apollo.MutationResult<CancelAllEventOccurrencesMutation>;
export type CancelAllEventOccurrencesMutationOptions = Apollo.BaseMutationOptions<CancelAllEventOccurrencesMutation, CancelAllEventOccurrencesMutationVariables>;
export const CreateClosuresPerProductDocument = gql`
    mutation CreateClosuresPerProduct($productIDs: [ID!]!, $name: String!, $startIso: String!, $endIso: String!) {
  createClosuresPerProduct(
    productIDs: $productIDs
    name: $name
    startISO: $startIso
    endISO: $endIso
  )
}
    `;
export type CreateClosuresPerProductMutationFn = Apollo.MutationFunction<CreateClosuresPerProductMutation, CreateClosuresPerProductMutationVariables>;

/**
 * __useCreateClosuresPerProductMutation__
 *
 * To run a mutation, you first call `useCreateClosuresPerProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClosuresPerProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClosuresPerProductMutation, { data, loading, error }] = useCreateClosuresPerProductMutation({
 *   variables: {
 *      productIDs: // value for 'productIDs'
 *      name: // value for 'name'
 *      startIso: // value for 'startIso'
 *      endIso: // value for 'endIso'
 *   },
 * });
 */
export function useCreateClosuresPerProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateClosuresPerProductMutation, CreateClosuresPerProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClosuresPerProductMutation, CreateClosuresPerProductMutationVariables>(CreateClosuresPerProductDocument, options);
      }
export type CreateClosuresPerProductMutationHookResult = ReturnType<typeof useCreateClosuresPerProductMutation>;
export type CreateClosuresPerProductMutationResult = Apollo.MutationResult<CreateClosuresPerProductMutation>;
export type CreateClosuresPerProductMutationOptions = Apollo.BaseMutationOptions<CreateClosuresPerProductMutation, CreateClosuresPerProductMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    _id
    name
    status
    operatorId
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateEventImageDocument = gql`
    mutation CreateEventImage($input: createEventImageInput!) {
  createEventImage(input: $input) {
    _id
  }
}
    `;
export type CreateEventImageMutationFn = Apollo.MutationFunction<CreateEventImageMutation, CreateEventImageMutationVariables>;

/**
 * __useCreateEventImageMutation__
 *
 * To run a mutation, you first call `useCreateEventImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventImageMutation, { data, loading, error }] = useCreateEventImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventImageMutation, CreateEventImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventImageMutation, CreateEventImageMutationVariables>(CreateEventImageDocument, options);
      }
export type CreateEventImageMutationHookResult = ReturnType<typeof useCreateEventImageMutation>;
export type CreateEventImageMutationResult = Apollo.MutationResult<CreateEventImageMutation>;
export type CreateEventImageMutationOptions = Apollo.BaseMutationOptions<CreateEventImageMutation, CreateEventImageMutationVariables>;
export const CreateOperatorDocument = gql`
    mutation CreateOperator($input: CreateOperatorInput!) {
  createOperator(input: $input) {
    _id
  }
}
    `;
export type CreateOperatorMutationFn = Apollo.MutationFunction<CreateOperatorMutation, CreateOperatorMutationVariables>;

/**
 * __useCreateOperatorMutation__
 *
 * To run a mutation, you first call `useCreateOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOperatorMutation, { data, loading, error }] = useCreateOperatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOperatorMutation(baseOptions?: Apollo.MutationHookOptions<CreateOperatorMutation, CreateOperatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOperatorMutation, CreateOperatorMutationVariables>(CreateOperatorDocument, options);
      }
export type CreateOperatorMutationHookResult = ReturnType<typeof useCreateOperatorMutation>;
export type CreateOperatorMutationResult = Apollo.MutationResult<CreateOperatorMutation>;
export type CreateOperatorMutationOptions = Apollo.BaseMutationOptions<CreateOperatorMutation, CreateOperatorMutationVariables>;
export const CreateOperatorImageDocument = gql`
    mutation CreateOperatorImage($input: createOperatorImageInput!) {
  createOperatorImage(input: $input) {
    _id
  }
}
    `;
export type CreateOperatorImageMutationFn = Apollo.MutationFunction<CreateOperatorImageMutation, CreateOperatorImageMutationVariables>;

/**
 * __useCreateOperatorImageMutation__
 *
 * To run a mutation, you first call `useCreateOperatorImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOperatorImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOperatorImageMutation, { data, loading, error }] = useCreateOperatorImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOperatorImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOperatorImageMutation, CreateOperatorImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOperatorImageMutation, CreateOperatorImageMutationVariables>(CreateOperatorImageDocument, options);
      }
export type CreateOperatorImageMutationHookResult = ReturnType<typeof useCreateOperatorImageMutation>;
export type CreateOperatorImageMutationResult = Apollo.MutationResult<CreateOperatorImageMutation>;
export type CreateOperatorImageMutationOptions = Apollo.BaseMutationOptions<CreateOperatorImageMutation, CreateOperatorImageMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    code
    message
    success
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: ID!) {
  deleteEvent(_id: $id) {
    _id
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteEventImageDocument = gql`
    mutation DeleteEventImage($input: deleteEventImageInput!) {
  deleteEventImage(input: $input) {
    _id
  }
}
    `;
export type DeleteEventImageMutationFn = Apollo.MutationFunction<DeleteEventImageMutation, DeleteEventImageMutationVariables>;

/**
 * __useDeleteEventImageMutation__
 *
 * To run a mutation, you first call `useDeleteEventImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventImageMutation, { data, loading, error }] = useDeleteEventImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEventImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventImageMutation, DeleteEventImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventImageMutation, DeleteEventImageMutationVariables>(DeleteEventImageDocument, options);
      }
export type DeleteEventImageMutationHookResult = ReturnType<typeof useDeleteEventImageMutation>;
export type DeleteEventImageMutationResult = Apollo.MutationResult<DeleteEventImageMutation>;
export type DeleteEventImageMutationOptions = Apollo.BaseMutationOptions<DeleteEventImageMutation, DeleteEventImageMutationVariables>;
export const DeleteEventOccurrenceDocument = gql`
    mutation DeleteEventOccurrence($input: deleteEventOccurrenceInput!) {
  deleteEventOccurrence(input: $input) {
    _id
  }
}
    `;
export type DeleteEventOccurrenceMutationFn = Apollo.MutationFunction<DeleteEventOccurrenceMutation, DeleteEventOccurrenceMutationVariables>;

/**
 * __useDeleteEventOccurrenceMutation__
 *
 * To run a mutation, you first call `useDeleteEventOccurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventOccurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventOccurrenceMutation, { data, loading, error }] = useDeleteEventOccurrenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEventOccurrenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventOccurrenceMutation, DeleteEventOccurrenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventOccurrenceMutation, DeleteEventOccurrenceMutationVariables>(DeleteEventOccurrenceDocument, options);
      }
export type DeleteEventOccurrenceMutationHookResult = ReturnType<typeof useDeleteEventOccurrenceMutation>;
export type DeleteEventOccurrenceMutationResult = Apollo.MutationResult<DeleteEventOccurrenceMutation>;
export type DeleteEventOccurrenceMutationOptions = Apollo.BaseMutationOptions<DeleteEventOccurrenceMutation, DeleteEventOccurrenceMutationVariables>;
export const DeleteFormResponseDocument = gql`
    mutation DeleteFormResponse($input: DeleteFormResponseInput!) {
  deleteFormResponse(input: $input) {
    _id
  }
}
    `;
export type DeleteFormResponseMutationFn = Apollo.MutationFunction<DeleteFormResponseMutation, DeleteFormResponseMutationVariables>;

/**
 * __useDeleteFormResponseMutation__
 *
 * To run a mutation, you first call `useDeleteFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormResponseMutation, { data, loading, error }] = useDeleteFormResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormResponseMutation, DeleteFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormResponseMutation, DeleteFormResponseMutationVariables>(DeleteFormResponseDocument, options);
      }
export type DeleteFormResponseMutationHookResult = ReturnType<typeof useDeleteFormResponseMutation>;
export type DeleteFormResponseMutationResult = Apollo.MutationResult<DeleteFormResponseMutation>;
export type DeleteFormResponseMutationOptions = Apollo.BaseMutationOptions<DeleteFormResponseMutation, DeleteFormResponseMutationVariables>;
export const DeleteOperatorDocument = gql`
    mutation DeleteOperator($id: ID!) {
  deleteOperator(_id: $id) {
    _id
  }
}
    `;
export type DeleteOperatorMutationFn = Apollo.MutationFunction<DeleteOperatorMutation, DeleteOperatorMutationVariables>;

/**
 * __useDeleteOperatorMutation__
 *
 * To run a mutation, you first call `useDeleteOperatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOperatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOperatorMutation, { data, loading, error }] = useDeleteOperatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOperatorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOperatorMutation, DeleteOperatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOperatorMutation, DeleteOperatorMutationVariables>(DeleteOperatorDocument, options);
      }
export type DeleteOperatorMutationHookResult = ReturnType<typeof useDeleteOperatorMutation>;
export type DeleteOperatorMutationResult = Apollo.MutationResult<DeleteOperatorMutation>;
export type DeleteOperatorMutationOptions = Apollo.BaseMutationOptions<DeleteOperatorMutation, DeleteOperatorMutationVariables>;
export const GenerateOperatorOtpDocument = gql`
    mutation GenerateOperatorOTP($id: ID!) {
  generateOperatorOTP(_id: $id) {
    _id
  }
}
    `;
export type GenerateOperatorOtpMutationFn = Apollo.MutationFunction<GenerateOperatorOtpMutation, GenerateOperatorOtpMutationVariables>;

/**
 * __useGenerateOperatorOtpMutation__
 *
 * To run a mutation, you first call `useGenerateOperatorOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOperatorOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOperatorOtpMutation, { data, loading, error }] = useGenerateOperatorOtpMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateOperatorOtpMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOperatorOtpMutation, GenerateOperatorOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOperatorOtpMutation, GenerateOperatorOtpMutationVariables>(GenerateOperatorOtpDocument, options);
      }
export type GenerateOperatorOtpMutationHookResult = ReturnType<typeof useGenerateOperatorOtpMutation>;
export type GenerateOperatorOtpMutationResult = Apollo.MutationResult<GenerateOperatorOtpMutation>;
export type GenerateOperatorOtpMutationOptions = Apollo.BaseMutationOptions<GenerateOperatorOtpMutation, GenerateOperatorOtpMutationVariables>;
export const GenerateSummaryDocument = gql`
    mutation GenerateSummary($input: SummaryInput!) {
  summarize(input: $input) {
    response
  }
}
    `;
export type GenerateSummaryMutationFn = Apollo.MutationFunction<GenerateSummaryMutation, GenerateSummaryMutationVariables>;

/**
 * __useGenerateSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSummaryMutation, { data, loading, error }] = useGenerateSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSummaryMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSummaryMutation, GenerateSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSummaryMutation, GenerateSummaryMutationVariables>(GenerateSummaryDocument, options);
      }
export type GenerateSummaryMutationHookResult = ReturnType<typeof useGenerateSummaryMutation>;
export type GenerateSummaryMutationResult = Apollo.MutationResult<GenerateSummaryMutation>;
export type GenerateSummaryMutationOptions = Apollo.BaseMutationOptions<GenerateSummaryMutation, GenerateSummaryMutationVariables>;
export const ImageCreateDocument = gql`
    mutation ImageCreate($data: JSON!, $entityType: Entity!, $entityId: MongoID!) {
  imageCreate(data: $data, entityType: $entityType, entityId: $entityId) {
    recordId
  }
}
    `;
export type ImageCreateMutationFn = Apollo.MutationFunction<ImageCreateMutation, ImageCreateMutationVariables>;

/**
 * __useImageCreateMutation__
 *
 * To run a mutation, you first call `useImageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageCreateMutation, { data, loading, error }] = useImageCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useImageCreateMutation(baseOptions?: Apollo.MutationHookOptions<ImageCreateMutation, ImageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageCreateMutation, ImageCreateMutationVariables>(ImageCreateDocument, options);
      }
export type ImageCreateMutationHookResult = ReturnType<typeof useImageCreateMutation>;
export type ImageCreateMutationResult = Apollo.MutationResult<ImageCreateMutation>;
export type ImageCreateMutationOptions = Apollo.BaseMutationOptions<ImageCreateMutation, ImageCreateMutationVariables>;
export const ImageRemoveDocument = gql`
    mutation ImageRemove($entityType: Entity!, $entityId: MongoID!, $filter: FilterRemoveOneNewImageInput) {
  imageRemove(entityType: $entityType, entityId: $entityId, filter: $filter) {
    recordId
  }
}
    `;
export type ImageRemoveMutationFn = Apollo.MutationFunction<ImageRemoveMutation, ImageRemoveMutationVariables>;

/**
 * __useImageRemoveMutation__
 *
 * To run a mutation, you first call `useImageRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageRemoveMutation, { data, loading, error }] = useImageRemoveMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useImageRemoveMutation(baseOptions?: Apollo.MutationHookOptions<ImageRemoveMutation, ImageRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageRemoveMutation, ImageRemoveMutationVariables>(ImageRemoveDocument, options);
      }
export type ImageRemoveMutationHookResult = ReturnType<typeof useImageRemoveMutation>;
export type ImageRemoveMutationResult = Apollo.MutationResult<ImageRemoveMutation>;
export type ImageRemoveMutationOptions = Apollo.BaseMutationOptions<ImageRemoveMutation, ImageRemoveMutationVariables>;
export const ImageSortOrderDocument = gql`
    mutation ImageSortOrder($images: [MongoID]!, $entityType: Entity!, $entityId: MongoID!) {
  imageSortOrder(images: $images, entityType: $entityType, entityId: $entityId)
}
    `;
export type ImageSortOrderMutationFn = Apollo.MutationFunction<ImageSortOrderMutation, ImageSortOrderMutationVariables>;

/**
 * __useImageSortOrderMutation__
 *
 * To run a mutation, you first call `useImageSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageSortOrderMutation, { data, loading, error }] = useImageSortOrderMutation({
 *   variables: {
 *      images: // value for 'images'
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useImageSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<ImageSortOrderMutation, ImageSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageSortOrderMutation, ImageSortOrderMutationVariables>(ImageSortOrderDocument, options);
      }
export type ImageSortOrderMutationHookResult = ReturnType<typeof useImageSortOrderMutation>;
export type ImageSortOrderMutationResult = Apollo.MutationResult<ImageSortOrderMutation>;
export type ImageSortOrderMutationOptions = Apollo.BaseMutationOptions<ImageSortOrderMutation, ImageSortOrderMutationVariables>;
export const ImageUpdateDocument = gql`
    mutation ImageUpdate($id: MongoID!, $record: UpdateByIdNewImageInput!) {
  imageUpdate(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type ImageUpdateMutationFn = Apollo.MutationFunction<ImageUpdateMutation, ImageUpdateMutationVariables>;

/**
 * __useImageUpdateMutation__
 *
 * To run a mutation, you first call `useImageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageUpdateMutation, { data, loading, error }] = useImageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useImageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ImageUpdateMutation, ImageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageUpdateMutation, ImageUpdateMutationVariables>(ImageUpdateDocument, options);
      }
export type ImageUpdateMutationHookResult = ReturnType<typeof useImageUpdateMutation>;
export type ImageUpdateMutationResult = Apollo.MutationResult<ImageUpdateMutation>;
export type ImageUpdateMutationOptions = Apollo.BaseMutationOptions<ImageUpdateMutation, ImageUpdateMutationVariables>;
export const IntegrateProductCalendarLinksByProductIdsDocument = gql`
    mutation IntegrateProductCalendarLinksByProductIds($calendarLinksByProductIDs: [CalendarLinksByProductId!]!) {
  integrateProductCalendarLinksByProductIds(
    calendarLinksByProductIDs: $calendarLinksByProductIDs
  ) {
    updatedInventoryClaimItems {
      _id
      metadata {
        claimedDateRangesISO {
          metadata
          start
          end
        }
      }
    }
    releasedInventoryClaimItems {
      _id
      metadata {
        claimedDateRangesISO {
          metadata
          end
          start
        }
      }
    }
    products {
      _id
      name {
        en
        es
        fr
      }
      accommodationMetadata {
        calendarLinks
        closures {
          _id
          name
          dateRangeISO {
            start
            _id
            end
          }
        }
      }
    }
  }
}
    `;
export type IntegrateProductCalendarLinksByProductIdsMutationFn = Apollo.MutationFunction<IntegrateProductCalendarLinksByProductIdsMutation, IntegrateProductCalendarLinksByProductIdsMutationVariables>;

/**
 * __useIntegrateProductCalendarLinksByProductIdsMutation__
 *
 * To run a mutation, you first call `useIntegrateProductCalendarLinksByProductIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrateProductCalendarLinksByProductIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrateProductCalendarLinksByProductIdsMutation, { data, loading, error }] = useIntegrateProductCalendarLinksByProductIdsMutation({
 *   variables: {
 *      calendarLinksByProductIDs: // value for 'calendarLinksByProductIDs'
 *   },
 * });
 */
export function useIntegrateProductCalendarLinksByProductIdsMutation(baseOptions?: Apollo.MutationHookOptions<IntegrateProductCalendarLinksByProductIdsMutation, IntegrateProductCalendarLinksByProductIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrateProductCalendarLinksByProductIdsMutation, IntegrateProductCalendarLinksByProductIdsMutationVariables>(IntegrateProductCalendarLinksByProductIdsDocument, options);
      }
export type IntegrateProductCalendarLinksByProductIdsMutationHookResult = ReturnType<typeof useIntegrateProductCalendarLinksByProductIdsMutation>;
export type IntegrateProductCalendarLinksByProductIdsMutationResult = Apollo.MutationResult<IntegrateProductCalendarLinksByProductIdsMutation>;
export type IntegrateProductCalendarLinksByProductIdsMutationOptions = Apollo.BaseMutationOptions<IntegrateProductCalendarLinksByProductIdsMutation, IntegrateProductCalendarLinksByProductIdsMutationVariables>;
export const InventoryUpdateClaimedDatesByOrderDocument = gql`
    mutation InventoryUpdateClaimedDatesByOrder($orderId: ID!, $startIso: String!, $endIso: String!) {
  inventoryUpdateClaimedDatesByOrder(
    orderID: $orderId
    startISO: $startIso
    endISO: $endIso
  ) {
    _id
  }
}
    `;
export type InventoryUpdateClaimedDatesByOrderMutationFn = Apollo.MutationFunction<InventoryUpdateClaimedDatesByOrderMutation, InventoryUpdateClaimedDatesByOrderMutationVariables>;

/**
 * __useInventoryUpdateClaimedDatesByOrderMutation__
 *
 * To run a mutation, you first call `useInventoryUpdateClaimedDatesByOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryUpdateClaimedDatesByOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryUpdateClaimedDatesByOrderMutation, { data, loading, error }] = useInventoryUpdateClaimedDatesByOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      startIso: // value for 'startIso'
 *      endIso: // value for 'endIso'
 *   },
 * });
 */
export function useInventoryUpdateClaimedDatesByOrderMutation(baseOptions?: Apollo.MutationHookOptions<InventoryUpdateClaimedDatesByOrderMutation, InventoryUpdateClaimedDatesByOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InventoryUpdateClaimedDatesByOrderMutation, InventoryUpdateClaimedDatesByOrderMutationVariables>(InventoryUpdateClaimedDatesByOrderDocument, options);
      }
export type InventoryUpdateClaimedDatesByOrderMutationHookResult = ReturnType<typeof useInventoryUpdateClaimedDatesByOrderMutation>;
export type InventoryUpdateClaimedDatesByOrderMutationResult = Apollo.MutationResult<InventoryUpdateClaimedDatesByOrderMutation>;
export type InventoryUpdateClaimedDatesByOrderMutationOptions = Apollo.BaseMutationOptions<InventoryUpdateClaimedDatesByOrderMutation, InventoryUpdateClaimedDatesByOrderMutationVariables>;
export const LearnerActivityLogCreateDocument = gql`
    mutation LearnerActivityLogCreate($record: CreateOneLearnerActivityLogInput!) {
  learnerActivityLogCreate(record: $record) {
    recordId
    record {
      createdDateISO
    }
  }
}
    `;
export type LearnerActivityLogCreateMutationFn = Apollo.MutationFunction<LearnerActivityLogCreateMutation, LearnerActivityLogCreateMutationVariables>;

/**
 * __useLearnerActivityLogCreateMutation__
 *
 * To run a mutation, you first call `useLearnerActivityLogCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearnerActivityLogCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learnerActivityLogCreateMutation, { data, loading, error }] = useLearnerActivityLogCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useLearnerActivityLogCreateMutation(baseOptions?: Apollo.MutationHookOptions<LearnerActivityLogCreateMutation, LearnerActivityLogCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearnerActivityLogCreateMutation, LearnerActivityLogCreateMutationVariables>(LearnerActivityLogCreateDocument, options);
      }
export type LearnerActivityLogCreateMutationHookResult = ReturnType<typeof useLearnerActivityLogCreateMutation>;
export type LearnerActivityLogCreateMutationResult = Apollo.MutationResult<LearnerActivityLogCreateMutation>;
export type LearnerActivityLogCreateMutationOptions = Apollo.BaseMutationOptions<LearnerActivityLogCreateMutation, LearnerActivityLogCreateMutationVariables>;
export const MemberUpdateDocument = gql`
    mutation MemberUpdate($id: MongoID!, $record: UpdateByIdMemberInput!) {
  memberUpdate(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type MemberUpdateMutationFn = Apollo.MutationFunction<MemberUpdateMutation, MemberUpdateMutationVariables>;

/**
 * __useMemberUpdateMutation__
 *
 * To run a mutation, you first call `useMemberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMemberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [memberUpdateMutation, { data, loading, error }] = useMemberUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useMemberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MemberUpdateMutation, MemberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MemberUpdateMutation, MemberUpdateMutationVariables>(MemberUpdateDocument, options);
      }
export type MemberUpdateMutationHookResult = ReturnType<typeof useMemberUpdateMutation>;
export type MemberUpdateMutationResult = Apollo.MutationResult<MemberUpdateMutation>;
export type MemberUpdateMutationOptions = Apollo.BaseMutationOptions<MemberUpdateMutation, MemberUpdateMutationVariables>;
export const OperatorConnectStripeAccountDocument = gql`
    mutation OperatorConnectStripeAccount($operatorId: ID!, $redirectUrl: String!) {
  operatorConnectStripeAccount(id: $operatorId, redirectUrl: $redirectUrl) {
    link
    record {
      _id
    }
  }
}
    `;
export type OperatorConnectStripeAccountMutationFn = Apollo.MutationFunction<OperatorConnectStripeAccountMutation, OperatorConnectStripeAccountMutationVariables>;

/**
 * __useOperatorConnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useOperatorConnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorConnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorConnectStripeAccountMutation, { data, loading, error }] = useOperatorConnectStripeAccountMutation({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useOperatorConnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<OperatorConnectStripeAccountMutation, OperatorConnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorConnectStripeAccountMutation, OperatorConnectStripeAccountMutationVariables>(OperatorConnectStripeAccountDocument, options);
      }
export type OperatorConnectStripeAccountMutationHookResult = ReturnType<typeof useOperatorConnectStripeAccountMutation>;
export type OperatorConnectStripeAccountMutationResult = Apollo.MutationResult<OperatorConnectStripeAccountMutation>;
export type OperatorConnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<OperatorConnectStripeAccountMutation, OperatorConnectStripeAccountMutationVariables>;
export const OperatorDisconnectStripeAccountDocument = gql`
    mutation OperatorDisconnectStripeAccount($operatorId: ID!) {
  operatorDisconnectStripeAccount(id: $operatorId) {
    _id
  }
}
    `;
export type OperatorDisconnectStripeAccountMutationFn = Apollo.MutationFunction<OperatorDisconnectStripeAccountMutation, OperatorDisconnectStripeAccountMutationVariables>;

/**
 * __useOperatorDisconnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useOperatorDisconnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorDisconnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorDisconnectStripeAccountMutation, { data, loading, error }] = useOperatorDisconnectStripeAccountMutation({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorDisconnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<OperatorDisconnectStripeAccountMutation, OperatorDisconnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorDisconnectStripeAccountMutation, OperatorDisconnectStripeAccountMutationVariables>(OperatorDisconnectStripeAccountDocument, options);
      }
export type OperatorDisconnectStripeAccountMutationHookResult = ReturnType<typeof useOperatorDisconnectStripeAccountMutation>;
export type OperatorDisconnectStripeAccountMutationResult = Apollo.MutationResult<OperatorDisconnectStripeAccountMutation>;
export type OperatorDisconnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<OperatorDisconnectStripeAccountMutation, OperatorDisconnectStripeAccountMutationVariables>;
export const OperatorUpdateDocument = gql`
    mutation OperatorUpdate($id: MongoID!, $record: UpdateByIdNewOperatorInput!) {
  operatorUpdate(_id: $id, record: $record) {
    record {
      _id
      bookerOptions {
        cancellationPolicy
        termsConditions
        payment {
          taxPercentage
          applicationPercentage
        }
      }
    }
  }
}
    `;
export type OperatorUpdateMutationFn = Apollo.MutationFunction<OperatorUpdateMutation, OperatorUpdateMutationVariables>;

/**
 * __useOperatorUpdateMutation__
 *
 * To run a mutation, you first call `useOperatorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorUpdateMutation, { data, loading, error }] = useOperatorUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useOperatorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorUpdateMutation, OperatorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorUpdateMutation, OperatorUpdateMutationVariables>(OperatorUpdateDocument, options);
      }
export type OperatorUpdateMutationHookResult = ReturnType<typeof useOperatorUpdateMutation>;
export type OperatorUpdateMutationResult = Apollo.MutationResult<OperatorUpdateMutation>;
export type OperatorUpdateMutationOptions = Apollo.BaseMutationOptions<OperatorUpdateMutation, OperatorUpdateMutationVariables>;
export const OrderCreateDocument = gql`
    mutation OrderCreate($source: OrderSourceInput!, $customerContact: CustomerContactInput!, $paymentMethodId: String!, $productPurchaseRequests: [ProductPurchaseRequest]!) {
  orderCreate(
    source: $source
    customerContact: $customerContact
    paymentMethodID: $paymentMethodId
    productPurchaseRequests: $productPurchaseRequests
  ) {
    recordId
  }
}
    `;
export type OrderCreateMutationFn = Apollo.MutationFunction<OrderCreateMutation, OrderCreateMutationVariables>;

/**
 * __useOrderCreateMutation__
 *
 * To run a mutation, you first call `useOrderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCreateMutation, { data, loading, error }] = useOrderCreateMutation({
 *   variables: {
 *      source: // value for 'source'
 *      customerContact: // value for 'customerContact'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      productPurchaseRequests: // value for 'productPurchaseRequests'
 *   },
 * });
 */
export function useOrderCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderCreateMutation, OrderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCreateMutation, OrderCreateMutationVariables>(OrderCreateDocument, options);
      }
export type OrderCreateMutationHookResult = ReturnType<typeof useOrderCreateMutation>;
export type OrderCreateMutationResult = Apollo.MutationResult<OrderCreateMutation>;
export type OrderCreateMutationOptions = Apollo.BaseMutationOptions<OrderCreateMutation, OrderCreateMutationVariables>;
export const OrderUpdateDocument = gql`
    mutation OrderUpdate($id: String!, $cancelled: Boolean!) {
  orderUpdate(_id: $id, cancelled: $cancelled) {
    recordId
  }
}
    `;
export type OrderUpdateMutationFn = Apollo.MutationFunction<OrderUpdateMutation, OrderUpdateMutationVariables>;

/**
 * __useOrderUpdateMutation__
 *
 * To run a mutation, you first call `useOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderUpdateMutation, { data, loading, error }] = useOrderUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancelled: // value for 'cancelled'
 *   },
 * });
 */
export function useOrderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderUpdateMutation, OrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderUpdateMutation, OrderUpdateMutationVariables>(OrderUpdateDocument, options);
      }
export type OrderUpdateMutationHookResult = ReturnType<typeof useOrderUpdateMutation>;
export type OrderUpdateMutationResult = Apollo.MutationResult<OrderUpdateMutation>;
export type OrderUpdateMutationOptions = Apollo.BaseMutationOptions<OrderUpdateMutation, OrderUpdateMutationVariables>;
export const PersonCourseUpdateDocument = gql`
    mutation PersonCourseUpdate($input: PersonCoursesUpdateInput) {
  personCoursesUpdate(input: $input) {
    _id
  }
}
    `;
export type PersonCourseUpdateMutationFn = Apollo.MutationFunction<PersonCourseUpdateMutation, PersonCourseUpdateMutationVariables>;

/**
 * __usePersonCourseUpdateMutation__
 *
 * To run a mutation, you first call `usePersonCourseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonCourseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personCourseUpdateMutation, { data, loading, error }] = usePersonCourseUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonCourseUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PersonCourseUpdateMutation, PersonCourseUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonCourseUpdateMutation, PersonCourseUpdateMutationVariables>(PersonCourseUpdateDocument, options);
      }
export type PersonCourseUpdateMutationHookResult = ReturnType<typeof usePersonCourseUpdateMutation>;
export type PersonCourseUpdateMutationResult = Apollo.MutationResult<PersonCourseUpdateMutation>;
export type PersonCourseUpdateMutationOptions = Apollo.BaseMutationOptions<PersonCourseUpdateMutation, PersonCourseUpdateMutationVariables>;
export const ProductCreateDocument = gql`
    mutation ProductCreate($record: CreateOneProductInput!, $inventoryCount: Int!) {
  productCreate(record: $record, inventoryCount: $inventoryCount) {
    recordId
    record {
      _id
      name {
        en
        es
        fr
      }
    }
  }
}
    `;
export type ProductCreateMutationFn = Apollo.MutationFunction<ProductCreateMutation, ProductCreateMutationVariables>;

/**
 * __useProductCreateMutation__
 *
 * To run a mutation, you first call `useProductCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCreateMutation, { data, loading, error }] = useProductCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *      inventoryCount: // value for 'inventoryCount'
 *   },
 * });
 */
export function useProductCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductCreateMutation, ProductCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCreateMutation, ProductCreateMutationVariables>(ProductCreateDocument, options);
      }
export type ProductCreateMutationHookResult = ReturnType<typeof useProductCreateMutation>;
export type ProductCreateMutationResult = Apollo.MutationResult<ProductCreateMutation>;
export type ProductCreateMutationOptions = Apollo.BaseMutationOptions<ProductCreateMutation, ProductCreateMutationVariables>;
export const ProductUpdateDocument = gql`
    mutation ProductUpdate($id: MongoID!, $record: UpdateByIdProductInput!) {
  productUpdate(_id: $id, record: $record) {
    recordId
    record {
      _id
      name {
        en
        es
        fr
      }
    }
  }
}
    `;
export type ProductUpdateMutationFn = Apollo.MutationFunction<ProductUpdateMutation, ProductUpdateMutationVariables>;

/**
 * __useProductUpdateMutation__
 *
 * To run a mutation, you first call `useProductUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productUpdateMutation, { data, loading, error }] = useProductUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProductUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductUpdateMutation, ProductUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductUpdateMutation, ProductUpdateMutationVariables>(ProductUpdateDocument, options);
      }
export type ProductUpdateMutationHookResult = ReturnType<typeof useProductUpdateMutation>;
export type ProductUpdateMutationResult = Apollo.MutationResult<ProductUpdateMutation>;
export type ProductUpdateMutationOptions = Apollo.BaseMutationOptions<ProductUpdateMutation, ProductUpdateMutationVariables>;
export const RefundCreateDocument = gql`
    mutation RefundCreate($orderId: String!, $amount: Int!) {
  refundCreate(orderID: $orderId, amount: $amount) {
    record {
      _id
      amount
      createdDateISO
      orderID
      status
      updatedDateISO
    }
  }
}
    `;
export type RefundCreateMutationFn = Apollo.MutationFunction<RefundCreateMutation, RefundCreateMutationVariables>;

/**
 * __useRefundCreateMutation__
 *
 * To run a mutation, you first call `useRefundCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundCreateMutation, { data, loading, error }] = useRefundCreateMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useRefundCreateMutation(baseOptions?: Apollo.MutationHookOptions<RefundCreateMutation, RefundCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundCreateMutation, RefundCreateMutationVariables>(RefundCreateDocument, options);
      }
export type RefundCreateMutationHookResult = ReturnType<typeof useRefundCreateMutation>;
export type RefundCreateMutationResult = Apollo.MutationResult<RefundCreateMutation>;
export type RefundCreateMutationOptions = Apollo.BaseMutationOptions<RefundCreateMutation, RefundCreateMutationVariables>;
export const RemoveManyFromTenantDocument = gql`
    mutation RemoveManyFromTenant($ids: [ID!]!, $tenants: String) {
  removeManyFromTenant(ids: $ids, tenants: $tenants) {
    _ids
  }
}
    `;
export type RemoveManyFromTenantMutationFn = Apollo.MutationFunction<RemoveManyFromTenantMutation, RemoveManyFromTenantMutationVariables>;

/**
 * __useRemoveManyFromTenantMutation__
 *
 * To run a mutation, you first call `useRemoveManyFromTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveManyFromTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeManyFromTenantMutation, { data, loading, error }] = useRemoveManyFromTenantMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      tenants: // value for 'tenants'
 *   },
 * });
 */
export function useRemoveManyFromTenantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveManyFromTenantMutation, RemoveManyFromTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveManyFromTenantMutation, RemoveManyFromTenantMutationVariables>(RemoveManyFromTenantDocument, options);
      }
export type RemoveManyFromTenantMutationHookResult = ReturnType<typeof useRemoveManyFromTenantMutation>;
export type RemoveManyFromTenantMutationResult = Apollo.MutationResult<RemoveManyFromTenantMutation>;
export type RemoveManyFromTenantMutationOptions = Apollo.BaseMutationOptions<RemoveManyFromTenantMutation, RemoveManyFromTenantMutationVariables>;
export const SendEmailDocument = gql`
    mutation sendEmail($input: sendEmailInput!) {
  sendEmail(input: $input) {
    to
  }
}
    `;
export type SendEmailMutationFn = Apollo.MutationFunction<SendEmailMutation, SendEmailMutationVariables>;

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(SendEmailDocument, options);
      }
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>;
export type SendEmailMutationResult = Apollo.MutationResult<SendEmailMutation>;
export type SendEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailMutation, SendEmailMutationVariables>;
export const SetOperatorAsPermanentlyClosedDocument = gql`
    mutation SetOperatorAsPermanentlyClosed($id: ID!) {
  setOperatorAsPermanentlyClosed(_id: $id) {
    _id
  }
}
    `;
export type SetOperatorAsPermanentlyClosedMutationFn = Apollo.MutationFunction<SetOperatorAsPermanentlyClosedMutation, SetOperatorAsPermanentlyClosedMutationVariables>;

/**
 * __useSetOperatorAsPermanentlyClosedMutation__
 *
 * To run a mutation, you first call `useSetOperatorAsPermanentlyClosedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOperatorAsPermanentlyClosedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOperatorAsPermanentlyClosedMutation, { data, loading, error }] = useSetOperatorAsPermanentlyClosedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetOperatorAsPermanentlyClosedMutation(baseOptions?: Apollo.MutationHookOptions<SetOperatorAsPermanentlyClosedMutation, SetOperatorAsPermanentlyClosedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOperatorAsPermanentlyClosedMutation, SetOperatorAsPermanentlyClosedMutationVariables>(SetOperatorAsPermanentlyClosedDocument, options);
      }
export type SetOperatorAsPermanentlyClosedMutationHookResult = ReturnType<typeof useSetOperatorAsPermanentlyClosedMutation>;
export type SetOperatorAsPermanentlyClosedMutationResult = Apollo.MutationResult<SetOperatorAsPermanentlyClosedMutation>;
export type SetOperatorAsPermanentlyClosedMutationOptions = Apollo.BaseMutationOptions<SetOperatorAsPermanentlyClosedMutation, SetOperatorAsPermanentlyClosedMutationVariables>;
export const SiteByOperatorIdDocument = gql`
    query SiteByOperatorId($input: SiteByOperatorIdInput) {
  siteByOperatorId(input: $input) {
    _id
    siteId
    url
    status
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSiteByOperatorIdQuery__
 *
 * To run a query within a React component, call `useSiteByOperatorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteByOperatorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteByOperatorIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteByOperatorIdQuery(baseOptions?: Apollo.QueryHookOptions<SiteByOperatorIdQuery, SiteByOperatorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteByOperatorIdQuery, SiteByOperatorIdQueryVariables>(SiteByOperatorIdDocument, options);
      }
export function useSiteByOperatorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteByOperatorIdQuery, SiteByOperatorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteByOperatorIdQuery, SiteByOperatorIdQueryVariables>(SiteByOperatorIdDocument, options);
        }
export function useSiteByOperatorIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteByOperatorIdQuery, SiteByOperatorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteByOperatorIdQuery, SiteByOperatorIdQueryVariables>(SiteByOperatorIdDocument, options);
        }
export type SiteByOperatorIdQueryHookResult = ReturnType<typeof useSiteByOperatorIdQuery>;
export type SiteByOperatorIdLazyQueryHookResult = ReturnType<typeof useSiteByOperatorIdLazyQuery>;
export type SiteByOperatorIdSuspenseQueryHookResult = ReturnType<typeof useSiteByOperatorIdSuspenseQuery>;
export type SiteByOperatorIdQueryResult = Apollo.QueryResult<SiteByOperatorIdQuery, SiteByOperatorIdQueryVariables>;
export const SiteDeployDocument = gql`
    mutation SiteDeploy($input: SiteDeployInput) {
  siteDeploy(input: $input) {
    _id
    url
    branch
  }
}
    `;
export type SiteDeployMutationFn = Apollo.MutationFunction<SiteDeployMutation, SiteDeployMutationVariables>;

/**
 * __useSiteDeployMutation__
 *
 * To run a mutation, you first call `useSiteDeployMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteDeployMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteDeployMutation, { data, loading, error }] = useSiteDeployMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteDeployMutation(baseOptions?: Apollo.MutationHookOptions<SiteDeployMutation, SiteDeployMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteDeployMutation, SiteDeployMutationVariables>(SiteDeployDocument, options);
      }
export type SiteDeployMutationHookResult = ReturnType<typeof useSiteDeployMutation>;
export type SiteDeployMutationResult = Apollo.MutationResult<SiteDeployMutation>;
export type SiteDeployMutationOptions = Apollo.BaseMutationOptions<SiteDeployMutation, SiteDeployMutationVariables>;
export const SubmitEventForApprovalDocument = gql`
    mutation SubmitEventForApproval($id: ID!) {
  submitEventForApproval(_id: $id) {
    _id
  }
}
    `;
export type SubmitEventForApprovalMutationFn = Apollo.MutationFunction<SubmitEventForApprovalMutation, SubmitEventForApprovalMutationVariables>;

/**
 * __useSubmitEventForApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitEventForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEventForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEventForApprovalMutation, { data, loading, error }] = useSubmitEventForApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitEventForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEventForApprovalMutation, SubmitEventForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEventForApprovalMutation, SubmitEventForApprovalMutationVariables>(SubmitEventForApprovalDocument, options);
      }
export type SubmitEventForApprovalMutationHookResult = ReturnType<typeof useSubmitEventForApprovalMutation>;
export type SubmitEventForApprovalMutationResult = Apollo.MutationResult<SubmitEventForApprovalMutation>;
export type SubmitEventForApprovalMutationOptions = Apollo.BaseMutationOptions<SubmitEventForApprovalMutation, SubmitEventForApprovalMutationVariables>;
export const UpdateClosuresPerProductDocument = gql`
    mutation UpdateClosuresPerProduct($closureId: ID!, $deleteClosure: Boolean!, $productIDs: [ID!], $name: String, $startIso: String, $endIso: String) {
  updateClosuresPerProduct(
    closureID: $closureId
    deleteClosure: $deleteClosure
    productIDs: $productIDs
    name: $name
    startISO: $startIso
    endISO: $endIso
  )
}
    `;
export type UpdateClosuresPerProductMutationFn = Apollo.MutationFunction<UpdateClosuresPerProductMutation, UpdateClosuresPerProductMutationVariables>;

/**
 * __useUpdateClosuresPerProductMutation__
 *
 * To run a mutation, you first call `useUpdateClosuresPerProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClosuresPerProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClosuresPerProductMutation, { data, loading, error }] = useUpdateClosuresPerProductMutation({
 *   variables: {
 *      closureId: // value for 'closureId'
 *      deleteClosure: // value for 'deleteClosure'
 *      productIDs: // value for 'productIDs'
 *      name: // value for 'name'
 *      startIso: // value for 'startIso'
 *      endIso: // value for 'endIso'
 *   },
 * });
 */
export function useUpdateClosuresPerProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClosuresPerProductMutation, UpdateClosuresPerProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClosuresPerProductMutation, UpdateClosuresPerProductMutationVariables>(UpdateClosuresPerProductDocument, options);
      }
export type UpdateClosuresPerProductMutationHookResult = ReturnType<typeof useUpdateClosuresPerProductMutation>;
export type UpdateClosuresPerProductMutationResult = Apollo.MutationResult<UpdateClosuresPerProductMutation>;
export type UpdateClosuresPerProductMutationOptions = Apollo.BaseMutationOptions<UpdateClosuresPerProductMutation, UpdateClosuresPerProductMutationVariables>;
export const UpdateEventAdminZoneDocument = gql`
    mutation UpdateEventAdminZone($input: UpdateEventAdminZoneInput!) {
  updateEventAdminZone(input: $input) {
    _id
  }
}
    `;
export type UpdateEventAdminZoneMutationFn = Apollo.MutationFunction<UpdateEventAdminZoneMutation, UpdateEventAdminZoneMutationVariables>;

/**
 * __useUpdateEventAdminZoneMutation__
 *
 * To run a mutation, you first call `useUpdateEventAdminZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventAdminZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventAdminZoneMutation, { data, loading, error }] = useUpdateEventAdminZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventAdminZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventAdminZoneMutation, UpdateEventAdminZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventAdminZoneMutation, UpdateEventAdminZoneMutationVariables>(UpdateEventAdminZoneDocument, options);
      }
export type UpdateEventAdminZoneMutationHookResult = ReturnType<typeof useUpdateEventAdminZoneMutation>;
export type UpdateEventAdminZoneMutationResult = Apollo.MutationResult<UpdateEventAdminZoneMutation>;
export type UpdateEventAdminZoneMutationOptions = Apollo.BaseMutationOptions<UpdateEventAdminZoneMutation, UpdateEventAdminZoneMutationVariables>;
export const UpdateEventDetailsDocument = gql`
    mutation UpdateEventDetails($input: updateEventDetailsInput!) {
  updateEventDetails(input: $input) {
    _id
  }
}
    `;
export type UpdateEventDetailsMutationFn = Apollo.MutationFunction<UpdateEventDetailsMutation, UpdateEventDetailsMutationVariables>;

/**
 * __useUpdateEventDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateEventDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDetailsMutation, { data, loading, error }] = useUpdateEventDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventDetailsMutation, UpdateEventDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventDetailsMutation, UpdateEventDetailsMutationVariables>(UpdateEventDetailsDocument, options);
      }
export type UpdateEventDetailsMutationHookResult = ReturnType<typeof useUpdateEventDetailsMutation>;
export type UpdateEventDetailsMutationResult = Apollo.MutationResult<UpdateEventDetailsMutation>;
export type UpdateEventDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateEventDetailsMutation, UpdateEventDetailsMutationVariables>;
export const UpdateEventImageDocument = gql`
    mutation UpdateEventImage($input: updateEventImageInput!) {
  updateEventImage(input: $input) {
    _id
  }
}
    `;
export type UpdateEventImageMutationFn = Apollo.MutationFunction<UpdateEventImageMutation, UpdateEventImageMutationVariables>;

/**
 * __useUpdateEventImageMutation__
 *
 * To run a mutation, you first call `useUpdateEventImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventImageMutation, { data, loading, error }] = useUpdateEventImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventImageMutation, UpdateEventImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventImageMutation, UpdateEventImageMutationVariables>(UpdateEventImageDocument, options);
      }
export type UpdateEventImageMutationHookResult = ReturnType<typeof useUpdateEventImageMutation>;
export type UpdateEventImageMutationResult = Apollo.MutationResult<UpdateEventImageMutation>;
export type UpdateEventImageMutationOptions = Apollo.BaseMutationOptions<UpdateEventImageMutation, UpdateEventImageMutationVariables>;
export const UpdateEventImagesDocument = gql`
    mutation UpdateEventImages($id: ID, $record: updateEventImagesInput!) {
  updateEventImages(_id: $id, record: $record) {
    _id
  }
}
    `;
export type UpdateEventImagesMutationFn = Apollo.MutationFunction<UpdateEventImagesMutation, UpdateEventImagesMutationVariables>;

/**
 * __useUpdateEventImagesMutation__
 *
 * To run a mutation, you first call `useUpdateEventImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventImagesMutation, { data, loading, error }] = useUpdateEventImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUpdateEventImagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventImagesMutation, UpdateEventImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventImagesMutation, UpdateEventImagesMutationVariables>(UpdateEventImagesDocument, options);
      }
export type UpdateEventImagesMutationHookResult = ReturnType<typeof useUpdateEventImagesMutation>;
export type UpdateEventImagesMutationResult = Apollo.MutationResult<UpdateEventImagesMutation>;
export type UpdateEventImagesMutationOptions = Apollo.BaseMutationOptions<UpdateEventImagesMutation, UpdateEventImagesMutationVariables>;
export const UpdateManyOperatorsDocument = gql`
    mutation UpdateManyOperators($input: updateManyOperatorsInput!) {
  updateManyOperators(input: $input) {
    _ids
  }
}
    `;
export type UpdateManyOperatorsMutationFn = Apollo.MutationFunction<UpdateManyOperatorsMutation, UpdateManyOperatorsMutationVariables>;

/**
 * __useUpdateManyOperatorsMutation__
 *
 * To run a mutation, you first call `useUpdateManyOperatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManyOperatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManyOperatorsMutation, { data, loading, error }] = useUpdateManyOperatorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManyOperatorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManyOperatorsMutation, UpdateManyOperatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManyOperatorsMutation, UpdateManyOperatorsMutationVariables>(UpdateManyOperatorsDocument, options);
      }
export type UpdateManyOperatorsMutationHookResult = ReturnType<typeof useUpdateManyOperatorsMutation>;
export type UpdateManyOperatorsMutationResult = Apollo.MutationResult<UpdateManyOperatorsMutation>;
export type UpdateManyOperatorsMutationOptions = Apollo.BaseMutationOptions<UpdateManyOperatorsMutation, UpdateManyOperatorsMutationVariables>;
export const ValidateOperatorOtpDocument = gql`
    mutation ValidateOperatorOTP($input: validateOperatorOTPInput!) {
  validateOperatorOTP(input: $input) {
    _id
  }
}
    `;
export type ValidateOperatorOtpMutationFn = Apollo.MutationFunction<ValidateOperatorOtpMutation, ValidateOperatorOtpMutationVariables>;

/**
 * __useValidateOperatorOtpMutation__
 *
 * To run a mutation, you first call `useValidateOperatorOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOperatorOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOperatorOtpMutation, { data, loading, error }] = useValidateOperatorOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateOperatorOtpMutation(baseOptions?: Apollo.MutationHookOptions<ValidateOperatorOtpMutation, ValidateOperatorOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateOperatorOtpMutation, ValidateOperatorOtpMutationVariables>(ValidateOperatorOtpDocument, options);
      }
export type ValidateOperatorOtpMutationHookResult = ReturnType<typeof useValidateOperatorOtpMutation>;
export type ValidateOperatorOtpMutationResult = Apollo.MutationResult<ValidateOperatorOtpMutation>;
export type ValidateOperatorOtpMutationOptions = Apollo.BaseMutationOptions<ValidateOperatorOtpMutation, ValidateOperatorOtpMutationVariables>;
export const ProductManyDocument = gql`
    query ProductMany($filter: FilterFindManyProductInput) {
  productMany(filter: $filter) {
    _id
    name {
      en
      es
      fr
    }
    type
    isActive
    isUpsellOnly
    publishingStatus
    operator
    images {
      _id
      caption {
        en
        es
        fr
      }
      full_url
      thumbnail_url
    }
    accommodationMetadata {
      calendarLinks
      closures {
        _id
        name
        dateRangeISO {
          start
          _id
          end
        }
      }
    }
    pricing {
      tiers {
        _id
        price
      }
      description {
        en
        fr
        es
      }
    }
    description {
      en
    }
  }
}
    `;

/**
 * __useProductManyQuery__
 *
 * To run a query within a React component, call `useProductManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductManyQuery(baseOptions?: Apollo.QueryHookOptions<ProductManyQuery, ProductManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductManyQuery, ProductManyQueryVariables>(ProductManyDocument, options);
      }
export function useProductManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductManyQuery, ProductManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductManyQuery, ProductManyQueryVariables>(ProductManyDocument, options);
        }
export function useProductManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductManyQuery, ProductManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductManyQuery, ProductManyQueryVariables>(ProductManyDocument, options);
        }
export type ProductManyQueryHookResult = ReturnType<typeof useProductManyQuery>;
export type ProductManyLazyQueryHookResult = ReturnType<typeof useProductManyLazyQuery>;
export type ProductManySuspenseQueryHookResult = ReturnType<typeof useProductManySuspenseQuery>;
export type ProductManyQueryResult = Apollo.QueryResult<ProductManyQuery, ProductManyQueryVariables>;
export const AmenityByIdsDocument = gql`
    query AmenityByIds($ids: [MongoID!]!) {
  amenityByIds(_ids: $ids) {
    name {
      en
      es
      fr
    }
    type
    _id
  }
}
    `;

/**
 * __useAmenityByIdsQuery__
 *
 * To run a query within a React component, call `useAmenityByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAmenityByIdsQuery(baseOptions: Apollo.QueryHookOptions<AmenityByIdsQuery, AmenityByIdsQueryVariables> & ({ variables: AmenityByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityByIdsQuery, AmenityByIdsQueryVariables>(AmenityByIdsDocument, options);
      }
export function useAmenityByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityByIdsQuery, AmenityByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityByIdsQuery, AmenityByIdsQueryVariables>(AmenityByIdsDocument, options);
        }
export function useAmenityByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmenityByIdsQuery, AmenityByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmenityByIdsQuery, AmenityByIdsQueryVariables>(AmenityByIdsDocument, options);
        }
export type AmenityByIdsQueryHookResult = ReturnType<typeof useAmenityByIdsQuery>;
export type AmenityByIdsLazyQueryHookResult = ReturnType<typeof useAmenityByIdsLazyQuery>;
export type AmenityByIdsSuspenseQueryHookResult = ReturnType<typeof useAmenityByIdsSuspenseQuery>;
export type AmenityByIdsQueryResult = Apollo.QueryResult<AmenityByIdsQuery, AmenityByIdsQueryVariables>;
export const AmenityManyDocument = gql`
    query AmenityMany($filter: FilterFindManyAmenityInput) {
  amenityMany(filter: $filter) {
    _id
    name {
      en
      es
      fr
    }
    type
  }
}
    `;

/**
 * __useAmenityManyQuery__
 *
 * To run a query within a React component, call `useAmenityManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAmenityManyQuery(baseOptions?: Apollo.QueryHookOptions<AmenityManyQuery, AmenityManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityManyQuery, AmenityManyQueryVariables>(AmenityManyDocument, options);
      }
export function useAmenityManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityManyQuery, AmenityManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityManyQuery, AmenityManyQueryVariables>(AmenityManyDocument, options);
        }
export function useAmenityManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmenityManyQuery, AmenityManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmenityManyQuery, AmenityManyQueryVariables>(AmenityManyDocument, options);
        }
export type AmenityManyQueryHookResult = ReturnType<typeof useAmenityManyQuery>;
export type AmenityManyLazyQueryHookResult = ReturnType<typeof useAmenityManyLazyQuery>;
export type AmenityManySuspenseQueryHookResult = ReturnType<typeof useAmenityManySuspenseQuery>;
export type AmenityManyQueryResult = Apollo.QueryResult<AmenityManyQuery, AmenityManyQueryVariables>;
export const BookerByIdDocument = gql`
    query BookerById($id: MongoID!) {
  bookerById(_id: $id) {
    operator {
      _id
    }
    productBundles {
      addOns
      product {
        _id
        name {
          en
          es
          fr
        }
      }
      _id
    }
    _id
  }
}
    `;

/**
 * __useBookerByIdQuery__
 *
 * To run a query within a React component, call `useBookerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookerByIdQuery(baseOptions: Apollo.QueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables> & ({ variables: BookerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
      }
export function useBookerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
        }
export function useBookerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
        }
export type BookerByIdQueryHookResult = ReturnType<typeof useBookerByIdQuery>;
export type BookerByIdLazyQueryHookResult = ReturnType<typeof useBookerByIdLazyQuery>;
export type BookerByIdSuspenseQueryHookResult = ReturnType<typeof useBookerByIdSuspenseQuery>;
export type BookerByIdQueryResult = Apollo.QueryResult<BookerByIdQuery, BookerByIdQueryVariables>;
export const BookerByMainProductIdDocument = gql`
    query BookerByMainProductId($productId: ID!, $operatorId: ID) {
  bookerByMainProductId(productID: $productId, operatorID: $operatorId) {
    _id
    productBundles {
      product {
        _id
        name {
          en
        }
      }
      addOns
      _id
    }
    operator {
      _id
      name
    }
  }
}
    `;

/**
 * __useBookerByMainProductIdQuery__
 *
 * To run a query within a React component, call `useBookerByMainProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerByMainProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerByMainProductIdQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useBookerByMainProductIdQuery(baseOptions: Apollo.QueryHookOptions<BookerByMainProductIdQuery, BookerByMainProductIdQueryVariables> & ({ variables: BookerByMainProductIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerByMainProductIdQuery, BookerByMainProductIdQueryVariables>(BookerByMainProductIdDocument, options);
      }
export function useBookerByMainProductIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerByMainProductIdQuery, BookerByMainProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerByMainProductIdQuery, BookerByMainProductIdQueryVariables>(BookerByMainProductIdDocument, options);
        }
export function useBookerByMainProductIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerByMainProductIdQuery, BookerByMainProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerByMainProductIdQuery, BookerByMainProductIdQueryVariables>(BookerByMainProductIdDocument, options);
        }
export type BookerByMainProductIdQueryHookResult = ReturnType<typeof useBookerByMainProductIdQuery>;
export type BookerByMainProductIdLazyQueryHookResult = ReturnType<typeof useBookerByMainProductIdLazyQuery>;
export type BookerByMainProductIdSuspenseQueryHookResult = ReturnType<typeof useBookerByMainProductIdSuspenseQuery>;
export type BookerByMainProductIdQueryResult = Apollo.QueryResult<BookerByMainProductIdQuery, BookerByMainProductIdQueryVariables>;
export const BookerCartPriceDocument = gql`
    query BookerCartPrice($bookerId: ID!, $productPurchaseRequests: [ProductPurchaseRequest]!) {
  bookerCartPrice(
    bookerID: $bookerId
    productPurchaseRequests: $productPurchaseRequests
  ) {
    grandTotal
    productPrices {
      price
      productID
    }
    subTotal
    taxTotal
  }
}
    `;

/**
 * __useBookerCartPriceQuery__
 *
 * To run a query within a React component, call `useBookerCartPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerCartPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerCartPriceQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      productPurchaseRequests: // value for 'productPurchaseRequests'
 *   },
 * });
 */
export function useBookerCartPriceQuery(baseOptions: Apollo.QueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables> & ({ variables: BookerCartPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
      }
export function useBookerCartPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
        }
export function useBookerCartPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
        }
export type BookerCartPriceQueryHookResult = ReturnType<typeof useBookerCartPriceQuery>;
export type BookerCartPriceLazyQueryHookResult = ReturnType<typeof useBookerCartPriceLazyQuery>;
export type BookerCartPriceSuspenseQueryHookResult = ReturnType<typeof useBookerCartPriceSuspenseQuery>;
export type BookerCartPriceQueryResult = Apollo.QueryResult<BookerCartPriceQuery, BookerCartPriceQueryVariables>;
export const BookerSendContactUsEmailDocument = gql`
    query BookerSendContactUsEmail($operatorId: ID!, $productId: ID!, $details: ContactUsEmailDetails!) {
  bookerSendContactUsEmail(
    operatorID: $operatorId
    productID: $productId
    details: $details
  ) {
    message
    success
  }
}
    `;

/**
 * __useBookerSendContactUsEmailQuery__
 *
 * To run a query within a React component, call `useBookerSendContactUsEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerSendContactUsEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerSendContactUsEmailQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      productId: // value for 'productId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useBookerSendContactUsEmailQuery(baseOptions: Apollo.QueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables> & ({ variables: BookerSendContactUsEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
      }
export function useBookerSendContactUsEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
        }
export function useBookerSendContactUsEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
        }
export type BookerSendContactUsEmailQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailQuery>;
export type BookerSendContactUsEmailLazyQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailLazyQuery>;
export type BookerSendContactUsEmailSuspenseQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailSuspenseQuery>;
export type BookerSendContactUsEmailQueryResult = Apollo.QueryResult<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>;
export const GetAdminZoneEventDocument = gql`
    query GetAdminZoneEvent($id: ID!) {
  getAdminZoneEvent: getEvent(_id: $id) {
    ...AdminZoneEvent
  }
}
    ${AdminZoneEventFragmentDoc}`;

/**
 * __useGetAdminZoneEventQuery__
 *
 * To run a query within a React component, call `useGetAdminZoneEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminZoneEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminZoneEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminZoneEventQuery(baseOptions: Apollo.QueryHookOptions<GetAdminZoneEventQuery, GetAdminZoneEventQueryVariables> & ({ variables: GetAdminZoneEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminZoneEventQuery, GetAdminZoneEventQueryVariables>(GetAdminZoneEventDocument, options);
      }
export function useGetAdminZoneEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminZoneEventQuery, GetAdminZoneEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminZoneEventQuery, GetAdminZoneEventQueryVariables>(GetAdminZoneEventDocument, options);
        }
export function useGetAdminZoneEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminZoneEventQuery, GetAdminZoneEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminZoneEventQuery, GetAdminZoneEventQueryVariables>(GetAdminZoneEventDocument, options);
        }
export type GetAdminZoneEventQueryHookResult = ReturnType<typeof useGetAdminZoneEventQuery>;
export type GetAdminZoneEventLazyQueryHookResult = ReturnType<typeof useGetAdminZoneEventLazyQuery>;
export type GetAdminZoneEventSuspenseQueryHookResult = ReturnType<typeof useGetAdminZoneEventSuspenseQuery>;
export type GetAdminZoneEventQueryResult = Apollo.QueryResult<GetAdminZoneEventQuery, GetAdminZoneEventQueryVariables>;
export const GetCoursesByDocument = gql`
    query GetCoursesBy($input: CoursesByInput) {
  coursesBy(input: $input) {
    courseName
    slug
    packageType
    packageUrl
    typeformId
    pdfUrl
    description
    coverImage {
      full_url
      _id
    }
    tenantsOf
    _id
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useGetCoursesByQuery__
 *
 * To run a query within a React component, call `useGetCoursesByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCoursesByQuery(baseOptions?: Apollo.QueryHookOptions<GetCoursesByQuery, GetCoursesByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesByQuery, GetCoursesByQueryVariables>(GetCoursesByDocument, options);
      }
export function useGetCoursesByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesByQuery, GetCoursesByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesByQuery, GetCoursesByQueryVariables>(GetCoursesByDocument, options);
        }
export function useGetCoursesBySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesByQuery, GetCoursesByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesByQuery, GetCoursesByQueryVariables>(GetCoursesByDocument, options);
        }
export type GetCoursesByQueryHookResult = ReturnType<typeof useGetCoursesByQuery>;
export type GetCoursesByLazyQueryHookResult = ReturnType<typeof useGetCoursesByLazyQuery>;
export type GetCoursesBySuspenseQueryHookResult = ReturnType<typeof useGetCoursesBySuspenseQuery>;
export type GetCoursesByQueryResult = Apollo.QueryResult<GetCoursesByQuery, GetCoursesByQueryVariables>;
export const GetEventDetailsDocument = gql`
    query GetEventDetails($id: ID!) {
  getEvent(_id: $id) {
    _id
    name
    description {
      en
      fr
    }
    externalUrl
    short_description {
      en
      fr
    }
    pricing
    more_info_link
    tags
    customVtcTags
    status
    images {
      _id
      full_url
      teaser_url
      teaser_url_x2
      thumbnail_url
      thumbnail_url_x2
      caption {
        en
        fr
      }
      blurhash
    }
    createdAt
    updatedAt
    operatorId
    operator {
      operator_name
      address
      website
      email
      phone
      facebook_link
      instagram_link
      youtube_link
      pinterest_link
    }
    externalUrl
    occurrences {
      _id
      startDateTime
      endDateTime
      isActive
      note
      type
    }
    schedule {
      day
      endDateTime
      interval
      month
      occurrences
      repeat
      startDateTime
      type
      weekdays
      occurrenceEndDate
      timeSlots {
        endISO
        startISO
      }
    }
    submitStatus
  }
}
    `;

/**
 * __useGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEventDetailsQuery, GetEventDetailsQueryVariables> & ({ variables: GetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDetailsQuery, GetEventDetailsQueryVariables>(GetEventDetailsDocument, options);
      }
export function useGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDetailsQuery, GetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDetailsQuery, GetEventDetailsQueryVariables>(GetEventDetailsDocument, options);
        }
export function useGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventDetailsQuery, GetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventDetailsQuery, GetEventDetailsQueryVariables>(GetEventDetailsDocument, options);
        }
export type GetEventDetailsQueryHookResult = ReturnType<typeof useGetEventDetailsQuery>;
export type GetEventDetailsLazyQueryHookResult = ReturnType<typeof useGetEventDetailsLazyQuery>;
export type GetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEventDetailsSuspenseQuery>;
export type GetEventDetailsQueryResult = Apollo.QueryResult<GetEventDetailsQuery, GetEventDetailsQueryVariables>;
export const GetEventDetailsOptionsDocument = gql`
    query GetEventDetailsOptions {
  getEventDetailsOptions {
    customVtcTags {
      _id
      bundle
      label {
        en
      }
    }
  }
}
    `;

/**
 * __useGetEventDetailsOptionsQuery__
 *
 * To run a query within a React component, call `useGetEventDetailsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDetailsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDetailsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventDetailsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventDetailsOptionsQuery, GetEventDetailsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDetailsOptionsQuery, GetEventDetailsOptionsQueryVariables>(GetEventDetailsOptionsDocument, options);
      }
export function useGetEventDetailsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDetailsOptionsQuery, GetEventDetailsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDetailsOptionsQuery, GetEventDetailsOptionsQueryVariables>(GetEventDetailsOptionsDocument, options);
        }
export function useGetEventDetailsOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventDetailsOptionsQuery, GetEventDetailsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventDetailsOptionsQuery, GetEventDetailsOptionsQueryVariables>(GetEventDetailsOptionsDocument, options);
        }
export type GetEventDetailsOptionsQueryHookResult = ReturnType<typeof useGetEventDetailsOptionsQuery>;
export type GetEventDetailsOptionsLazyQueryHookResult = ReturnType<typeof useGetEventDetailsOptionsLazyQuery>;
export type GetEventDetailsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetEventDetailsOptionsSuspenseQuery>;
export type GetEventDetailsOptionsQueryResult = Apollo.QueryResult<GetEventDetailsOptionsQuery, GetEventDetailsOptionsQueryVariables>;
export const GetEventImagesDocument = gql`
    query GetEventImages($id: ID!) {
  getEvent(_id: $id) {
    _id
    images {
      _id
      full_url
      teaser_url
      teaser_url_x2
      thumbnail_url
      thumbnail_url_x2
      caption {
        en
        fr
      }
      blurhash
    }
  }
}
    `;

/**
 * __useGetEventImagesQuery__
 *
 * To run a query within a React component, call `useGetEventImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventImagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventImagesQuery(baseOptions: Apollo.QueryHookOptions<GetEventImagesQuery, GetEventImagesQueryVariables> & ({ variables: GetEventImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventImagesQuery, GetEventImagesQueryVariables>(GetEventImagesDocument, options);
      }
export function useGetEventImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventImagesQuery, GetEventImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventImagesQuery, GetEventImagesQueryVariables>(GetEventImagesDocument, options);
        }
export function useGetEventImagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventImagesQuery, GetEventImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventImagesQuery, GetEventImagesQueryVariables>(GetEventImagesDocument, options);
        }
export type GetEventImagesQueryHookResult = ReturnType<typeof useGetEventImagesQuery>;
export type GetEventImagesLazyQueryHookResult = ReturnType<typeof useGetEventImagesLazyQuery>;
export type GetEventImagesSuspenseQueryHookResult = ReturnType<typeof useGetEventImagesSuspenseQuery>;
export type GetEventImagesQueryResult = Apollo.QueryResult<GetEventImagesQuery, GetEventImagesQueryVariables>;
export const GetEventsDocument = gql`
    query getEvents($input: GetEventsInput) {
  getEvents(input: $input) {
    _id
    operator {
      operator_name
    }
    name
    images {
      full_url
    }
    status
    submitStatus
    schedule {
      startDateTime
      endDateTime
      occurrenceEndDate
    }
    occurrences {
      _id
      startDateTime
      endDateTime
      isActive
      note
      type
    }
    nextOccurrence {
      _id
      startDateTime
      endDateTime
      isActive
      note
      type
    }
  }
}
    `;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
      }
export function useGetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsSuspenseQueryHookResult = ReturnType<typeof useGetEventsSuspenseQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetEventsByDocument = gql`
    query GetEventsBy($input: GetEventsGroupByPeriodInput) {
  getEventsGroupByPeriod(input: $input) {
    count
    periods {
      year
      month
      week
      events {
        _id
        operator {
          operator_name
        }
        name
        images {
          full_url
        }
        status
        submitStatus
        schedule {
          startDateTime
          endDateTime
          occurrenceEndDate
        }
        occurrences {
          _id
          startDateTime
          endDateTime
          isActive
          note
          type
        }
        nextOccurrence {
          _id
          startDateTime
          endDateTime
          isActive
          note
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventsByQuery__
 *
 * To run a query within a React component, call `useGetEventsByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEventsByQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsByQuery, GetEventsByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsByQuery, GetEventsByQueryVariables>(GetEventsByDocument, options);
      }
export function useGetEventsByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsByQuery, GetEventsByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsByQuery, GetEventsByQueryVariables>(GetEventsByDocument, options);
        }
export function useGetEventsBySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsByQuery, GetEventsByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsByQuery, GetEventsByQueryVariables>(GetEventsByDocument, options);
        }
export type GetEventsByQueryHookResult = ReturnType<typeof useGetEventsByQuery>;
export type GetEventsByLazyQueryHookResult = ReturnType<typeof useGetEventsByLazyQuery>;
export type GetEventsBySuspenseQueryHookResult = ReturnType<typeof useGetEventsBySuspenseQuery>;
export type GetEventsByQueryResult = Apollo.QueryResult<GetEventsByQuery, GetEventsByQueryVariables>;
export const GetEventsFilteredByStatusDocument = gql`
    query GetEventsFilteredByStatus($tenantOf: [String]) {
  draft: getEvents(input: {filterBy: {status: "Draft", tenantOf: $tenantOf}}) {
    _id
    name
    status
    images {
      full_url
      thumbnail_url
      caption {
        en
        fr
      }
    }
    operatorId
    operator {
      operator_name
    }
    createdAt
    updatedAt
    schedule {
      startDateTime
      endDateTime
      timeSlots {
        startISO
        endISO
      }
    }
  }
  upcoming: getEvents(
    input: {filterBy: {status: "Upcoming", tenantOf: $tenantOf}}
  ) {
    _id
    name
    status
    images {
      full_url
      thumbnail_url
      caption {
        en
        fr
      }
    }
    operatorId
    operator {
      operator_name
    }
    createdAt
    updatedAt
    schedule {
      startDateTime
      endDateTime
      timeSlots {
        startISO
        endISO
      }
    }
  }
  past: getEvents(input: {filterBy: {status: "Past", tenantOf: $tenantOf}}) {
    _id
    name
    status
    images {
      full_url
      thumbnail_url
      caption {
        en
        fr
      }
    }
    operatorId
    operator {
      operator_name
    }
    createdAt
    updatedAt
    schedule {
      startDateTime
      endDateTime
      timeSlots {
        startISO
        endISO
      }
    }
  }
  cancelled: getEvents(
    input: {filterBy: {status: "Cancelled", tenantOf: $tenantOf}}
  ) {
    _id
    name
    status
    images {
      full_url
      thumbnail_url
      caption {
        en
        fr
      }
    }
    operatorId
    operator {
      operator_name
    }
    createdAt
    updatedAt
    schedule {
      startDateTime
      endDateTime
      timeSlots {
        startISO
        endISO
      }
    }
  }
}
    `;

/**
 * __useGetEventsFilteredByStatusQuery__
 *
 * To run a query within a React component, call `useGetEventsFilteredByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsFilteredByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsFilteredByStatusQuery({
 *   variables: {
 *      tenantOf: // value for 'tenantOf'
 *   },
 * });
 */
export function useGetEventsFilteredByStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsFilteredByStatusQuery, GetEventsFilteredByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsFilteredByStatusQuery, GetEventsFilteredByStatusQueryVariables>(GetEventsFilteredByStatusDocument, options);
      }
export function useGetEventsFilteredByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsFilteredByStatusQuery, GetEventsFilteredByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsFilteredByStatusQuery, GetEventsFilteredByStatusQueryVariables>(GetEventsFilteredByStatusDocument, options);
        }
export function useGetEventsFilteredByStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsFilteredByStatusQuery, GetEventsFilteredByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsFilteredByStatusQuery, GetEventsFilteredByStatusQueryVariables>(GetEventsFilteredByStatusDocument, options);
        }
export type GetEventsFilteredByStatusQueryHookResult = ReturnType<typeof useGetEventsFilteredByStatusQuery>;
export type GetEventsFilteredByStatusLazyQueryHookResult = ReturnType<typeof useGetEventsFilteredByStatusLazyQuery>;
export type GetEventsFilteredByStatusSuspenseQueryHookResult = ReturnType<typeof useGetEventsFilteredByStatusSuspenseQuery>;
export type GetEventsFilteredByStatusQueryResult = Apollo.QueryResult<GetEventsFilteredByStatusQuery, GetEventsFilteredByStatusQueryVariables>;
export const GetFormResponsesDocument = gql`
    query getFormResponses($id: String, $type: String, $linkedId: String) {
  getFormResponses(_id: $id, type: $type, linkedID: $linkedId) {
    data {
      _id
      name
      linkedID
      requestBody
      type
    }
  }
}
    `;

/**
 * __useGetFormResponsesQuery__
 *
 * To run a query within a React component, call `useGetFormResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponsesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      linkedId: // value for 'linkedId'
 *   },
 * });
 */
export function useGetFormResponsesQuery(baseOptions?: Apollo.QueryHookOptions<GetFormResponsesQuery, GetFormResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormResponsesQuery, GetFormResponsesQueryVariables>(GetFormResponsesDocument, options);
      }
export function useGetFormResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormResponsesQuery, GetFormResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormResponsesQuery, GetFormResponsesQueryVariables>(GetFormResponsesDocument, options);
        }
export function useGetFormResponsesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormResponsesQuery, GetFormResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormResponsesQuery, GetFormResponsesQueryVariables>(GetFormResponsesDocument, options);
        }
export type GetFormResponsesQueryHookResult = ReturnType<typeof useGetFormResponsesQuery>;
export type GetFormResponsesLazyQueryHookResult = ReturnType<typeof useGetFormResponsesLazyQuery>;
export type GetFormResponsesSuspenseQueryHookResult = ReturnType<typeof useGetFormResponsesSuspenseQuery>;
export type GetFormResponsesQueryResult = Apollo.QueryResult<GetFormResponsesQuery, GetFormResponsesQueryVariables>;
export const GetLearnerActivityLogManyDocument = gql`
    query GetLearnerActivityLogMany($filter: FilterFindManyLearnerActivityLogInput, $perPage: Int, $page: Int, $sort: SortFindManyLearnerActivityLogInput) {
  learnerActivityLogMany(
    filter: $filter
    perPage: $perPage
    page: $page
    sort: $sort
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      eventType
      personName
      personId
      operatorName
      operatorId
      courseName
      courseId
      _id
      createdDateISO
      updatedDateISO
    }
  }
}
    `;

/**
 * __useGetLearnerActivityLogManyQuery__
 *
 * To run a query within a React component, call `useGetLearnerActivityLogManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnerActivityLogManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnerActivityLogManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLearnerActivityLogManyQuery(baseOptions?: Apollo.QueryHookOptions<GetLearnerActivityLogManyQuery, GetLearnerActivityLogManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearnerActivityLogManyQuery, GetLearnerActivityLogManyQueryVariables>(GetLearnerActivityLogManyDocument, options);
      }
export function useGetLearnerActivityLogManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearnerActivityLogManyQuery, GetLearnerActivityLogManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearnerActivityLogManyQuery, GetLearnerActivityLogManyQueryVariables>(GetLearnerActivityLogManyDocument, options);
        }
export function useGetLearnerActivityLogManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearnerActivityLogManyQuery, GetLearnerActivityLogManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearnerActivityLogManyQuery, GetLearnerActivityLogManyQueryVariables>(GetLearnerActivityLogManyDocument, options);
        }
export type GetLearnerActivityLogManyQueryHookResult = ReturnType<typeof useGetLearnerActivityLogManyQuery>;
export type GetLearnerActivityLogManyLazyQueryHookResult = ReturnType<typeof useGetLearnerActivityLogManyLazyQuery>;
export type GetLearnerActivityLogManySuspenseQueryHookResult = ReturnType<typeof useGetLearnerActivityLogManySuspenseQuery>;
export type GetLearnerActivityLogManyQueryResult = Apollo.QueryResult<GetLearnerActivityLogManyQuery, GetLearnerActivityLogManyQueryVariables>;
export const GetOperatorDocument = gql`
    query GetOperator($_id: ID!) {
  getOperator(_id: $_id) {
    _id
    updated_at
    website
    line_1
    line_2
    latitude
    longitude
    address
    city
    email
    tenants
    people
    connections
    images {
      _id
      full_url
      teaser_url
      teaser_url_x2
      thumbnail_url
      thumbnail_url_x2
      caption {
        en
        fr
      }
      blurhash
    }
    operator_name
    postal_code
    province
    description {
      en
      fr
    }
    short_description {
      en
      fr
    }
    more_info_link
    phone
    termsConditions
    tags {
      type_of_operator
      capacity
      region
      pricing
      amenities
      vtc_custom
      accreditations
    }
    facebook_link
    instagram_link
    youtube_link
    pinterest_link
    google_mybusiness_link
    tiktok_link
    tripadvisor_link
    hours_of_operation_week {
      sun {
        from
        to
        isActive
      }
      mon {
        from
        to
        isActive
      }
      tue {
        from
        to
        isActive
      }
      wed {
        from
        to
        isActive
      }
      thu {
        from
        to
        isActive
      }
      fri {
        from
        to
        isActive
      }
      sat {
        from
        to
        isActive
      }
    }
    up_to_date_source
    open_hours_option
    checklist {
      verifyAllLinks
      tagYourBusiness
      verifyLocation
      verifyOpeningHours
      uploadNewHighResPhotos
      isYourBusinessDescriptionAccurateAndCompelling
    }
    publishingOptions
    markAsNeedsAttention
    seasonality {
      high {
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
      }
      low {
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
      }
      closed {
        jan
        feb
        mar
        apr
        may
        jun
        jul
        aug
        sep
        oct
        nov
        dec
      }
    }
    sta_license_status
    status
    note {
      text
      by
      date
      is_public
    }
  }
}
    `;

/**
 * __useGetOperatorQuery__
 *
 * To run a query within a React component, call `useGetOperatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatorQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useGetOperatorQuery(baseOptions: Apollo.QueryHookOptions<GetOperatorQuery, GetOperatorQueryVariables> & ({ variables: GetOperatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperatorQuery, GetOperatorQueryVariables>(GetOperatorDocument, options);
      }
export function useGetOperatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperatorQuery, GetOperatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperatorQuery, GetOperatorQueryVariables>(GetOperatorDocument, options);
        }
export function useGetOperatorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperatorQuery, GetOperatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperatorQuery, GetOperatorQueryVariables>(GetOperatorDocument, options);
        }
export type GetOperatorQueryHookResult = ReturnType<typeof useGetOperatorQuery>;
export type GetOperatorLazyQueryHookResult = ReturnType<typeof useGetOperatorLazyQuery>;
export type GetOperatorSuspenseQueryHookResult = ReturnType<typeof useGetOperatorSuspenseQuery>;
export type GetOperatorQueryResult = Apollo.QueryResult<GetOperatorQuery, GetOperatorQueryVariables>;
export const GetOperatorsDocument = gql`
    query GetOperators($status: String, $limit: Int, $offset: Int, $sort: String, $tenants: String, $operator_name: String, $tags: [String]) {
  getOperators(
    status: $status
    limit: $limit
    offset: $offset
    sort: $sort
    tenants: $tenants
    operator_name: $operator_name
    tags: $tags
  ) {
    total
    data {
      _id
      operator_name
      status
      website
      updated_at
    }
  }
}
    `;

/**
 * __useGetOperatorsQuery__
 *
 * To run a query within a React component, call `useGetOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatorsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      tenants: // value for 'tenants'
 *      operator_name: // value for 'operator_name'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGetOperatorsQuery(baseOptions?: Apollo.QueryHookOptions<GetOperatorsQuery, GetOperatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperatorsQuery, GetOperatorsQueryVariables>(GetOperatorsDocument, options);
      }
export function useGetOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperatorsQuery, GetOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperatorsQuery, GetOperatorsQueryVariables>(GetOperatorsDocument, options);
        }
export function useGetOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperatorsQuery, GetOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperatorsQuery, GetOperatorsQueryVariables>(GetOperatorsDocument, options);
        }
export type GetOperatorsQueryHookResult = ReturnType<typeof useGetOperatorsQuery>;
export type GetOperatorsLazyQueryHookResult = ReturnType<typeof useGetOperatorsLazyQuery>;
export type GetOperatorsSuspenseQueryHookResult = ReturnType<typeof useGetOperatorsSuspenseQuery>;
export type GetOperatorsQueryResult = Apollo.QueryResult<GetOperatorsQuery, GetOperatorsQueryVariables>;
export const GetPersonByIdDocument = gql`
    query getPersonById($id: MongoID!) {
  personById(_id: $id) {
    firstName
    lastName
    accountStatus
    email
    operator {
      _id
      operator_name
    }
    address {
      line1
      line2
      city
      subdivision
      postalCode
      country
      location {
        type
        coordinates
      }
    }
    auth0Id
    enrolledThrough
    learner {
      stats {
        startDate
        totalCoursesCompleted
        totalCoursesStarted
      }
      courses {
        courseId
        courseName
        startDate
        lastAccessDate
        completedDate
        status
        suspendData
        location
      }
    }
    _id
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useGetPersonByIdQuery__
 *
 * To run a query within a React component, call `useGetPersonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPersonByIdQuery, GetPersonByIdQueryVariables> & ({ variables: GetPersonByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonByIdQuery, GetPersonByIdQueryVariables>(GetPersonByIdDocument, options);
      }
export function useGetPersonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonByIdQuery, GetPersonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonByIdQuery, GetPersonByIdQueryVariables>(GetPersonByIdDocument, options);
        }
export function useGetPersonByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPersonByIdQuery, GetPersonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonByIdQuery, GetPersonByIdQueryVariables>(GetPersonByIdDocument, options);
        }
export type GetPersonByIdQueryHookResult = ReturnType<typeof useGetPersonByIdQuery>;
export type GetPersonByIdLazyQueryHookResult = ReturnType<typeof useGetPersonByIdLazyQuery>;
export type GetPersonByIdSuspenseQueryHookResult = ReturnType<typeof useGetPersonByIdSuspenseQuery>;
export type GetPersonByIdQueryResult = Apollo.QueryResult<GetPersonByIdQuery, GetPersonByIdQueryVariables>;
export const GetUserStatusByEmailDocument = gql`
    query getUserStatusByEmail($email: String) {
  getUserStatus(email: $email) {
    account
    claimed
    email
  }
}
    `;

/**
 * __useGetUserStatusByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserStatusByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStatusByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStatusByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserStatusByEmailQuery(baseOptions?: Apollo.QueryHookOptions<GetUserStatusByEmailQuery, GetUserStatusByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserStatusByEmailQuery, GetUserStatusByEmailQueryVariables>(GetUserStatusByEmailDocument, options);
      }
export function useGetUserStatusByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserStatusByEmailQuery, GetUserStatusByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserStatusByEmailQuery, GetUserStatusByEmailQueryVariables>(GetUserStatusByEmailDocument, options);
        }
export function useGetUserStatusByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserStatusByEmailQuery, GetUserStatusByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserStatusByEmailQuery, GetUserStatusByEmailQueryVariables>(GetUserStatusByEmailDocument, options);
        }
export type GetUserStatusByEmailQueryHookResult = ReturnType<typeof useGetUserStatusByEmailQuery>;
export type GetUserStatusByEmailLazyQueryHookResult = ReturnType<typeof useGetUserStatusByEmailLazyQuery>;
export type GetUserStatusByEmailSuspenseQueryHookResult = ReturnType<typeof useGetUserStatusByEmailSuspenseQuery>;
export type GetUserStatusByEmailQueryResult = Apollo.QueryResult<GetUserStatusByEmailQuery, GetUserStatusByEmailQueryVariables>;
export const InventoryByProductBookedDatesDocument = gql`
    query InventoryByProductBookedDates($productId: ID!) {
  inventoryDatesByProduct(productID: $productId) {
    bookedDatesISO
    checkOutOnlyDatesISO
  }
}
    `;

/**
 * __useInventoryByProductBookedDatesQuery__
 *
 * To run a query within a React component, call `useInventoryByProductBookedDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryByProductBookedDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryByProductBookedDatesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useInventoryByProductBookedDatesQuery(baseOptions: Apollo.QueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables> & ({ variables: InventoryByProductBookedDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
      }
export function useInventoryByProductBookedDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
        }
export function useInventoryByProductBookedDatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
        }
export type InventoryByProductBookedDatesQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesQuery>;
export type InventoryByProductBookedDatesLazyQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesLazyQuery>;
export type InventoryByProductBookedDatesSuspenseQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesSuspenseQuery>;
export type InventoryByProductBookedDatesQueryResult = Apollo.QueryResult<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>;
export const MemberCountDocument = gql`
    query MemberCount($filter: FilterCountMemberInput) {
  memberCount(filter: $filter)
}
    `;

/**
 * __useMemberCountQuery__
 *
 * To run a query within a React component, call `useMemberCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMemberCountQuery(baseOptions?: Apollo.QueryHookOptions<MemberCountQuery, MemberCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberCountQuery, MemberCountQueryVariables>(MemberCountDocument, options);
      }
export function useMemberCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberCountQuery, MemberCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberCountQuery, MemberCountQueryVariables>(MemberCountDocument, options);
        }
export function useMemberCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberCountQuery, MemberCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberCountQuery, MemberCountQueryVariables>(MemberCountDocument, options);
        }
export type MemberCountQueryHookResult = ReturnType<typeof useMemberCountQuery>;
export type MemberCountLazyQueryHookResult = ReturnType<typeof useMemberCountLazyQuery>;
export type MemberCountSuspenseQueryHookResult = ReturnType<typeof useMemberCountSuspenseQuery>;
export type MemberCountQueryResult = Apollo.QueryResult<MemberCountQuery, MemberCountQueryVariables>;
export const MemberManyDocument = gql`
    query MemberMany($filter: FilterFindManyMemberInput, $sort: SortFindManyMemberInput, $skip: Int, $limit: Int) {
  memberMany(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    _id
    operator {
      website
      email
      images {
        full_url
      }
      status
      address
      operator_name
      _id
    }
    organization {
      tenantId
      name
      staff {
        _id
        firstName
        lastName
      }
      customTags {
        noteTags {
          _id
          name {
            en
            fr
          }
        }
      }
    }
    owner {
      email
      _id
      firstName
      lastName
    }
    staff {
      email
      firstName
      lastName
      _id
    }
  }
}
    `;

/**
 * __useMemberManyQuery__
 *
 * To run a query within a React component, call `useMemberManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMemberManyQuery(baseOptions?: Apollo.QueryHookOptions<MemberManyQuery, MemberManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberManyQuery, MemberManyQueryVariables>(MemberManyDocument, options);
      }
export function useMemberManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberManyQuery, MemberManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberManyQuery, MemberManyQueryVariables>(MemberManyDocument, options);
        }
export function useMemberManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberManyQuery, MemberManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberManyQuery, MemberManyQueryVariables>(MemberManyDocument, options);
        }
export type MemberManyQueryHookResult = ReturnType<typeof useMemberManyQuery>;
export type MemberManyLazyQueryHookResult = ReturnType<typeof useMemberManyLazyQuery>;
export type MemberManySuspenseQueryHookResult = ReturnType<typeof useMemberManySuspenseQuery>;
export type MemberManyQueryResult = Apollo.QueryResult<MemberManyQuery, MemberManyQueryVariables>;
export const MembersGroupByOwnerDocument = gql`
    query MembersGroupByOwner($filter: FilterMembersGroupByOwnerInput, $limit: Int, $skip: Int) {
  membersGroupByOwner(filter: $filter, limit: $limit, skip: $skip) {
    count
    groups {
      uuid
      members {
        _id
        operator {
          email
          website
          images {
            full_url
          }
          status
          address
          operator_name
          _id
        }
        organization {
          tenantId
          name
          staff {
            _id
            firstName
            lastName
          }
          customTags {
            noteTags {
              _id
              name {
                en
                fr
              }
            }
          }
        }
        owner {
          email
          _id
          firstName
          lastName
        }
        staff {
          email
          firstName
          lastName
          _id
        }
      }
    }
  }
}
    `;

/**
 * __useMembersGroupByOwnerQuery__
 *
 * To run a query within a React component, call `useMembersGroupByOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersGroupByOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersGroupByOwnerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useMembersGroupByOwnerQuery(baseOptions?: Apollo.QueryHookOptions<MembersGroupByOwnerQuery, MembersGroupByOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembersGroupByOwnerQuery, MembersGroupByOwnerQueryVariables>(MembersGroupByOwnerDocument, options);
      }
export function useMembersGroupByOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembersGroupByOwnerQuery, MembersGroupByOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembersGroupByOwnerQuery, MembersGroupByOwnerQueryVariables>(MembersGroupByOwnerDocument, options);
        }
export function useMembersGroupByOwnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembersGroupByOwnerQuery, MembersGroupByOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembersGroupByOwnerQuery, MembersGroupByOwnerQueryVariables>(MembersGroupByOwnerDocument, options);
        }
export type MembersGroupByOwnerQueryHookResult = ReturnType<typeof useMembersGroupByOwnerQuery>;
export type MembersGroupByOwnerLazyQueryHookResult = ReturnType<typeof useMembersGroupByOwnerLazyQuery>;
export type MembersGroupByOwnerSuspenseQueryHookResult = ReturnType<typeof useMembersGroupByOwnerSuspenseQuery>;
export type MembersGroupByOwnerQueryResult = Apollo.QueryResult<MembersGroupByOwnerQuery, MembersGroupByOwnerQueryVariables>;
export const OperatorByIdDocument = gql`
    query OperatorById($id: MongoID!) {
  operatorById(_id: $id) {
    _id
    contact {
      address {
        city
        country
        line1
        line2
        location {
          coordinates
          type
        }
        postalCode
        subdivision
      }
      email
      phone
    }
    description {
      en
      es
      fr
    }
    name
    bookerOptions {
      cancellationPolicy
      termsConditions
      payment {
        connectedAccountId
        taxPercentage
        applicationPercentage
      }
    }
  }
}
    `;

/**
 * __useOperatorByIdQuery__
 *
 * To run a query within a React component, call `useOperatorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOperatorByIdQuery(baseOptions: Apollo.QueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables> & ({ variables: OperatorByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
      }
export function useOperatorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
        }
export function useOperatorByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
        }
export type OperatorByIdQueryHookResult = ReturnType<typeof useOperatorByIdQuery>;
export type OperatorByIdLazyQueryHookResult = ReturnType<typeof useOperatorByIdLazyQuery>;
export type OperatorByIdSuspenseQueryHookResult = ReturnType<typeof useOperatorByIdSuspenseQuery>;
export type OperatorByIdQueryResult = Apollo.QueryResult<OperatorByIdQuery, OperatorByIdQueryVariables>;
export const OperatorManyDocument = gql`
    query OperatorMany($filter: FilterFindManyNewOperatorInput) {
  operatorMany(filter: $filter) {
    _id
    name
    images {
      _id
      caption {
        en
        es
        fr
      }
      full_url
      thumbnail_url
    }
  }
}
    `;

/**
 * __useOperatorManyQuery__
 *
 * To run a query within a React component, call `useOperatorManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOperatorManyQuery(baseOptions?: Apollo.QueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
      }
export function useOperatorManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
        }
export function useOperatorManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
        }
export type OperatorManyQueryHookResult = ReturnType<typeof useOperatorManyQuery>;
export type OperatorManyLazyQueryHookResult = ReturnType<typeof useOperatorManyLazyQuery>;
export type OperatorManySuspenseQueryHookResult = ReturnType<typeof useOperatorManySuspenseQuery>;
export type OperatorManyQueryResult = Apollo.QueryResult<OperatorManyQuery, OperatorManyQueryVariables>;
export const OperatorStripeAccountStatusDocument = gql`
    query OperatorStripeAccountStatus($operatorId: ID!) {
  operatorStripeAccountStatus(id: $operatorId) {
    id
    name
    status
  }
}
    `;

/**
 * __useOperatorStripeAccountStatusQuery__
 *
 * To run a query within a React component, call `useOperatorStripeAccountStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorStripeAccountStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorStripeAccountStatusQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorStripeAccountStatusQuery(baseOptions: Apollo.QueryHookOptions<OperatorStripeAccountStatusQuery, OperatorStripeAccountStatusQueryVariables> & ({ variables: OperatorStripeAccountStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorStripeAccountStatusQuery, OperatorStripeAccountStatusQueryVariables>(OperatorStripeAccountStatusDocument, options);
      }
export function useOperatorStripeAccountStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorStripeAccountStatusQuery, OperatorStripeAccountStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorStripeAccountStatusQuery, OperatorStripeAccountStatusQueryVariables>(OperatorStripeAccountStatusDocument, options);
        }
export function useOperatorStripeAccountStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorStripeAccountStatusQuery, OperatorStripeAccountStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorStripeAccountStatusQuery, OperatorStripeAccountStatusQueryVariables>(OperatorStripeAccountStatusDocument, options);
        }
export type OperatorStripeAccountStatusQueryHookResult = ReturnType<typeof useOperatorStripeAccountStatusQuery>;
export type OperatorStripeAccountStatusLazyQueryHookResult = ReturnType<typeof useOperatorStripeAccountStatusLazyQuery>;
export type OperatorStripeAccountStatusSuspenseQueryHookResult = ReturnType<typeof useOperatorStripeAccountStatusSuspenseQuery>;
export type OperatorStripeAccountStatusQueryResult = Apollo.QueryResult<OperatorStripeAccountStatusQuery, OperatorStripeAccountStatusQueryVariables>;
export const OperatorTotalSalesDocument = gql`
    query OperatorTotalSales($id: ID!) {
  operatorTotalSales(id: $id)
}
    `;

/**
 * __useOperatorTotalSalesQuery__
 *
 * To run a query within a React component, call `useOperatorTotalSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorTotalSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorTotalSalesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOperatorTotalSalesQuery(baseOptions: Apollo.QueryHookOptions<OperatorTotalSalesQuery, OperatorTotalSalesQueryVariables> & ({ variables: OperatorTotalSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorTotalSalesQuery, OperatorTotalSalesQueryVariables>(OperatorTotalSalesDocument, options);
      }
export function useOperatorTotalSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorTotalSalesQuery, OperatorTotalSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorTotalSalesQuery, OperatorTotalSalesQueryVariables>(OperatorTotalSalesDocument, options);
        }
export function useOperatorTotalSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorTotalSalesQuery, OperatorTotalSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorTotalSalesQuery, OperatorTotalSalesQueryVariables>(OperatorTotalSalesDocument, options);
        }
export type OperatorTotalSalesQueryHookResult = ReturnType<typeof useOperatorTotalSalesQuery>;
export type OperatorTotalSalesLazyQueryHookResult = ReturnType<typeof useOperatorTotalSalesLazyQuery>;
export type OperatorTotalSalesSuspenseQueryHookResult = ReturnType<typeof useOperatorTotalSalesSuspenseQuery>;
export type OperatorTotalSalesQueryResult = Apollo.QueryResult<OperatorTotalSalesQuery, OperatorTotalSalesQueryVariables>;
export const OrderByIdDocument = gql`
    query OrderById($id: String!) {
  orderById(_id: $id) {
    _id
    cancelled
    createdDateISO
    customerContact {
      phone
      name
      email
      guests {
        _id
        name
      }
    }
    source {
      bookerID
      operator
    }
    purchasedProducts {
      _id
      product {
        _id
        name {
          en
          es
          fr
        }
        description {
          en
          es
          fr
        }
        type
        pricing {
          tiers {
            _id
            label {
              en
              es
              fr
            }
            price
            type
          }
        }
        images {
          _id
          caption {
            en
            es
            fr
          }
          full_url
          thumbnail_url
        }
      }
      guestsPerTier {
        count
        tierId
      }
      inventoryClaims {
        _id
        claimedDateRangeISO {
          _id
          start
          end
        }
        inventoryID
      }
    }
  }
}
    `;

/**
 * __useOrderByIdQuery__
 *
 * To run a query within a React component, call `useOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables> & ({ variables: OrderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderByIdQuery, OrderByIdQueryVariables>(OrderByIdDocument, options);
      }
export function useOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderByIdQuery, OrderByIdQueryVariables>(OrderByIdDocument, options);
        }
export function useOrderByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderByIdQuery, OrderByIdQueryVariables>(OrderByIdDocument, options);
        }
export type OrderByIdQueryHookResult = ReturnType<typeof useOrderByIdQuery>;
export type OrderByIdLazyQueryHookResult = ReturnType<typeof useOrderByIdLazyQuery>;
export type OrderByIdSuspenseQueryHookResult = ReturnType<typeof useOrderByIdSuspenseQuery>;
export type OrderByIdQueryResult = Apollo.QueryResult<OrderByIdQuery, OrderByIdQueryVariables>;
export const OrderManyDocument = gql`
    query OrderMany($filter: FilterFindManyOrderInput, $perPage: Int, $page: Int, $sort: SortFindManyOrderInput) {
  orderMany(filter: $filter, perPage: $perPage, page: $page, sort: $sort) {
    count
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
      perPage
    }
    items {
      _id
      cancelled
      createdDateISO
      purchasedProducts {
        _id
        guestsPerTier {
          count
          tierId
        }
        inventoryClaims {
          _id
          claimedDateRangeISO {
            _id
            start
            end
          }
          inventoryID
        }
        product {
          _id
          name {
            en
            es
            fr
          }
          type
        }
      }
      customerContact {
        name
        email
      }
      stripeMetadata {
        invoiceID
      }
    }
  }
}
    `;

/**
 * __useOrderManyQuery__
 *
 * To run a query within a React component, call `useOrderManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrderManyQuery(baseOptions?: Apollo.QueryHookOptions<OrderManyQuery, OrderManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderManyQuery, OrderManyQueryVariables>(OrderManyDocument, options);
      }
export function useOrderManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderManyQuery, OrderManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderManyQuery, OrderManyQueryVariables>(OrderManyDocument, options);
        }
export function useOrderManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderManyQuery, OrderManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderManyQuery, OrderManyQueryVariables>(OrderManyDocument, options);
        }
export type OrderManyQueryHookResult = ReturnType<typeof useOrderManyQuery>;
export type OrderManyLazyQueryHookResult = ReturnType<typeof useOrderManyLazyQuery>;
export type OrderManySuspenseQueryHookResult = ReturnType<typeof useOrderManySuspenseQuery>;
export type OrderManyQueryResult = Apollo.QueryResult<OrderManyQuery, OrderManyQueryVariables>;
export const OrderPricesByIdDocument = gql`
    query OrderPricesById($orderId: ID!) {
  orderPricesById(orderID: $orderId) {
    grandTotal
    productPrices {
      price
      productID
    }
    subTotal
    taxTotal
  }
}
    `;

/**
 * __useOrderPricesByIdQuery__
 *
 * To run a query within a React component, call `useOrderPricesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPricesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPricesByIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderPricesByIdQuery(baseOptions: Apollo.QueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables> & ({ variables: OrderPricesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>(OrderPricesByIdDocument, options);
      }
export function useOrderPricesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>(OrderPricesByIdDocument, options);
        }
export function useOrderPricesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>(OrderPricesByIdDocument, options);
        }
export type OrderPricesByIdQueryHookResult = ReturnType<typeof useOrderPricesByIdQuery>;
export type OrderPricesByIdLazyQueryHookResult = ReturnType<typeof useOrderPricesByIdLazyQuery>;
export type OrderPricesByIdSuspenseQueryHookResult = ReturnType<typeof useOrderPricesByIdSuspenseQuery>;
export type OrderPricesByIdQueryResult = Apollo.QueryResult<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>;
export const OrderPricesByIdsDocument = gql`
    query OrderPricesByIds($orderIDs: [ID!]!) {
  orderPricesByIds(orderIDs: $orderIDs) {
    orderID
    prices {
      grandTotal
      taxTotal
      subTotal
      productPrices {
        price
        productID
      }
    }
  }
}
    `;

/**
 * __useOrderPricesByIdsQuery__
 *
 * To run a query within a React component, call `useOrderPricesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPricesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPricesByIdsQuery({
 *   variables: {
 *      orderIDs: // value for 'orderIDs'
 *   },
 * });
 */
export function useOrderPricesByIdsQuery(baseOptions: Apollo.QueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables> & ({ variables: OrderPricesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>(OrderPricesByIdsDocument, options);
      }
export function useOrderPricesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>(OrderPricesByIdsDocument, options);
        }
export function useOrderPricesByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>(OrderPricesByIdsDocument, options);
        }
export type OrderPricesByIdsQueryHookResult = ReturnType<typeof useOrderPricesByIdsQuery>;
export type OrderPricesByIdsLazyQueryHookResult = ReturnType<typeof useOrderPricesByIdsLazyQuery>;
export type OrderPricesByIdsSuspenseQueryHookResult = ReturnType<typeof useOrderPricesByIdsSuspenseQuery>;
export type OrderPricesByIdsQueryResult = Apollo.QueryResult<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>;
export const OrgFindOneDocument = gql`
    query OrgFindOne($filter: FilterFindOneNewOrgInput) {
  orgFindOne(filter: $filter) {
    _id
    customTags {
      memberTags {
        _id
        name {
          en
        }
      }
      noteTags {
        _id
        name {
          en
        }
      }
    }
    membershipSettings {
      customViews {
        _id
        label
        query
        searchField
        value
      }
      dues {
        active
        tiers {
          _id
          label
        }
      }
    }
  }
}
    `;

/**
 * __useOrgFindOneQuery__
 *
 * To run a query within a React component, call `useOrgFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgFindOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrgFindOneQuery(baseOptions?: Apollo.QueryHookOptions<OrgFindOneQuery, OrgFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgFindOneQuery, OrgFindOneQueryVariables>(OrgFindOneDocument, options);
      }
export function useOrgFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgFindOneQuery, OrgFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgFindOneQuery, OrgFindOneQueryVariables>(OrgFindOneDocument, options);
        }
export function useOrgFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgFindOneQuery, OrgFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgFindOneQuery, OrgFindOneQueryVariables>(OrgFindOneDocument, options);
        }
export type OrgFindOneQueryHookResult = ReturnType<typeof useOrgFindOneQuery>;
export type OrgFindOneLazyQueryHookResult = ReturnType<typeof useOrgFindOneLazyQuery>;
export type OrgFindOneSuspenseQueryHookResult = ReturnType<typeof useOrgFindOneSuspenseQuery>;
export type OrgFindOneQueryResult = Apollo.QueryResult<OrgFindOneQuery, OrgFindOneQueryVariables>;
export const GetPersonManyDocument = gql`
    query GetPersonMany($limit: Int, $filter: FilterFindManyPersonInput) {
  personMany(limit: $limit, filter: $filter) {
    firstName
    lastName
    accountStatus
    email
    auth0Id
    operator {
      operator_name
      _id
    }
    tenantsOf {
      tenantId
      role
      _id
    }
    learner {
      courses {
        courseId
        courseName
        startDate
        lastAccessDate
        completedDate
        status
        suspendData
      }
      stats {
        startDate
        totalCoursesCompleted
        totalCoursesStarted
      }
    }
    _id
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useGetPersonManyQuery__
 *
 * To run a query within a React component, call `useGetPersonManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonManyQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPersonManyQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonManyQuery, GetPersonManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonManyQuery, GetPersonManyQueryVariables>(GetPersonManyDocument, options);
      }
export function useGetPersonManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonManyQuery, GetPersonManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonManyQuery, GetPersonManyQueryVariables>(GetPersonManyDocument, options);
        }
export function useGetPersonManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPersonManyQuery, GetPersonManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonManyQuery, GetPersonManyQueryVariables>(GetPersonManyDocument, options);
        }
export type GetPersonManyQueryHookResult = ReturnType<typeof useGetPersonManyQuery>;
export type GetPersonManyLazyQueryHookResult = ReturnType<typeof useGetPersonManyLazyQuery>;
export type GetPersonManySuspenseQueryHookResult = ReturnType<typeof useGetPersonManySuspenseQuery>;
export type GetPersonManyQueryResult = Apollo.QueryResult<GetPersonManyQuery, GetPersonManyQueryVariables>;
export const ProductByIdDocument = gql`
    query ProductById($id: MongoID!) {
  productById(_id: $id) {
    _id
    externalBookingUrl
    description {
      en
      es
      fr
    }
    name {
      en
      es
      fr
    }
    images {
      _id
      caption {
        en
        es
        fr
      }
      full_url
      thumbnail_url
      blurhash
    }
    pricing {
      description {
        en
        es
        fr
      }
      tiers {
        _id
        price
        type
        label {
          en
          es
          fr
        }
      }
    }
    operator
    type
    shortDescription {
      en
      es
      fr
    }
    tags {
      _id
      name {
        en
        es
        fr
      }
    }
    taxRate {
      _id
      country
      percentage
      subdivision
    }
    accommodationMetadata {
      minimumNights
      maximumNights
      amenities {
        _id
        name {
          en
          es
          fr
        }
        type
      }
      closures {
        _id
        name
        dateRangeISO {
          start
          _id
          end
        }
      }
      guestMetadata {
        maximumNumber
        minimumNumber
        nameEntryAllowed
        nameEntryRequired
      }
      rooms {
        _id
        amenities
        type
      }
    }
  }
}
    `;

/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables> & ({ variables: ProductByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
      }
export function useProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
        }
export function useProductByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
        }
export type ProductByIdQueryHookResult = ReturnType<typeof useProductByIdQuery>;
export type ProductByIdLazyQueryHookResult = ReturnType<typeof useProductByIdLazyQuery>;
export type ProductByIdSuspenseQueryHookResult = ReturnType<typeof useProductByIdSuspenseQuery>;
export type ProductByIdQueryResult = Apollo.QueryResult<ProductByIdQuery, ProductByIdQueryVariables>;
export const ProductCalendarLinkByIdDocument = gql`
    query ProductCalendarLinkById($id: ID!) {
  productCalendarLinkById(id: $id)
}
    `;

/**
 * __useProductCalendarLinkByIdQuery__
 *
 * To run a query within a React component, call `useProductCalendarLinkByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCalendarLinkByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCalendarLinkByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductCalendarLinkByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables> & ({ variables: ProductCalendarLinkByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>(ProductCalendarLinkByIdDocument, options);
      }
export function useProductCalendarLinkByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>(ProductCalendarLinkByIdDocument, options);
        }
export function useProductCalendarLinkByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>(ProductCalendarLinkByIdDocument, options);
        }
export type ProductCalendarLinkByIdQueryHookResult = ReturnType<typeof useProductCalendarLinkByIdQuery>;
export type ProductCalendarLinkByIdLazyQueryHookResult = ReturnType<typeof useProductCalendarLinkByIdLazyQuery>;
export type ProductCalendarLinkByIdSuspenseQueryHookResult = ReturnType<typeof useProductCalendarLinkByIdSuspenseQuery>;
export type ProductCalendarLinkByIdQueryResult = Apollo.QueryResult<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>;
export const ProductClosureByIdDocument = gql`
    query ProductClosureById($closureId: ID!) {
  productClosureById(closureID: $closureId) {
    closure {
      _id
      dateRangeISO {
        _id
        end
        start
      }
      name
    }
    productIDs
  }
}
    `;

/**
 * __useProductClosureByIdQuery__
 *
 * To run a query within a React component, call `useProductClosureByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductClosureByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductClosureByIdQuery({
 *   variables: {
 *      closureId: // value for 'closureId'
 *   },
 * });
 */
export function useProductClosureByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables> & ({ variables: ProductClosureByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>(ProductClosureByIdDocument, options);
      }
export function useProductClosureByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>(ProductClosureByIdDocument, options);
        }
export function useProductClosureByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>(ProductClosureByIdDocument, options);
        }
export type ProductClosureByIdQueryHookResult = ReturnType<typeof useProductClosureByIdQuery>;
export type ProductClosureByIdLazyQueryHookResult = ReturnType<typeof useProductClosureByIdLazyQuery>;
export type ProductClosureByIdSuspenseQueryHookResult = ReturnType<typeof useProductClosureByIdSuspenseQuery>;
export type ProductClosureByIdQueryResult = Apollo.QueryResult<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>;
export const ProductTotalSalesDocument = gql`
    query productTotalSales($id: ID!) {
  productTotalSales(id: $id)
}
    `;

/**
 * __useProductTotalSalesQuery__
 *
 * To run a query within a React component, call `useProductTotalSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTotalSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTotalSalesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductTotalSalesQuery(baseOptions: Apollo.QueryHookOptions<ProductTotalSalesQuery, ProductTotalSalesQueryVariables> & ({ variables: ProductTotalSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTotalSalesQuery, ProductTotalSalesQueryVariables>(ProductTotalSalesDocument, options);
      }
export function useProductTotalSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTotalSalesQuery, ProductTotalSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTotalSalesQuery, ProductTotalSalesQueryVariables>(ProductTotalSalesDocument, options);
        }
export function useProductTotalSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductTotalSalesQuery, ProductTotalSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductTotalSalesQuery, ProductTotalSalesQueryVariables>(ProductTotalSalesDocument, options);
        }
export type ProductTotalSalesQueryHookResult = ReturnType<typeof useProductTotalSalesQuery>;
export type ProductTotalSalesLazyQueryHookResult = ReturnType<typeof useProductTotalSalesLazyQuery>;
export type ProductTotalSalesSuspenseQueryHookResult = ReturnType<typeof useProductTotalSalesSuspenseQuery>;
export type ProductTotalSalesQueryResult = Apollo.QueryResult<ProductTotalSalesQuery, ProductTotalSalesQueryVariables>;
export const ProductsByIdsDocument = gql`
    query ProductsByIds($ids: [MongoID!]!) {
  productsByIds(_ids: $ids) {
    _id
    externalBookingUrl
    description {
      en
      es
      fr
    }
    name {
      en
      es
      fr
    }
    images {
      _id
      caption {
        en
        es
        fr
      }
      full_url
      thumbnail_url
    }
    pricing {
      description {
        en
        es
        fr
      }
      tiers {
        _id
        price
        type
        label {
          en
          es
          fr
        }
      }
    }
    type
    shortDescription {
      en
      es
      fr
    }
    tags {
      _id
      name {
        en
        es
        fr
      }
    }
    taxRate {
      _id
      country
      percentage
      subdivision
    }
    accommodationMetadata {
      amenities {
        _id
        name {
          en
          es
          fr
        }
        type
      }
      closures {
        _id
        name
        dateRangeISO {
          start
          _id
          end
        }
      }
      guestMetadata {
        maximumNumber
        minimumNumber
        nameEntryAllowed
        nameEntryRequired
      }
      rooms {
        _id
        amenities
        type
      }
    }
  }
}
    `;

/**
 * __useProductsByIdsQuery__
 *
 * To run a query within a React component, call `useProductsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useProductsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ProductsByIdsQuery, ProductsByIdsQueryVariables> & ({ variables: ProductsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsByIdsQuery, ProductsByIdsQueryVariables>(ProductsByIdsDocument, options);
      }
export function useProductsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsByIdsQuery, ProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsByIdsQuery, ProductsByIdsQueryVariables>(ProductsByIdsDocument, options);
        }
export function useProductsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductsByIdsQuery, ProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsByIdsQuery, ProductsByIdsQueryVariables>(ProductsByIdsDocument, options);
        }
export type ProductsByIdsQueryHookResult = ReturnType<typeof useProductsByIdsQuery>;
export type ProductsByIdsLazyQueryHookResult = ReturnType<typeof useProductsByIdsLazyQuery>;
export type ProductsByIdsSuspenseQueryHookResult = ReturnType<typeof useProductsByIdsSuspenseQuery>;
export type ProductsByIdsQueryResult = Apollo.QueryResult<ProductsByIdsQuery, ProductsByIdsQueryVariables>;
export const RefundManyDocument = gql`
    query RefundMany($filter: FilterFindManyRefundInput) {
  refundMany(filter: $filter) {
    _id
    amount
    orderID
    status
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useRefundManyQuery__
 *
 * To run a query within a React component, call `useRefundManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRefundManyQuery(baseOptions?: Apollo.QueryHookOptions<RefundManyQuery, RefundManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundManyQuery, RefundManyQueryVariables>(RefundManyDocument, options);
      }
export function useRefundManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundManyQuery, RefundManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundManyQuery, RefundManyQueryVariables>(RefundManyDocument, options);
        }
export function useRefundManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RefundManyQuery, RefundManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RefundManyQuery, RefundManyQueryVariables>(RefundManyDocument, options);
        }
export type RefundManyQueryHookResult = ReturnType<typeof useRefundManyQuery>;
export type RefundManyLazyQueryHookResult = ReturnType<typeof useRefundManyLazyQuery>;
export type RefundManySuspenseQueryHookResult = ReturnType<typeof useRefundManySuspenseQuery>;
export type RefundManyQueryResult = Apollo.QueryResult<RefundManyQuery, RefundManyQueryVariables>;
export const RefundsByOrderIdsDocument = gql`
    query RefundsByOrderIds($orderIDs: [ID!]!) {
  refundsByOrderIds(orderIDs: $orderIDs) {
    _id
    amount
    createdDateISO
    orderID
    status
    updatedDateISO
  }
}
    `;

/**
 * __useRefundsByOrderIdsQuery__
 *
 * To run a query within a React component, call `useRefundsByOrderIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundsByOrderIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundsByOrderIdsQuery({
 *   variables: {
 *      orderIDs: // value for 'orderIDs'
 *   },
 * });
 */
export function useRefundsByOrderIdsQuery(baseOptions: Apollo.QueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables> & ({ variables: RefundsByOrderIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>(RefundsByOrderIdsDocument, options);
      }
export function useRefundsByOrderIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>(RefundsByOrderIdsDocument, options);
        }
export function useRefundsByOrderIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>(RefundsByOrderIdsDocument, options);
        }
export type RefundsByOrderIdsQueryHookResult = ReturnType<typeof useRefundsByOrderIdsQuery>;
export type RefundsByOrderIdsLazyQueryHookResult = ReturnType<typeof useRefundsByOrderIdsLazyQuery>;
export type RefundsByOrderIdsSuspenseQueryHookResult = ReturnType<typeof useRefundsByOrderIdsSuspenseQuery>;
export type RefundsByOrderIdsQueryResult = Apollo.QueryResult<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>;